import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MsalService } from '@azure/msal-angular';
import { of } from 'rxjs';
import { ChatbotService } from './../../common/services/chatbot.service';
import { InsightsModel, results } from 'src/app/common/models/common.model';
import { TableOuputComponent } from 'src/app/common/shared/table-ouput/table-ouput.component';
import { CrosstabService } from '../../common/services/crosstab.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { ExportDownloadServices } from 'src/app/common/services/exports-downloads.service';
import { SharedChatService } from 'src/app/common/services/shared-chat.service';
import { Subscription, switchMap, take, tap, firstValueFrom, from, catchError, throwError, forkJoin, map, Observable, shareReplay, finalize } from 'rxjs';
import {
  DataObject, checkboxSelection, checkboxSelectionWithParent, OutputDataObject,
  CrossTabOutputItem, StackChart, LineChart, GroupBarChart
} from 'src/app/common/models/crosstab.model';
import { Feature } from 'src/app/common/models/usermanagement.model';
import { InsightspopupService } from 'src/app/common/services/insightspopup.service';
import {
  fomData, StudyData, DiagnosticData, ChatListDocument, ChatHistoryDocument,
  ChatAnswerDocument, UserIdentityDocument, SaveChatResponseRequest
} from 'src/app/common/models/chatbotexpand.model';
import { UserProjectManagementService } from 'src/app/common/services/user-project-management.service';
import { COMMON_CONSTANTS } from 'src/app/common/constants/common-constants';
import * as _ from 'lodash';
import { CustomsnapshotService } from '../snapshot/Services/customsnapshot.service';
import { SnapshotService } from '../snapshot/Services/snapshot.service';
import { CommonChartmoduleService } from '../snapshot/Services/common-chartmodule.service';
import { ConfigurationService } from 'src/app/common/services/configuration.service';
import { FilesWithIdentifiers } from 'src/app/common/models/configurations.model';
import { exceptionMessage } from 'src/app/common/constants/common-constants';
import { IndexedDBService } from 'src/app/common/services/askme_indexeddb.service';
import { protectedResources } from 'src/app/auth.config';
import { DiagnosticViewerHelper } from './diagnostic-viewer/diagnostic-viewer.helper';
import { ExportHandlerHelper } from './helpers/export-handler/export-handler.helper';
import { InsightsGeneratorHelper } from 'src/app/modules/chatbotexpand/helpers/insights-generator/insights-generator.helper';
import { ChartUtilitiesHelper } from './helpers/chart-utilities/chart-utilities.helper';
import { SelectionSummaryHelper } from './helpers/selection-summary/selection-summary.helper';
import { ChatHistoryHelper } from './helpers/chat-history/chat-history.helper';
import { TableOutputProcessorHelper } from './helpers/table-output-processor/table-output-processor.helper';
import { MarkdownPayloadHelper } from './helpers/markdown-payload/markdown-payload.helper';
import { FormattersHelper } from './helpers/formatters/formatters.helper';
import { DataTransformersHelper } from './helpers/data-transformers/data-transformers.helper';

const BASE_TYPES = {
  TOTAL: 'Total Base',
  ANSWER: 'Answer Base'
} as const;

const DEFAULT_VALUES = {
  NONE: 'None',
  DATA: 'Data'
} as const;

const SNAPSHOT_TYPES = {
  SINGLE_BRAND: 'Single Brand'
} as const;

const CHART_TYPES = {
  COLUMN: 'column',
  BAR: 'bar'
} as const;

const CALCULATION_TYPES = {
  RESP_GRP: 'RespGrp',
  MEAN: 'mean'
} as const;

interface Config {
  key: string;
  value: boolean;
}

interface VariableList {
  Level0: string;
  isEntryPoint: boolean;
  hasOnlyBrandIndependentChildren: boolean;
  hasOnlyBrandDependentChildren: boolean;
  hasSomeBrandDependentChildrenNotAll: boolean;
  Level1: {
    Level1_value: string;
    is_derived: string;
    is_brand_analysis: number;
    calc_type: string;
    tooltip: string;
    hasNextLevel: boolean;
    data_variable_code: string;
    response_code: string;
    sort_id: string;
    is_multi_punch: string;
    date: string;
    year_code: string;
    is_dimension: string;
    isCustomGrpPresent: string;
    isCustomCalcPresent: string;
    kibanaFilterScript: string;
    customGroupId: string;
    customCalculationId: string;
    dataYearCode: string;
    is_time_Period_Present: string;
  }[];
}

interface ListItem {
  Level0: string;
  Level1: string;
  tooltip: string;
  has_nextLevel: boolean;
  sortId: number;
  is_Derived: string;
  is_calc_type: string;
  data_variable_code: string;
  data_response_code: string;
  data_sort_id: string;
  data_is_multi_punch: string;
  data_date: string;
  data_year_code: string;
  is_dimension: boolean;
  is_custmGrpPresent: boolean;
  is_custmCalcPresent: boolean;
  kibanaFilterScript: string;
  customGroupId: string;
  customCalculationId: string;
  dataYearCode: string;
  isSelectAllMetrics: boolean;
  isSelectAllMetricsCount: number;
  is_entrypoint?: boolean;
}

@Component({
  selector: 'app-chatbotexpand',
  templateUrl: './chatbotexpand.component.html',
  styleUrls: ['./chatbotexpand.component.css'],
})
export class ChatbotexpandComponent implements OnInit, AfterViewInit, OnDestroy {

  // @ViewChild & @ViewChildren DECORATORS
  @ViewChild('summaryText') summaryText: ElementRef | undefined;
  @ViewChild('tableOutputComponent') tableOutputComponent!: TableOuputComponent;

  hasSnapshotActive: boolean = false;
  hasBrandAnalysisActive: boolean = false;
  hasCrosstabActive: boolean = false;
  @ViewChild('SidePanel') SidePanel: ElementRef | undefined;
  @ViewChild('inforRibbon', { static: false }) inforRibbon: ElementRef | undefined;
  @ViewChild('chatHistoryScroll') chatHistoryScroll: ElementRef | undefined;
  @ViewChild('insightsContainer') insightsContainer: ElementRef | undefined;
  @ViewChild('exportsPopup', { static: false }) exportsPopupRef: ElementRef | undefined;

  // @Input DECORATORS
  errorHeader: string = '';
  @Input() exportDownloads: boolean = true;
  @Input() pptExport: boolean = true;
  @Input() isIndex: boolean = false;
  @Input() landingdata: any;

  // PRIVATE PROPERTIES
  private tooltipStates = { stack: false, line: false, bar: false };
  private subscriptions: Subscription = new Subscription();


  // FORM & SEARCH PROPERTIES
  searchForm!: FormGroup;
  searchText: string = '';
  searchTextLevel1: string = '';
  searchQuery: string = '';
  inputValue: any = '';
  existingquery: any = '';
  questionBrowserSearchText: string = '';
  chatSearchText: string = '';
  chatNestedSearchText: string = '';
  isNestedSearchVisible: boolean = false;
  primaryFilteredCount: number = 0;
  starredSearchText: string = '';

  // USER & SESSION MANAGEMENT
  userId: string = '';
  guidChatId: string = '';
  validatedSessionId: string | null = null;
  selectedChatId: string | null = null;
  selectedMessageId: string | null = null;
  newChatId: any;
  isNewChatStarted: boolean = false;
  abandoningSessionId: string = '';

  // STUDY & CLIENT CONFIGURATION
  selected_study: any;
  selected_client: any;
  studyname: string = '';
  clientcode: any;
  receivedData: StudyData[] = [];
  filteredlist: StudyData | undefined;
  filteredStudies: string[] = [];
  logo_url: string = '';
  isDemoStudy: boolean = false;
  arktabaccess: boolean = false;
  modulesAccess: any = null;
  isCacheGenerated: boolean = false;
  streamStatusText: string = '';
  isStreamFinished: boolean = false;
  private statusQueue: string[] = [];
  private isProcessingStatusQueue: boolean = false;
  chatPayload: any = null;
  parallelChatPayload: any = null;
  private currentOrchToken: string = '';

  // CHAT & CONVERSATION PROPERTIES
  currentView: 'landing' | 'chat' | 'loading' = 'loading';
  isChatHistoryOpen: boolean = false;
  isSavedQuestionsOpen: boolean = false;
  isChatAreaVisible: boolean = true;
  private currentTrendlineResponse: any = null;
  private currentRowPayloadTrendline: any = null;
  private currentCustomizationTrendline: any = null;
  isTrendAvailable: boolean = false;
  isTrendActive: boolean = false;

  setTrendAvailable(event: boolean) {
    setTimeout(() => {
      this.isTrendAvailable = event;
      this.cdr.markForCheck();
    });
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', this.onDocumentClick, true);
  }

  private onDocumentClick = (event: Event): void => {
    if (!this.isExportspopup) {
      return;
    }
    const target = event.target as Node;
    const popupEl = this.exportsPopupRef && this.exportsPopupRef.nativeElement as Node;
    if (popupEl && !popupEl.contains(target)) {
      this.isExportspopup = false;
      try {
        this.cdr.detectChanges();
      } catch (e) {
        // ignore
      }
    }
  }

  setSampleSizeChange(event: boolean) {
    setTimeout(() => {
      this.isSampleSize = event;
      this.cdr.markForCheck();
    });
  }

  onTrendToggle() {
    this.isTrendActive = !this.isTrendActive;
    this.isSampleSize = false; // Reset sample size state when toggling view
    console.log('[Snapshot Toggle] isTrendActive:', this.isTrendActive);

    // Switch insights when view changes
    const targetText = this.isTrendActive ? this.snapshotinsights_trendline_text : this.snapshotinsights_standard_text;
    if (targetText) {
      console.log('[Snapshot Toggle] Switching insights text to:', { isTrend: this.isTrendActive, length: targetText.length });
      this.insightsStreamingText = targetText;
      this.insightsStreamingPoints = this.formatInsightsIntoPoints(targetText);

      this.InsightsResponse = {
        header: this.isTrendActive ? 'Trendline Insights' : 'Snapshot Insights',
        message: targetText,
        show: true
      };
      this._insightsSerive.showInisghts(this.InsightsResponse);
    }
  }
  isNewChatSession: boolean = false;
  isClosing: boolean = false;
  chatList: ChatListDocument[] = [];
  allChatList: ChatListDocument[] = [];
  chatHistory: ChatHistoryDocument[] = [];
  recentChats: ChatListDocument[] = [];
  olderChats: ChatListDocument[] = [];
  chatResponse: { [key: string]: string }[] = [];
  chatAccordions: any[] = [];
  chatPreviewBlocks: {
    question: string;
    response: string;
    messageId?: string;
    isStarred?: boolean;
    isLiked?: boolean | null;
    feedbackSaved?: boolean;
    showDislikeInput?: boolean;
    dislikeReason?: string;
    QuestionAnswer?: string;
  }[] = [];
  questions: string[] = [
    'Brand funnel of Bluehold?',
    'compare the mean brand power grid and consideration for Bluehold Financial and Guardia Funds in Q3 2023 in Market 01?',
    'Familiarity of Silveridge among females?',
    'Among male respondents aged 25–34 in Market 01, what is the awareness of Sproutvest Finance?'
  ];
  matchedQuestions: any[] = [];
  defaultQuestionAnswer: string = 'No data Available';

  // STARRED/SAVED QUESTIONS
  starredMessages: { MessageId: string; Question: string; ChatId: string; CreatedAt?: string }[] = [];
  filteredStarredMessages: { MessageId: string; Question: string; ChatId: string; CreatedAt?: string }[] = [];
  isLoadingStarredMessages: boolean = false;

  // UI DISPLAY FLAGS - GENERAL
  displayTable: boolean = false;
  isTableView: boolean = false;
  isChartView: boolean = true;
  private maxRowsPerSlide = 15;
  private maxColumnsPerSlide = 28;
  isTableClick: boolean = false;
  isListView: boolean = true;
  showSnapshot: boolean = false;
  snapshotConfiguration: any = null;
  showExtraSelections: boolean = false;
  showModuleDropdown: boolean = true;
  showDropdown: boolean = false;
  showCustomMetricsPopup: boolean = false;
  showToastNotification: boolean = false;
  showOutput: boolean = true;
  askMeLanding: boolean = true;
  isHidden: boolean = true;
  isQuestionBrowserOpen: boolean = false;
  noContentFlag: boolean = false;
  isInsightspopupOpen: boolean = false;
  isExportspopup: boolean = false;
  isCreateBtnClick: boolean = false;
  isInsightsBtnEnabled: boolean = false;
  isselectionsummarycollapse: boolean = false;
  isselectionsummarycollapse2: boolean = false;
  issavedselectionblock: boolean = false;
  isSaveSelectionClick: boolean = false;
  isSaveCustomGroupSelectionClick: boolean = false;
  isSaveCustomCalculationSelectionClick: boolean = false;
  isDiagnosticAnimating: boolean = false;
  isDiagnostic: boolean = false;
  moduleSelectionToggle: boolean = false;
  failedCase: boolean = false;

  // UI DISPLAY FLAGS - PANELS
  sidePanelDisplay: boolean = false;
  sidePanelNestingDisplay: boolean = false;
  columnPanelDisplay: boolean = false;
  columnNestingPanelDispaly: boolean = false;
  filterPanelDisplay: boolean = false;
  FooterNote: boolean = false;
  filteringAnsBlock: boolean = false;
  AnsBaseBlock: boolean = false;

  // UI DISPLAY FLAGS - DROPDOWNS  
  weightDropDown: boolean = false;
  dataDropDown: boolean = false;
  confidenceLevelDropDown: boolean = false;
  referenceLevelDropDown: boolean = false;
  sampleSizeDropdown: boolean = false;
  ConfidenceLevelDropDownToggle: boolean = false;
  BaseDropDownToggle: boolean = false;
  weightDropDownToggle: boolean = false;
  SampleSizeContainer: boolean = false;

  // CHART & VISUALIZATION  
  isTranspose: boolean = false;
  chartType = this.isTranspose ? CHART_TYPES.BAR : CHART_TYPES.COLUMN;
  is_TransposeBtn: boolean = false;
  is_chart_visualization: boolean = false;
  isVerticalBarChartClick: boolean = false;
  isLineChartClick: boolean = false;
  isVerticalStackChartClick: boolean = false;
  isVerticalGroupBarChartClick: boolean = false;
  disableStackChart: boolean = false;
  disableLineChart: boolean = false;
  StackFlag: boolean = false;
  showBarTooltip: boolean = false;
  showStackTooltip: boolean = false;
  showLineTooltip: boolean = false;
  showMainTooltip: boolean = false;
  public LineChart: LineChart = {
    title: '',
    Data: [],
    Properties: [],
  };
  public StackChart: StackChart = {
    title: '',
    Data: [],
    Properties: [],
  };
  public BarChart: GroupBarChart = {
    title: '',
    Data: [],
    Properties: [],
  };
  GeneralToolTip: string[] = [
    'Charting Option to be disabled when using Indexation.',
    'Charting Option to be disabled when anything is selected <br> in Row Nesting.',
    'Charting Option to be disabled when more than one metric <br> is selected in Rows.',
    'Charting Option to be disabled when anything is selected <br> in Column Nesting.',
  ];
  StackChartToolTip: string[] = [
    'Stack Chart is enabled only when a single metric group <br> is selected with all its options, and the number of rows <br> does not exceed 15.',
    'It won’t work for multipunch variables or if nesting is applied.'
  ];
  LineChartToolTip: string[] = [
    'Trend will be available only when a single<br>Time Period Group is selected in the columns.',
    'There will be one trend line for each option<br>selected in the Rows.',
    'You can select a maximum of 15 options in the Rows.<br> If you select more than 15 options,charting<br>options will be disabled.',
    'Charting Option to be disabled when anything<br>is selected in Row Nesting.',
    'Charting Option to be disabled when more<br>than one metric is selected in Rows.',
    'Charting Option to be disabled when anything<br>is selected in Column Nesting.',
  ];
  BarChartToolTip: string[] = [
    'You can select a maximum of 15 options in the Rows. If you select more than 15 options, charting options will be disabled.',
    'Charting Option to be disabled when anything is selected <br> in Row Nesting.',
    'Charting Option to be disabled when more than one metric <br> is selected in Rows.',
    'Charting Option to be disabled when anything is selected <br> in Column Nesting.',
  ];

  // DATA ARRAYS & LISTS
  dataArray: any[] = [];
  fomDataArray: any[] = [];
  leftpanelDataArray: any[] = [];
  leftPanelData: any = {};
  loadData: any[] = [];
  listAItemsList: ListItem[] = [];
  listBItemsList: ListItem[] = [];
  listCItemsList: ListItem[] = [];
  listDItemsList: ListItem[] = [];
  listEItemsList: ListItem[] = [];
  entryList: any[] = [];
  entryPanel: { Level1: string }[] = [];
  variableList: VariableList[] = [];
  SampleSizeList: any = [];
  aggregatedVariables: any = [];
  is_confidenceLevel: any = [];
  WeightDropDownList: { Label: string; responseCode: string; tooltip: string }[] = [];
  dataDropDownList: string[] = ['Data', 'Sample Size', 'Weighted Sample', 'Weighted Numerator', 'Unweighted Numerator'];
  titleSection: { key: string; value: string }[] = [];
  entryPoints: { key: string; value: string }[] = [];
  selections: { key: string; value: string }[] = [];
  Columnselections: any = [];
  Rowselections: any = [];
  AllSelections: any = [];
  moduleseSelections = [
    { key: 'Snapshot', value: true, isSelected: true },
    { key: 'Crosstab', value: true, isSelected: false }
  ];
  snapshotWidgetData: any = [];
  snapshotDataModel: any = [];
  moduleList: any = [];
  indexVsBrandReference: any = [];
  significanceVsBrandReference: any = [];
  subSectionNames: any = [];
  weight: any = [];
  base = [
    { key: 'Total Base', selected: true },
    { key: 'Answer Base', selected: false }
  ];
  base2 = [{ key: 'Total Base', selected: true }];
  vsBrandArray: any[] = [];
  selectedSigType: any[] = [];
  significanceTypes: any[] = [];
  significanceVal: any[] = [];

  // DATA OBJECTS & COMPLEX STRUCTURES
  previewDataObject: DataObject = {
    Row: [],
    Column: [],
    RowNesting: [],
    ColNesting: [],
    Filter: [],
    CustomGroup: [],
    CustomCalculation: []
  };
  FinalOutputdataObject: OutputDataObject = {
    Row: [],
    Column: []
  };
  public OutputdataObject: OutputDataObject = {
    Row: [],
    Column: [],
  };
  public dataObject: DataObject = {
    Row: [],
    Column: [],
    RowNesting: [],
    ColNesting: [],
    Filter: [],
    CustomGroup: [],
    CustomCalculation: [],
  };
  public fomData: fomData = {
    Header: '',
    Level1: '',
    Level2: '',
    MetricOption: '',
    data_variable_code: '',
    response_code: '',
    derived_metric_calculation: '',
    Level0: '',
    Level3: '',
    Level4: '',
    Level5: '',
    Level6: '',
    sort_id: 0,
    level1_sort_id: 0,
    is_multi_punch: 0,
    is_derived_variable: false,
    is_dimension: false,
    calculation_type: '',
    url_logo: '',
    tooltip: '',
    year_code: '',
    year_label: '',
    date: '',
    isActive: false,
    is_CustomGroup: false,
    customGroupQuery: '',
    is_CustomCalculation: false,
    customCalculationQuery: '',
    dataYearCode: '',
    is_time_Period_Present: false,
    is_dimension_Present: false,
    is_shared: false,
    user_name: '',
    customGroupId: '',
    customCalculationId: '',
    is_brandanalysis: 0,
    variable_code: '',
    is_aggregated_data: 0,
    is_semi_aggregated_data: 0,
    is_snapshot: 0,
    sequence: 0,
  };
  widegtconfigdetails: any = {
    section: '',
    subSection: '',
    snapshotType: '',
    snapshotName: '',
    clientName: '',
    study: '',
    IsCustomSnapshot: false
  };
  output_details: any = {};
  weightFilter: { [key: string]: string } = {};

  // CONFIGURATION & SETTINGS
  variableTabData: any;
  configWeights: any;
  configweights: any;
  DefaultConfidenceLevel: string = DEFAULT_VALUES.NONE;
  DefaultSampleSize: string = DEFAULT_VALUES.NONE;
  DefaultDataDropDown: string = DEFAULT_VALUES.DATA;
  DefaultReferenceLevel: string = DEFAULT_VALUES.NONE;
  DefaultWeight: string = '';
  selectedDataFormat: string = '';
  selectedWeight: string = '';
  selectedIndex: string = '';
  threshold: string = '';
  isData: boolean = true;
  isWeightedLabel: boolean = false;
  isSampleSize: boolean = false;
  isSampleSizeBlock: boolean = false;
  isWeightedSampleBlock: boolean = false;
  isWeightedBase: boolean = false;
  isWeightedNumerator: boolean = false;
  isUnWeightedNumerator: boolean = false;
  isTotalBase: boolean = false;
  isTotalBaseFromPrompt: string = 'false';
  isAnswerBase: boolean = false;
  isTotal: boolean = false;
  isFilteringActive: boolean = true;
  isRowNesting: boolean = false;
  isColumnNesting: boolean = false;
  isSelectAllMetricsLevel: boolean = false;
  isSelectAllMetrics: any;
  isAggregatedData: boolean = false;
  isSemiAggregatedData: boolean = false;
  isExistingDataPresent: boolean = false;
  columnLength: number = 0;

  is_sticky_selection: boolean = false;
  isRespondentLevel: boolean = true;

  // SIGNIFICANCE TESTING & STATISTICAL
  isPairWise: boolean = false;
  isReference: boolean = false;
  isDisablePairWise: boolean = true;
  isDisableReference: boolean = true;
  isSignificanceContainerDisabled: boolean = false;
  is_sigtesting: boolean = false;
  isSig: boolean = true;
  isSigSelected: any = true;
  SignificanceVsReference: string = '';
  significance: string = 'None';
  displaySignificance: any = 'None';
  displayConfidenceLevel: string = '';
  displayReference: any = 'None';
  confidenceLevelSelectedValue: string = '';
  significanceSelectedValue: string = 'None';
  selectedSignificance: any;
  selectedSigBrand: any;
  stacticText: string = '';

  // WEIGHT & INDEX CONFIGURATION
  is_indexing: boolean = false;
  is_indexingShow: boolean = false;
  isIndexSelected: any;
  IndexData: any;
  weightColumnName: string = '';
  weightSelectedValue: any = 'Total Population';
  sortToggle: boolean = true;

  // SNAPSHOT & WIDGET CONFIGURATION
  snapshotName: string = '';
  selectedType: any = 'Single Brand';
  filteredWidgetSelection: any;
  pageData: any;
  widgetData: any;
  baseselected: string = 'Total Base';
  outputData: any;
  item: any;
  items: any;
  itemWithoutTrend: any;
  itemWithoutTrendItems: any;
  lastCrosstabPayload: any;
  lastSnapshotPayload: any;
  lastBrandAnalysisPayload: any;
  MainResult: any;
  masterStudyConfig: any = null;
  filteredWidgetData: any;
  filteredWidgetID: any;
  selectedWidgetName: any;
  selectedWidgetID: any;
  WidgetId: any;
  Widget_Id: any;
  widget_Name: any;
  widget_Id: any;
  displayModuleSelected: string = 'Snapshot';
  selectedSection: string = '';
  selectedSubSection: string = 'NA';
  selectedcompareacrossOption: string = '';
  SaveSelectiontext: string = '';
  isselectionHeader: string = '';

  // EXPORT & DOWNLOAD PROPERTIES
  excelExport: boolean = false;
  CrossTabOutPutData: any;
  Snapshotdataforexport: any;
  CrossTabOutPutEntireData: any;
  OutputData: any;
  passOutputData: any;
  ImageURL: string = '';

  // BRAND ANALYSIS
  is_brand_analysis: boolean = false;
  isBrandAnalysis: boolean = false;
  isBoostFactor: boolean = false;
  ShareColumn: any;
  BaseColumn: any;
  selectedBrands: any[] = [];
  referenceBrand: string = '';
  allbrands: any;
  allSigBrands: any;

  // TOAST NOTIFICATIONS
  toastMessage: string = '';
  toastType: 'success' | 'error' | 'info' = 'success';

  // DIAGNOSTIC & ICONS
  diagnosticIcon: string = 'assets/imageChatbot/Diagnostic_Left_Icon_Normal.svg';

  // SELECTION & SUMMARY
  selectionSummary: string = '';
  selectionSummaryTitle: string = '';
  summaryTitle: any;
  additionalList: any;

  // INSIGHTS
  insightsVal: any = '';
  InsightsResponse: any = '';
  public insights_payload: any = null;
  public snapshotinsights_payload: any = null;
  public snapshotinsights_trend_payload: any = null;
  public snapshotinsights_standard_text: string = '';
  public snapshotinsights_trendline_text: string = '';
  public insightsStreamingText: string = '';
  public insightsStreamingPoints: string[] = []; // Formatted streaming points
  private insightsScrollInterval: any = null;
  private isInsightsScrolling: boolean = false;
  private qnaFirstChunkTime: number = 0;

  // MISCELLANEOUS/LEGACY PROPERTIES
  is_Transpose: any;
  is_ranking: any;
  isFilterToggle: any;
  isAnswerToggle: any;
  comparisionpoint: any;
  confidenceLevel: any;
  repository: any;
  lowBaseIdentifier: any;
  is_AI_Integration: any;
  is_StoryBoard: any;
  is_Column_Row_Percentage: any;
  insufficentBase: any;
  insufficientBase: any;
  lowBase: any;
  LowBase: any;
  iscustomgrp: any;
  iscustomCalc: any;
  iscustomreport: any;
  changeEntryPoint: any;
  is_reset_selection: any;
  dataexists: any;
  newdataexists: any;
  strdata: any;
  serviceVariable: any;
  mcode: any;
  promptData: any;
  mandatoryVariableMapping: any;
  is_dimension_Present: boolean = false;
  is_Time_Period_Present: boolean = true;
  istimePeriodWave: boolean = false;

  // SUBSCRIPTIONS
  $unSubscribeSubmitData1!: Subscription;
  $unSubscribeSubmitData2!: Subscription;
  $unSubscribeSubmitData3!: Subscription;
  $unSubscribeSubmitData4!: Subscription;
  $unSubscribeSubmitData5!: Subscription;
  $unSubscribeSubmitData6!: Subscription;
  $unSubscribeSubmitData7!: Subscription;
  $unSubscribeSubmitData8!: Subscription;
  $unSubscribeSubmitData9!: Subscription;

  goToWelcomeSection(): void {
    this.currentView = 'landing';
  }

  goToLandingPage(): void {
    this.router.navigateByUrl('/landing');
  }

  onChartIconMouseOver(tooltipType: 'stack' | 'line' | 'bar', event: MouseEvent): void {
    this.tooltipStates[tooltipType] = true;
    this.updateTooltipFlags();

    if (!this.isIndex) {
      this.showMainTooltip = false;
      event.stopPropagation();
    }
  }

  onChartIconMouseLeave(tooltipType: 'stack' | 'line' | 'bar'): void {
    this.tooltipStates[tooltipType] = false;
    this.updateTooltipFlags();
  }

  private updateTooltipFlags(): void {
    this.showStackTooltip = this.tooltipStates.stack;
    this.showLineTooltip = this.tooltipStates.line;
    this.showBarTooltip = this.tooltipStates.bar;
  }

  fallbackMessage(): string {
    const clientName = this.selected_client || 'Unknown Client';
    const studyName = this.selected_study || 'Unknown Study';

    return exceptionMessage
      .replace(/{{client}}/g, clientName)
      .replace(/{{study}}/g, studyName);
  }

  onHover(isHovering: boolean): void {
    this.diagnosticIcon = isHovering
      ? 'assets/imageChatbot/Diagnostic_Left_Icon_Hover.svg'
      : 'assets/imageChatbot/Diagnostic_Left_Icon_Normal.svg';
  }

  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }

  closeDropdown(): void {
    this.showDropdown = false;
  }

  viewOnline(): void {
    this.isDiagnosticAnimating = true;
    const animationPromise = new Promise(resolve => setTimeout(resolve, 1000));
    const diagnosticPromise = Promise.resolve(this.fetchDiagnostic()).catch(() => { });

    Promise.all([animationPromise, diagnosticPromise])
      .finally(() => {
        this.isDiagnosticAnimating = false;
        this._loaderService.hideLoader();
        this.closeDropdown();
      });
  }

  exportToExcel(): void {
    this.apiService.downloadDiagnosticsExcel().subscribe((blob: Blob) => {
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0].replace(/-/g, '');
      const client = this.selected_client && this.selected_client.trim() !== '' ? this.selected_client : 'Diagnostics';
      const snapshot = this.snapshotName && this.snapshotName.trim() !== '' ? this.snapshotName : 'Excel';
      const fileName = `${client}-${snapshot}-${formattedDate}.xlsx`;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      this.closeDropdown();
    });
  }

  handleConfig(eventData: any): void {
    if (eventData.configweights && eventData.configweights.length > 0) {
      this.configWeights = eventData.configweights;

      if (this.variableTabData && this.variableTabData.length > 0) {
        this.populateWeightDropdown();
      }
    }
  }

  getBearerToken(): Promise<string> {
    return new Promise((resolve) => {
      let account = this.msalService.instance.getActiveAccount();
      if (!account) {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts && accounts.length > 0) {
          account = accounts[0];
          this.msalService.instance.setActiveAccount(account);
        }
      }
      if (!account) {
        resolve('');
        return;
      }
      this.msalService.instance.acquireTokenSilent({
        scopes: protectedResources.Api.scopes.read,
        account: account
      }).then(tokenResponse => {
        resolve(`Bearer ${tokenResponse.accessToken}`);
      }).catch(error => {
        console.error('Token acquisition failed in chatbotexpand', error);
        resolve('');
      });
    });
  }

  get currentQuestion(): string {
    if (!this.selectedMessageId || this.chatPreviewBlocks.length === 0) {
      return this.chatPreviewBlocks.length > 0
        ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question
        : '';
    }

    const selectedBlock = this.chatPreviewBlocks.find(
      block => block.messageId === this.selectedMessageId
    );

    return selectedBlock
      ? selectedBlock.question
      : (this.chatPreviewBlocks.length > 0
        ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question
        : '');
  }

  get currentAnswer(): string {
    if (!this.selectedMessageId || this.chatPreviewBlocks.length === 0) {
      return this.chatPreviewBlocks.length > 0
        ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].QuestionAnswer || ''
        : '';
    }

    const selectedBlock = this.chatPreviewBlocks.find(
      block => block.messageId === this.selectedMessageId
    );

    return selectedBlock
      ? (selectedBlock.QuestionAnswer || '')
      : (this.chatPreviewBlocks.length > 0
        ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].QuestionAnswer || ''
        : '');
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private _loaderService: LoaderService,
    private _exportDownloads: ExportDownloadServices,
    private apiService: ChatbotService,
    private crossTabService: CrosstabService,
    private _insightsSerive: InsightspopupService,
    private _usermanagementService: UserProjectManagementService,
    private _configCustomService: CustomsnapshotService,
    public _configService: SnapshotService,
    private _configurationService: ConfigurationService,
    private sharedChatService: SharedChatService,
    private commonchartmodules: CommonChartmoduleService,
    private indexedDBService: IndexedDBService,
    private msalService: MsalService,
    private cdr: ChangeDetectorRef
  ) {
    this.landingdata = this.router.getCurrentNavigation()?.extras.state;
    if (this.landingdata == undefined) {
      this.router.navigateByUrl('landing');
    }
    this.searchForm = this.fb.group({
      query: ['']
    });

    const fromLandingPage = this.landingdata?.fromLandingPage === true || sessionStorage.getItem('fromLanding') === 'true';
    if (fromLandingPage) {
      // If there's already an input question from the landing page, go directly to chat view
      this.currentView = this.landingdata?.inputValue ? 'chat' : 'landing';
    } else {
      this.currentView = 'chat';
    }
  }

  formatMarkdown(text: any, isInsights: boolean = false): string {
    if (Array.isArray(text)) {
      text = text[0] || '';
    }
    if (typeof text !== 'string') {
      return '';
    }
    return FormattersHelper.formatMarkdown(text, isInsights);
  }

  subscribeToVariableData(): void {
    this.$unSubscribeSubmitData3 =
      this.crossTabService.variableTabData$.subscribe(({ data }) => {
        if (data !== null && data !== undefined) {
          this.variableTabData = data;
          if (this.configWeights && this.configWeights.length > 0) {
            this.populateWeightDropdown();
          }
        }
      });
  }

  async ngOnInit(): Promise<void> {
    let session_id_from_storage = sessionStorage.getItem('session_id');

    if (this.landingdata && this.landingdata.guidChatId) {
      this.guidChatId = this.landingdata.guidChatId;
      this.validatedSessionId = this.guidChatId;
      this.modulesAccess = this.landingdata.modules_access;
    } else if (session_id_from_storage) {
      this.guidChatId = session_id_from_storage;
      this.validatedSessionId = this.guidChatId;
    }

    this.selected_study = this.landingdata?.study || null;
    this.selected_client = this.landingdata?.client_code || null;
    this._configService.clientName = this.selected_client;
    this._configService.selectedStudy = this.selected_study;

    this.preFetchMetadata();

    // Only call access-check if not already validated for this session
    if (!this.validatedSessionId || this.validatedSessionId !== this.guidChatId) {
      this.getBearerToken().then(token => {
        this.apiService.accessCheck(
          this.selected_client || 'Demo',
          this.selected_study || 'brand-health-tracker',
          token,
          this.guidChatId || ''
        ).subscribe({
          next: (res: any) => {
            if (res && res.session_id) {
              this.guidChatId = res.session_id;
              this.modulesAccess = res.modules_access;
              this.isCacheGenerated = false; // Reset cache flag as we have fresh modules_access
            }
            this.validatedSessionId = this.guidChatId;
          },
          error: (err) => {
            console.error('[ACCESS-CHECK] ❌ Init access-check failed:', err);
          }
        });
      });
    } else {
    }

    this.askMeLanding = true;
    this.arktabaccess = true;
    this.startAiLoader();
    this.selected_study = this.landingdata?.study || null;
    this.selected_client = this.landingdata?.client_code || null;
    this.commonchartmodules.colortemplate(this.selected_client);
    this.ShareColumn = this.landingdata?.shareColumn || null;
    this.BaseColumn = this.landingdata?.baseColumn || null;
    this.displayTable = false;
    this.subscribeToVariableData();
    this.indexedDBService.clearExpiredCache().catch((err: any) =>
      console.error('Error clearing expired cache:', err)
    );

    this.getChatListData();
    this.initializeUserIdentity();
    const fromLandingPage = this.landingdata?.fromLandingPage === true || sessionStorage.getItem('fromLanding') === 'true';
    if (!this.selected_study || !this.selected_client) {
      this.arktabaccess = false;
      this.router.navigateByUrl('/landing');
      return;
    }

    let result: results | null = await this.indexedDBService.getClientStudyData(
      this.selected_client,
      this.selected_study,
      this.isBrandAnalysis
    );

    if (!result) {
      result = await firstValueFrom(
        this.crossTabService.getClientStudyData(
          {
            client_code: this.selected_client,
            study: this.selected_study,
          },
          this.isBrandAnalysis
        )
      );

      if (result && result.HasValidData) {
        await this.indexedDBService.cacheClientStudyData(
          this.selected_client,
          this.selected_study,
          this.isBrandAnalysis,
          result
        );
      }
    }

    if (result && result.HasValidData) {
      const studyData: StudyData = {
        study: this.selected_study,
        client_name: this.selected_client,
        url_logo: this.filteredlist?.url_logo || '',
      };
      this.receivedData = JSON.parse(result.Data);
      this.clientcode = this.selected_client;
      this.filteredlist = this.receivedData.find(
        (u: StudyData) =>
          u.study === this.selected_study &&
          u.client_name === this.selected_client
      );

      this.logo_url = this.filteredlist?.url_logo || '';
      try {
        this._configurationService.getLogoFiles(this.selected_client).subscribe((files: FilesWithIdentifiers[]) => {
          if (files && files.length > 0) {
            const askme = files.find((f: FilesWithIdentifiers) => f.fileName && f.fileName.toLowerCase().endsWith('_askme.png'));
            const normal = files.find((f: FilesWithIdentifiers) => f.fileName && !f.fileName.toLowerCase().endsWith('_askme.png'));
            this.logo_url = askme?.url || normal?.url || this.logo_url;
          }
        }, (err: any) => {
          console.warn('Could not fetch logo files list, using default url_logo', err);
        });
      } catch (e) {
        console.warn('Error fetching logo files, using default url_logo', e);
      }

      if (this.selected_client === 'PMI') {
        this.configChanges(this.receivedData, this.selected_study);
      }

      if (fromLandingPage) {
        this.arktabaccess = false;
        this.processSendMessageRequest();
      } else {
        this.loadLatestChatIfExists();
      }
    } else {
      this.arktabaccess = false;
      this.router.navigateByUrl('/landing');
    }

    this.summaryTitle = this.Summary();
  }

  /**
   * Pre-fetches master study configuration metadata so analytical dropdowns in the output popup
   * are populated faster. This replicates a portion of the popup's own initialization logic.
   */
  preFetchMetadata(): void {
    const client = this.selected_client || 'Demo';
    const study = this.selected_study || 'brand-health-tracker';

    if (client && study) {
      console.log('[ACCESS-CHECK] → Pre-fetching master study configuration metadata...');
      this._configService.getGeneralConfigData({
        study: study,
        client_name: client,
        client_code: client,
        isBrandAnalysis: true
      }).subscribe({
        next: (res: any) => {
          console.log('[ACCESS-CHECK] ✓ Metadata Pre-fetch Received.');
          if (res) {
            this.handleMetadataPreFetchResponse(res);
          }
        },
        error: (err: any) => {
          console.error('[ACCESS-CHECK] ❌ Metadata Pre-fetch Error:', err);
        }
      });
    }
  }

  /**
   * Processes the pre-fetched metadata response and stores it in the service
   * so the output popup can pick it up immediately.
   */
  handleMetadataPreFetchResponse(data: any): void {
    if (!data) return;

    let parsedData: any = null;
    try {
      if (data.Data && data.Data !== '') {
        parsedData = (typeof data.Data === 'string') ? JSON.parse(data.Data) : data.Data;
      } else if (data.Config && data.Config !== '') {
        parsedData = (typeof data.Config === 'string') ? JSON.parse(data.Config) : data.Config;
      } else {
        parsedData = data;
      }
    } catch (e) {
      parsedData = data.Data || data;
    }

    if (parsedData && parsedData.configData) {
      parsedData = parsedData.configData;
    }

    // Write to shared service property
    this._configService.outputSnapshotData = parsedData;
    this.masterStudyConfig = parsedData; // Store master config for explicit passing via Input
    console.log('[ACCESS-CHECK] ✓ Stored master config in SnapshotService and masterStudyConfig. Keys:', Object.keys(parsedData || {}));

    // Map specific properties to the service (Matches Popup Ref)
    if (parsedData.brandMetadata) this._configService.brandData = parsedData.brandMetadata;
    else if (parsedData.brand_metadata) this._configService.brandData = parsedData.brand_metadata;

    const weightsRaw = parsedData.weight || parsedData.weights;
    if (weightsRaw) {
      this._configService.weights = weightsRaw;
      // Derive the display label for the first selected weight (matches output-popup mapping)
      const selectedWeights = Array.isArray(weightsRaw)
        ? weightsRaw.filter((w: any) => w.is_selected || w.isSelected)
        : [];
      const firstWeight = selectedWeights.length > 0 ? selectedWeights[0]
        : (Array.isArray(weightsRaw) ? weightsRaw[0] : null);
      if (firstWeight) {
        const allSelected = selectedWeights.length > 0 ? selectedWeights : (Array.isArray(weightsRaw) ? weightsRaw : []);
        const idx = allSelected.indexOf(firstWeight);
        const label = idx === 0 ? 'Primary Weight'
          : idx === 1 ? 'Secondary Weight'
          : (firstWeight.variable_label || firstWeight.key || `Weight ${idx + 1}`);
        this._configService.weightLabel = label;
        if (!this.DefaultWeight) {
          this.DefaultWeight = label;
        }
      }
    }

    console.log('[ACCESS-CHECK] ✓ Metadata mapping complete. Sig:', !!parsedData.significance_type, 'Comp:', !!parsedData.comparison_point);
  }

  async initializeUserIdentity(): Promise<void> {
    try {
      const storedUserId = sessionStorage.getItem('arkUserId');

      if (storedUserId) {
        const response = await firstValueFrom(this.apiService.getUserIdentity(storedUserId));
        const apiResponse = JSON.parse(response);

        if (apiResponse.HasValidData && apiResponse.Data) {
          const userData = JSON.parse(apiResponse.Data);
          this.userId = userData.UserId;
          return;
        }
      }
      await this.createNewUserIdentity();
    } catch (error) {
      await this.createNewUserIdentity();
    }
  }

  async createNewUserIdentity(): Promise<void> {
    try {
      const userDoc: UserIdentityDocument = {
        UserId: '',
      };

      const response = await firstValueFrom(this.apiService.saveUserIdentity(userDoc));
      const apiResponse = JSON.parse(response);

      if (apiResponse.HasValidData && apiResponse.Data) {
        this.userId = apiResponse.Data;
        sessionStorage.setItem('arkUserId', this.userId);
      } else {
      }
    } catch (error) {
    }
  }

  processSendMessageRequest(): void {
    this.subscriptions.add(
      this.sharedChatService.sendMessageRequest$.pipe(take(1)).subscribe(payload => {
        if (payload && payload.inputValue && payload.inputValue.trim() !== '') {
          // Guard: Prevent sending new message while previous question is still processing
          if (this.arktabaccess) {
            console.warn('[SEND GUARD] Cannot send message from landing page - previous question still processing');
            this.sharedChatService.clearRequest();
            return;
          }

          this.inputValue = payload.inputValue.trim();
          this.selectedMessageId = null; // Clear selected message for new question
          if (payload.guidChatId) {
            this.guidChatId = payload.guidChatId;
            this.validatedSessionId = payload.guidChatId;
          } else {
            console.warn('[RECEIVE-MESSAGE] Fallback triggered: No guidChatId in payload!');
          }
          if (payload.modulesAccess) {
            this.modulesAccess = payload.modulesAccess;
          }
          this.sendInputMessage();
          this.sharedChatService.clearRequest();
        } else {
          if (payload) {
            this.landingdata = {
              ...this.landingdata,
              client_code: payload.clientCode,
              study: payload.study,
              dataArray: payload.dataArray || [],
              landingData: payload.landingData || {},
              guidChatId: payload.guidChatId,
              modules_access: payload.modulesAccess
            };
            if (payload.guidChatId) {
              this.guidChatId = payload.guidChatId;
              this.validatedSessionId = payload.guidChatId;
            } else {
              console.warn('[RECEIVE-MESSAGE] (Fallback Block) Fallback triggered: No guidChatId in payload!');
            }
            this.selected_study = payload.study;
            this.selected_client = payload.clientCode;
            this.loadData = payload.dataArray || [];
            this.leftPanelData = payload.landingData || {};
          }
          this.arktabaccess = false;
          this.currentView = 'landing';
          this.chatPreviewBlocks = [];
          this.isNewChatSession = true;
        }
      })
    );
  }

  ngOnDestroy() {
    try {
      document.removeEventListener('click', this.onDocumentClick, true);
    } catch (e) {
      // ignore
    }
    this.subscriptions.unsubscribe();
    if (this.$unSubscribeSubmitData1) {
      this.$unSubscribeSubmitData1.unsubscribe();
    }
    if (this.$unSubscribeSubmitData2) {
      this.$unSubscribeSubmitData2.unsubscribe();
    }
    if (this.$unSubscribeSubmitData3) {
      this.$unSubscribeSubmitData3.unsubscribe();
    }
    if (this.$unSubscribeSubmitData4) {
      this.$unSubscribeSubmitData4.unsubscribe();
    }
    if (this.$unSubscribeSubmitData5) {
      this.$unSubscribeSubmitData5.unsubscribe();
    }
    if (this.$unSubscribeSubmitData6) {
      this.$unSubscribeSubmitData6.unsubscribe();
    }
    if (this.$unSubscribeSubmitData8) {
      this.$unSubscribeSubmitData8.unsubscribe();
    }
    if (this.$unSubscribeSubmitData9) {
      this.$unSubscribeSubmitData9.unsubscribe();
    }
    this.stopInsightsAutoScroll();
    sessionStorage.removeItem('isarkTabAccessed');
  }

  toggleChatHistory(): void {
    if (this.currentView === 'landing') {
      this.navigateToChat();
    }
    if (this.isSavedQuestionsOpen) {
      this.isSavedQuestionsOpen = false;
    }
    if (this.isQuestionBrowserOpen) {
      this.isQuestionBrowserOpen = false;
    }
    this.isChatHistoryOpen = !this.isChatHistoryOpen;
  }

  toggleSavedSelections(): void {
    if (this.currentView === 'landing') {
      this.navigateToChat();
    }
    if (this.isChatHistoryOpen) {
      this.isChatHistoryOpen = false;
    }
    if (this.isQuestionBrowserOpen) {
      this.isQuestionBrowserOpen = false;
    }
    this.isSavedQuestionsOpen = !this.isSavedQuestionsOpen;

    if (this.isSavedQuestionsOpen) {
      this.loadStarredMessages();
    }
  }

  loadStarredMessages(): void {
    this.isLoadingStarredMessages = true;
    this.apiService.getStarredMessages().subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          this.starredMessages = JSON.parse(apiResponse.Data);
          this.filteredStarredMessages = [...this.starredMessages];
        } else {
          this.starredMessages = [];
          this.filteredStarredMessages = [];
        }
        this.isLoadingStarredMessages = false;
      },
      error: (err) => {
        this.starredMessages = [];
        this.filteredStarredMessages = [];
        this.isLoadingStarredMessages = false;
      }
    });
  }

  onStarredSearch(): void {
    const searchText = this.starredSearchText.toLowerCase().trim();
    if (!searchText) {
      this.filteredStarredMessages = [...this.starredMessages];
      return;
    }

    const searchTokens = this.tokenizeSearchText(searchText.toLowerCase());
    this.filteredStarredMessages = this.starredMessages.filter(msg =>
      this.matchesAllTokens(msg.Question || '', searchTokens)
    );
  }

  unstarFromSaved(message: any, event: Event): void {
    event.stopPropagation();
    const messageId = message.MessageId || message.messageId || message.id;
    if (!messageId) {
      console.warn('[unstarFromSaved] ❌ No message ID found in:', message);
      return;
    }

    this.apiService.updateChatStarred(messageId, false).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          // Update local starredMessages list
          const beforeCount = this.starredMessages.length;
          this.starredMessages = this.starredMessages.filter(m => {
            const mId = (m.MessageId || (m as any).messageId || '').toString().toLowerCase();
            const targetId = (messageId || '').toString().toLowerCase();
            return mId !== targetId;
          });
          this.onStarredSearch(); // Refresh filtered list

          // Also update allChatList if it contains this message
          this.allChatList.forEach(chat => {
            const msg = chat.ChatHistory?.find((h: any) => {
              const hId = (h.MessageId || h.messageId || '').toString().toLowerCase();
              const targetId = (messageId || '').toString().toLowerCase();
              return hId === targetId;
            });
            if (msg) {
              msg.IsStarred = false;
              (msg as any).isStarred = false;
            }
          });

          // Update chatPreviewBlocks if current
          const currentMsg = this.chatPreviewBlocks.find(b => {
            const bId = (b.messageId || '').toString().toLowerCase();
            const targetId = (messageId || '').toString().toLowerCase();
            return bId === targetId;
          });
          if (currentMsg) {
            currentMsg.isStarred = false;
          }

          this.showToast('Removed from saved questions', 'success');
        }
      }
    });
  }

  deleteFromSaved(message: any, event: Event): void {
    event.stopPropagation();
    const messageId = message.MessageId || message.messageId || message.id;
    if (!messageId) return;

    if (!confirm('Are you sure you want to delete this question?')) return;

    this.apiService.updateChatStarred(messageId, false).subscribe({
      next: () => {
        this.apiService.deleteChatMessage(messageId).subscribe({
          next: (res: string) => {
            const apiResponse = JSON.parse(res);
            if (apiResponse.HasValidData) {
              // Remove from local lists
              const beforeCount = this.starredMessages.length;
              this.starredMessages = this.starredMessages.filter(m => {
                const mId = (m.MessageId || (m as any).messageId || '').toString().toLowerCase();
                const targetId = (messageId || '').toString().toLowerCase();
                return mId !== targetId;
              });
              this.onStarredSearch();

              // Update allChatList
              this.allChatList.forEach(chat => {
                if (chat.ChatHistory) {
                  const idx = chat.ChatHistory.findIndex((h: any) => {
                    const hId = (h.MessageId || h.messageId || '').toString().toLowerCase();
                    const targetId = (messageId || '').toString().toLowerCase();
                    return hId === targetId;
                  });
                  if (idx > -1) {
                    chat.ChatHistory.splice(idx, 1);
                  }
                }
              });

              // Handle current view if deleting the active message
              if (messageId === this.selectedMessageId) {
                const chatObj = this.chatPreviewBlocks.find(b => {
                  const bId = (b.messageId || '').toString().toLowerCase();
                  const targetId = (messageId || '').toString().toLowerCase();
                  return bId === targetId;
                });
                if (chatObj) {
                  const pIndex = this.chatPreviewBlocks.indexOf(chatObj);
                  if (pIndex > -1) this.chatPreviewBlocks.splice(pIndex, 1);

                  this.selectedMessageId = null;
                  this.displayTable = false;
                  this.showSnapshot = false;
                  this.clearOutputDataObject();
                  this.isInsightspopupOpen = false;

                  if (this.chatPreviewBlocks.length === 0) {
                    this.navigateToLanding();
                  }
                }
              }

              this.showToast('Question deleted successfully', 'success');
            }
          }
        });
      },
      error: () => {
        console.warn('[deleteFromSaved] ⚠️ Pre-emptive unstar failed, proceeding with delete anyway');
        // Fallback to just delete if unstar fails
        this.apiService.deleteChatMessage(messageId).subscribe();
      }
    });
  }

  onStarredQuestionClick(message: { MessageId: string; Question: string; ChatId: string }): void {
    this.isSavedQuestionsOpen = false;
    const chat = this.allChatList.find(c => c.ChatHistory && c.ChatHistory.some(h => h.MessageId === message.MessageId));

    if (chat) {
      const specificMsg = chat.ChatHistory?.find(h => h.MessageId === message.MessageId);

      if (specificMsg) {
        this.chatPreviewBlocks = [{
          question: specificMsg.Question || message.Question || '',
          response: '',
          messageId: specificMsg.MessageId,
          isStarred: specificMsg.IsStarred || false,
          QuestionAnswer: specificMsg.QuestionAnswer || this.defaultQuestionAnswer
        }];

        this.newChatId = chat.ChatId || null;
        this.guidChatId = chat.ChatId || '';
        this.selectedChatId = chat.ChatId || null;
        this.currentView = 'chat';
      }
    } else {
      // Fallback if chat is not in current list
      this.chatPreviewBlocks = [{
        question: message.Question || '',
        response: '',
        messageId: message.MessageId,
        isStarred: true,
        QuestionAnswer: this.defaultQuestionAnswer
      }];
      this.guidChatId = message.ChatId || message.MessageId;
      this.selectedChatId = message.ChatId || message.MessageId;
      this.currentView = 'chat';
    }

    this.selectedMessageId = message.MessageId;
    this.getChatResponse(message.MessageId, true);
  }

  onQuestionBrowserClick(question: { question: string; messageId: string; chatTitle: string }): void {
    this.isQuestionBrowserOpen = false;
    const chat = this.allChatList.find(c => c.ChatHistory && c.ChatHistory.some(h => h.MessageId === question.messageId));

    if (chat) {
      const specificMsg = chat.ChatHistory?.find(h => h.MessageId === question.messageId);

      if (specificMsg) {
        this.chatPreviewBlocks = [{
          question: specificMsg.Question || question.question || '',
          response: '',
          messageId: specificMsg.MessageId,
          isStarred: specificMsg.IsStarred || false,
          QuestionAnswer: specificMsg.QuestionAnswer || this.defaultQuestionAnswer
        }];

        this.newChatId = chat.ChatId || null;
        this.guidChatId = chat.ChatId || '';
        this.selectedChatId = chat.ChatId || null;
        this.currentView = 'chat';
      }
    } else {
      // Fallback
      this.chatPreviewBlocks = [{
        question: question.question || '',
        response: '',
        messageId: question.messageId,
        isStarred: false,
        QuestionAnswer: this.defaultQuestionAnswer
      }];
      this.guidChatId = question.messageId;
      this.selectedChatId = question.messageId;
      this.currentView = 'chat';
    }

    this.selectedMessageId = question.messageId;
    this.getChatResponse(question.messageId, true);
  }

  toggleQuestionBrowser(): void {
    if (this.currentView === 'landing') {
      this.navigateToChat();
    }
    if (this.isChatHistoryOpen) {
      this.isChatHistoryOpen = false;
    }
    if (this.isSavedQuestionsOpen) {
      this.isSavedQuestionsOpen = false;
    }
    this.isQuestionBrowserOpen = !this.isQuestionBrowserOpen;

    if (this.isQuestionBrowserOpen) {
      this.onQuestionBrowserSearch();
    }
  }

  onQuestionBrowserSearch(): void {
    this.matchedQuestions = [];
    const searchText = (this.questionBrowserSearchText || '').toLowerCase().trim();
    const searchTokens = searchText.split(/\s+/).filter(token => token.length > 0);

    if (searchTokens.length === 0) {
      this.allChatList.forEach(chat => {
        if (chat.ChatHistory) {
          chat.ChatHistory.forEach(h => {
            if (h.Question) {
              this.matchedQuestions.push({
                question: h.Question,
                messageId: h.MessageId,
                chatTitle: chat.ChatTitle,
                createdAt: h.CreatedAt
              });
            }
          });
        }
      });
    } else {
      this.allChatList.forEach(chat => {
        if (chat.ChatHistory) {
          chat.ChatHistory.forEach(h => {
            if (this.matchesAllTokens(h.Question || '', searchTokens)) {
              this.matchedQuestions.push({
                question: h.Question,
                messageId: h.MessageId,
                chatTitle: chat.ChatTitle,
                createdAt: h.CreatedAt
              });
            }
          });
        }
      });
    }
  }

  closeChatHistory(): void {
    this.isChatHistoryOpen = false;
  }

  closeSavedQuestions(): void {
    this.isSavedQuestionsOpen = false;
  }

  toggleChatArea(): void {
    this.isChatAreaVisible = !this.isChatAreaVisible;
  }

  onSendMessage(): void {
    if (this.arktabaccess) {
      console.warn('[SEND GUARD] Cannot send new message - previous question still processing');
      return;
    }

    if (this.searchText && this.searchText.trim()) {
      this.inputValue = this.searchText.trim();
      this.isNewChatSession = false;
      this.selectedMessageId = null;
      this.sendInputMessage();
      this.searchText = '';
      this.scrollToBottom();
    }
  }

  scrollToBottom(): void {
    setTimeout(() => {
      if (this.chatHistoryScroll && this.chatHistoryScroll.nativeElement) {
        const element = this.chatHistoryScroll.nativeElement;
        element.scrollTop = element.scrollHeight;
      }
    }, 100);
  }

  toggleView(): void {
    this.isListView = !this.isListView;
  }

  trackByIndex(index: number): number {
    return index;
  }

  getGridImage(index: number): string {
    const imageNumber = (index % 6) + 1;
    return `url('/assets/ImagesAskme/Grid_${String(imageNumber).padStart(2, '0')}.jpg')`;
  }

  truncateText(text: string, maxLength: number = 150): string {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength).trim() + '...';
  }

  navigateToChat(): void {
    this.currentView = 'chat';
    this.isNewChatSession = false;
  }

  navigateToLanding(): void {
    if (this.guidChatId) {
      this.abandoningSessionId = this.guidChatId;
      this.isNewChatStarted = true;
    }
    this.currentView = 'landing';
    this.chatPreviewBlocks = [];
    this.guidChatId = '';
    this.validatedSessionId = '';
    this.newChatId = null;
    this.selectedChatId = null;
    this.selectedMessageId = null;
    this.inputValue = '';
    this.searchText = '';
    this.isNewChatSession = true;
  }

  onCloseChatHistory(): void {
    this.isClosing = true;
    setTimeout(() => {
      this.closeChatHistory();
      this.isClosing = false;
    }, 300);
  }

  onBackClickChatHistory(): void {
    this.onCloseChatHistory();
  }

  toggleAccordion(item: any): void {
    item.isExpanded = !item.isExpanded;
  }

  onChatHeaderQuestionClick(item: any): void {
    this.isChatHistoryOpen = false;
    if (item.mainQuestionMessageId) {
      this.getChatResponse(item.mainQuestionMessageId);
    }
  }

  onCloseSavedQuestions(): void {
    this.isClosing = true;
    setTimeout(() => {
      this.closeSavedQuestions();
      this.isClosing = false;
    }, 300);
  }

  onBackClickSavedQuestions(): void {
    this.onCloseSavedQuestions();
  }

  onSearchSubmit(): void {
    const searchQuery = this.searchForm.get('query')?.value;
    if (searchQuery && searchQuery.trim()) {
      // Guard: Prevent sending new message while previous question is still processing
      if (this.arktabaccess) {
        console.warn('[SEND GUARD] Cannot send search query - previous question still processing');
        return;
      }

      this.inputValue = searchQuery.trim();
      this.currentView = 'chat';
      this.selectedMessageId = null;
      this.sendInputMessage();
      this.searchForm.patchValue({ query: '' });
    }
  }

  configChanges(data: any, study: any) {
    let comparisionpoint;
    let confidenceLevel;
    let weights;
    let dataFormat;
    data = data.filter((a: any) => a.study === study);
    if (data.length > 0) {
      if (data[0].comparison_point.length > 0) {
        const isNoneKeyPresent = data[0].comparison_point.some(
          (itemConst: any) => itemConst.key === 'None'
        );
        if (!isNoneKeyPresent) {
          data[0].comparison_point.unshift({ key: 'None', value: true });
        }
        comparisionpoint = data[0].comparison_point.filter(
          (a: Config) => a.value
        );
      }

      if (data[0].confidence_level.length > 0) {
        confidenceLevel = data[0].confidence_level.filter(
          (a: Config) => a.value
        );
      }

      if (data[0].weight.length > 0) {
        weights = data[0].weight.filter((a: any) => a.is_selected);
      }

      if (data[0].dataformat.length > 0) {
        dataFormat = data[0].dataformat.filter((a: any) => a.value);
      }
      this.aggregatedVariables = data[0].aggregatedvariables;
    }
  }

  Summary() {
    const content =
      this.inforRibbon != undefined
        ? this.inforRibbon.nativeElement.textContent
        : '';
    return content;
  }

  private getOrchestrationRequest(): Observable<any> {
    return from(this.getBearerToken()).pipe(
      tap(token => this.currentOrchToken = token),
      switchMap(token => {
        const modules = this.modulesAccess || {};

        const findModuleAccess = (searchKey: string) => {
          const actualKey = Object.keys(modules).find(k => k.toLowerCase() === searchKey.toLowerCase());
          return actualKey ? modules[actualKey]?.has_access : false;
        };

        const hasSnapshot = findModuleAccess('snapshot');
        const hasCrosstab = findModuleAccess('crosstab');
        const hasBrandAnalysis = findModuleAccess('brand_analysis') || findModuleAccess('brandanalysis');

        const activeCount = [hasSnapshot, hasCrosstab, hasBrandAnalysis].filter(v => v).length;
        this.hasSnapshotActive = hasSnapshot;
        this.hasCrosstabActive = hasCrosstab;
        this.hasBrandAnalysisActive = hasBrandAnalysis;


        // CASE 1: Single Module Access (Direct Specialized Call)
        if (activeCount === 1) {
          if (hasSnapshot) {
            return this.apiService.snapshotAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, this.inputValue, true, false, true, 0);
          } else if (hasCrosstab) {
            return this.apiService.crosstabAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, this.inputValue, true, false, true, 0);
          } else if (hasBrandAnalysis) {
            return this.apiService.brandAnalysisAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, this.inputValue, true, false, true, 0);
          }
        }

        // CASE 2: Multi-Module Access (Mcode Decider Strategy)
        if (activeCount > 1) {

          return new Observable(observer => {
            const decider$ = this.apiService.mcodeChatAgentStream(
              this.selected_client, this.selected_study, this.guidChatId, token, this.inputValue,
              true, false, hasSnapshot, hasCrosstab, hasBrandAnalysis, true, 0
            ).pipe(shareReplay(1));

            // Helper to execute FULL lifecycle (Stream + Payload) for a module
            const executeTask = (mcode: number, query: string): Observable<any> => {
              const stream$ = mcode === 1 ? this.apiService.snapshotAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, query, true, false, true, 0) :
                (mcode === 2 ? this.apiService.brandAnalysisAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, query, true, false, true, 0) :
                  this.apiService.crosstabAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, query, true, false, true, 0));

              return new Observable(obs => {
                let streamMetadata: any = null;
                const sSub = stream$.subscribe({
                  next: (event) => {
                    if (event && event.event === 'final_result') {
                      streamMetadata = event;
                    } else if (event && event.event !== 'done' && event.event !== 'meta') {
                      obs.next(event); // UI Status updates
                    }
                  },
                  error: (err) => obs.error(err),
                  complete: () => {
                    if (!streamMetadata) {
                      obs.error(`Stream ${mcode} result missing`);
                      return;
                    }

                    const rawData = streamMetadata.data;
                    const resData = rawData.result || rawData.final_output || rawData;
                    const payloadParams = {
                      client_name: rawData.client_name, study: rawData.study, session_id: rawData.session_id,
                      bearer_token: token, mcode: mcode, significance: "None", confidence_level: "None",
                      base: "ANSWER", weight: "Weight"
                    };

                    let specialized: any = null;
                    if (mcode === 1) {
                      specialized = { ...payloadParams, snapshot_type: resData.snapshot_type || resData.Snapshot_Type, primary_brands: resData.Primary_Brands || resData.primary_brands, primary_metrics: resData.Primary_Metrics || resData.primary_metrics || resData.primary_metircs, market: resData.Markets || resData.market, timeperiod: resData.Time_Period || resData.timeperiod, Filter_Audience: resData.Filter_Audience || resData.filter_audience, Metric_Filters: resData.Metric_Filters || resData.metric_filters, Snapshot_Name: resData.Snapshot_Name || resData.snapshot_name, Section: resData.Section || resData.section, Widget_ID: resData.Widget_ID || resData.widget_id, Widget_Name: resData.Widget_Name || resData.widget_name, selected_doc_id: resData.selected_doc_id, snapshot_index: rawData.snapshot_index, widget_snapshot_index: rawData.widget_snapshot_index };
                    } else {
                      specialized = { ...payloadParams, row: resData.Row, column: resData.Column, row_nesting: resData.Row_Nesting, column_nesting: resData.Column_Nesting, filters: resData.Filters, brand_analysis_index: rawData.brand_analysis_index, crosstab_index: rawData.crosstab_index };
                    }

                    const payload$ = mcode === 1 ? this.apiService.snapshotPayloadAPI(specialized) :
                      (mcode === 2 ? this.apiService.brandAnalysisPayloadAPI(specialized) :
                        this.apiService.crosstabPayloadAPI(specialized));

                    payload$.subscribe({
                      next: (payloadRes) => {
                        obs.next({
                          event: 'final_result',
                          mcode: mcode,
                          isPreFetched: true,
                          data: rawData, // Main metadata for sendInputMessage logic
                          payloadParams: specialized,
                          payload: payloadRes // Actual finalized data
                        });
                        obs.complete();
                      },
                      error: (err) => obs.error(err)
                    });
                  }
                });
                return () => sSub.unsubscribe();
              });
            };

            const deciderSub = decider$.subscribe({
              next: (event: any) => {
                if (event && event.event !== 'final_result') {
                  observer.next(event);
                  return;
                }

                if (event && event.event === 'final_result' && event.data) {
                  const rawData = event.data;
                  const resData = rawData.result || rawData;
                  const rankingStr = resData.priority_order || resData.mcode_ranking || '';
                  const priorityMcode = resData.priority_mcode;
                  const optimizedQuery = resData.resolved_question || resData.question || this.inputValue;

                  let mcodeRanking: number[] = [];
                  if (rankingStr && typeof rankingStr === 'string' && rankingStr.trim() !== '') {
                    const digits = rankingStr.match(/\d+/g)?.map(d => parseInt(d)) || [];
                    mcodeRanking = rankingStr.includes('=') && !rankingStr.includes('>') ? [...digits].reverse() : [...digits];
                  } else if (priorityMcode) {
                    const p = parseInt(priorityMcode.toString());
                    if (p === 1) mcodeRanking = [1, 2, 3];
                    else if (p === 2) mcodeRanking = [2, 1, 3];
                    else if (p === 3) mcodeRanking = [3, 2, 1];
                    else mcodeRanking = [p];
                  }

                  // Access Filtering + Completeness
                  mcodeRanking = mcodeRanking.filter(m => (m === 1 && hasSnapshot) || (m === 2 && hasBrandAnalysis) || (m === 3 && hasCrosstab));
                  [1, 2, 3].forEach(m => {
                    if (((m === 1 && hasSnapshot) || (m === 2 && hasBrandAnalysis) || (m === 3 && hasCrosstab)) && !mcodeRanking.includes(m)) {
                      mcodeRanking.push(m);
                    }
                  });
                  mcodeRanking = Array.from(new Set(mcodeRanking));

                  if (mcodeRanking.length === 0) { observer.error('No valid mcodes'); return; }
                  console.log('[ORCHESTRATION] Final Sequence:', mcodeRanking);

                  // Parallel Pre-fetch all Tasks
                  const taskMap: { [key: number]: Observable<any> } = {};
                  if (hasSnapshot) taskMap[1] = executeTask(1, optimizedQuery).pipe(shareReplay(1));
                  if (hasBrandAnalysis) taskMap[2] = executeTask(2, optimizedQuery).pipe(shareReplay(1));
                  if (hasCrosstab) taskMap[3] = executeTask(3, optimizedQuery).pipe(shareReplay(1));

                  Object.values(taskMap).forEach(t$ => t$.subscribe({ error: () => { } }));

                  const createChain = (rankIdx: number): Observable<any> => {
                    const mcode = mcodeRanking[rankIdx];
                    return taskMap[mcode].pipe(
                      catchError((err: any) => {
                        if (rankIdx + 1 < mcodeRanking.length) {
                          const nextMcode = mcodeRanking[rankIdx + 1];
                          const currentName = mcode === 1 ? 'Snapshot' : (mcode === 2 ? 'Brand Analysis' : 'Crosstab');
                          const nextName = nextMcode === 1 ? 'Snapshot' : (nextMcode === 2 ? 'Brand Analysis' : 'Crosstab');

                          console.warn(`[ORCHESTRATION] ${currentName} failed. Falling back to ${nextName}`);
                          this.queueStatusMessage(`${currentName} analysis failed. Trying ${nextName}...`);
                          return createChain(rankIdx + 1);
                        }
                        return throwError(() => err);
                      })
                    );
                  };

                  createChain(0).subscribe({
                    next: (val) => observer.next(val),
                    error: (err) => observer.error(err),
                    complete: () => observer.complete()
                  });
                }
              },
              error: (err: any) => {
                console.error('[ORCHESTRATION] Decider failed. Absolute fallback.');
                const fallbackRanking = [1, 2, 3].filter(m => (m === 1 && hasSnapshot) || (m === 2 && hasBrandAnalysis) || (m === 3 && hasCrosstab));
                if (fallbackRanking.length === 0) { observer.error('No access'); return; }

                const fbMap: { [key: number]: Observable<any> } = {};
                fallbackRanking.forEach(m => fbMap[m] = executeTask(m, this.inputValue).pipe(shareReplay(1)));
                Object.values(fbMap).forEach(t$ => t$.subscribe({ error: () => { } }));

                const createFbChain = (idx: number): Observable<any> => {
                  const mcode = fallbackRanking[idx];
                  return fbMap[mcode].pipe(
                    catchError((e) => {
                      if (idx + 1 < fallbackRanking.length) {
                        const nextMcode = fallbackRanking[idx + 1];
                        const currentName = mcode === 1 ? 'Snapshot' : (mcode === 2 ? 'Brand Analysis' : 'Crosstab');
                        const nextName = nextMcode === 1 ? 'Snapshot' : (nextMcode === 2 ? 'Brand Analysis' : 'Crosstab');

                        console.warn(`[ORCHESTRATION-FALLBACK] ${currentName} failed. Trying ${nextName}`);
                        this.queueStatusMessage(`${currentName} failed. Attempting ${nextName}...`);
                        return createFbChain(idx + 1);
                      }
                      return throwError(() => e);
                    })
                  );
                };

                createFbChain(0).subscribe({
                  next: (v) => observer.next(v),
                  error: (e) => observer.error(e),
                  complete: () => observer.complete()
                });
              }
            });
            return () => deciderSub.unsubscribe();
          });
        }

        // FALLBACK: If count is 0 or other logic fails
        console.log('[ORCHESTRATION] Defaulting to Snapshot.');
        return this.apiService.snapshotAgentStream(this.selected_client, this.selected_study, this.guidChatId, token, this.inputValue, true, false, true, 0);
      })
    );
  }

  private queueStatusMessage(msg: string) {
    if (msg) {
      this.statusQueue.push(msg);
      if (!this.isProcessingStatusQueue) {
        this.processNextStatus();
      }
    }
  }

  private processNextStatus() {
    if (this.statusQueue.length === 0) {
      this.isProcessingStatusQueue = false;
      return;
    }

    this.isProcessingStatusQueue = true;
    const nextMsg = this.statusQueue.shift();
    if (nextMsg) {
      this.streamStatusText = nextMsg;
      this.cdr.detectChanges();
    }

    setTimeout(() => {
      this.processNextStatus();
    }, 800); // Display each technical step for at least 800ms
  }

  populateWeightDropdown(): void {
    this.WeightDropDownList = [];
    this.weightFilter = {};

    this.configWeights?.forEach((x: any) => {
      let WeightedData = this.variableTabData.filter(
        (a: any) => a.data_variable_code === x.variable_code
      );

      if (x.variable_label === 'Unweighted') {
        this.WeightDropDownList.push({
          Label: x.variable_label,
          responseCode: x.variable_label,
          tooltip: x.variable_label,
        });

        this.weightFilter[x.variable_label] = x.variable_label;

      } else if (x.variable_label.trim() === 'Boost Factor') {
        this.WeightDropDownList.push({
          Label: x.variable_label,
          responseCode: x.variable_code,
          tooltip: x.variable_label,
        });

        this.weightFilter[x.variable_label] = x.variable_code;

      } else {
        if (WeightedData.length > 0) {
          this.WeightDropDownList.push({
            Label: WeightedData[0].Level1,
            responseCode: WeightedData[0].data_variable_code,
            tooltip: WeightedData[0].tooltip,
          });
          this.weightFilter[WeightedData[0].Level1] = WeightedData[0].data_variable_code;
        } else {
          // Fallback when variableTabData has no match: map to Primary/Secondary Weight labels
          const nonSpecialCount = this.WeightDropDownList.filter(
            (w: any) => w.Label !== 'Unweighted' && w.Label !== 'Boost Factor'
          ).length;
          const weightLabel = nonSpecialCount === 0 ? 'Primary Weight'
            : nonSpecialCount === 1 ? 'Secondary Weight'
            : `Weight ${nonSpecialCount + 1}`;
          this.WeightDropDownList.push({
            Label: weightLabel,
            responseCode: x.variable_code,
            tooltip: x.variable_label,
          });
          this.weightFilter[weightLabel] = x.variable_code;
        }
      }
    });

    if (this.WeightDropDownList.length > 0 && this.DefaultWeight == '') {
      this.DefaultWeight = this.WeightDropDownList[0].Label;
      this.selectedWeight = this.WeightDropDownList[0].responseCode;
      this._configService.weightLabel = this.DefaultWeight;
    }
  }

  isSelected(SelectedValue: string): boolean {
    return this.selectedIndex === SelectedValue;
  }

  isSelectedSignificance(SelectedValue: string): boolean {
    return this.SignificanceVsReference === SelectedValue;
  }

  // Strip parent prefix from nested child values (e.g., "Audience|Gender|Male" -> "Gender|Male")
  private normalizeNestedChildFields(data: any[]): void {
    if (!data?.length) return;
    const normalize = (val: string) => {
      if (!val) return val;
      const p = val.split('|');
      return p.length >= 3 ? p.slice(1).join('|') : val;
    };
    data.forEach(item => {
      if (item.Level1RowChild) item.Level1RowChild = normalize(item.Level1RowChild);
      if (item.Level2RowChild) item.Level2RowChild = normalize(item.Level2RowChild);
      if (item.Level1ColChild) item.Level1ColChild = normalize(item.Level1ColChild);
      if (item.Level2ColChild) item.Level2ColChild = normalize(item.Level2ColChild);
      if (item.rowChild) item.rowChild = normalize(item.rowChild);
      if (item.colChild) item.colChild = normalize(item.colChild);
    });
  }

  BindTableOutput(CrossTabOuputData: any) {
    this.CrossTabOutPutData = this.CrossTabOutPutData.filter(
      (a: CrossTabOutputItem) => a.colChild !== null
    );

    this.CrossTabOutPutData.forEach((item: CrossTabOutputItem, index: number) => {
      if (index < 5) {
      }
      const selections = TableOutputProcessorHelper.createSelections(item);
      const parents = TableOutputProcessorHelper.createParentObjects(item, selections);

      TableOutputProcessorHelper.processParent(parents.row, this.OutputdataObject.Row, selections.nested.row);
      TableOutputProcessorHelper.processParent(parents.col, this.OutputdataObject.Column, selections.nested.col);
    });
  }

  replacePipe(input: string): string {
    return SelectionSummaryHelper.replacePipe(input);
  }

  onTableIconClick() {
    this.displayTable = true;
    this.isTableClick = true;
    this.isVerticalBarChartClick = false;
    this.isVerticalGroupBarChartClick = false;
    this.isLineChartClick = false;
    this.isVerticalStackChartClick = false;
    // this.createTable(false, Feature.CrosstabOutput, false);
  }

  sortOutputData() {
    this.OutputdataObject.Row.sort((a, b) => {
      const indexA = this.dataObject.Row.findIndex(
        (item) => item.Parent === a.Parent
      );
      const indexB = this.dataObject.Row.findIndex(
        (item) => item.Parent === b.Parent
      );
      return indexA - indexB;
    });

    this.OutputdataObject.Column.sort((a, b) => {
      const indexA = this.dataObject.Column.findIndex(
        (item) => item.Parent === a.Parent
      );
      const indexB = this.dataObject.Column.findIndex(
        (item) => item.Parent === b.Parent
      );
      return indexA - indexB;
    });

    this.OutputdataObject.Row.forEach((row) => {
      const parentData = this.dataObject.Row.find(
        (item) => item.Parent === row.Parent
      );
      if (parentData) {
        row.Data.sort((a, b) => {
          const indexA = parentData.Data.findIndex(
            (data) => data.Child === a.Child
          );
          const indexB = parentData.Data.findIndex(
            (data) => data.Child === b.Child
          );
          return indexA - indexB;
        });
      }
    });

    this.OutputdataObject.Row.forEach((row) => {
      row.Data.forEach((outputSelection) => {
        this.dataObject.RowNesting.forEach((rowNest) => {
          this.sortByChildIndex(outputSelection.NestedArray, rowNest.Data);
        });
      });
    });

    this.OutputdataObject.Row.forEach((row) => {
      row.Data.forEach((outputSelection) => {
        outputSelection.NestedArray.forEach((rowNest1) => {
          this.dataObject.RowNesting.forEach((rowNest) => {
            this.sortByChildIndex(rowNest1.NestedArray, rowNest.Data);
          });
        });
      });
    });

    this.OutputdataObject.Column.forEach((column) => {
      const parentData = this.dataObject.Column.find(
        (item) => item.Parent === column.Parent
      );
      if (parentData) {
        column.Data.sort((a, b) => {
          const indexA = parentData.Data.findIndex(
            (data) => data.Child === a.Child
          );
          const indexB = parentData.Data.findIndex(
            (data) => data.Child === b.Child
          );
          return indexA - indexB;
        });
      }
    });

    this.OutputdataObject.Column.forEach((column) => {
      column.Data.forEach((outputSelection) => {
        this.dataObject.ColNesting.forEach((colNest) => {
          this.sortByChildIndex(outputSelection.NestedArray, colNest.Data);
        });
      });
    });

    this.OutputdataObject.Column.forEach((column) => {
      column.Data.forEach((outputSelection) => {
        outputSelection.NestedArray.forEach((colNest1) => {
          this.dataObject.ColNesting.forEach((colNest) => {
            this.sortByChildIndex(colNest1.NestedArray, colNest.Data);
          });
        });
      });
    });
    this.OutputdataObject = JSON.parse(JSON.stringify(this.OutputdataObject));
  }

  toggleDataBlock(block: string): void {
    this.resetChartStates('table');
    this.isLineChartClick = false;
    this.displayTable = true;
    if (!this.isVerticalGroupBarChartClick) {
      this.disableStackChart = true;
    }
    const rowdata = this.dataObject['Row'];
    const columndata = this.dataObject['Column'];
    const TimePeriodinColumn = columndata.filter(parent => parent.Data.some(child => child.isTimePeriod === true));
    const rowDataLength: number = rowdata.length > 0 ? rowdata[0].Data.length : 0;
    this.isChartView = !(this.listBItemsList.length > 0 || this.listDItemsList.length > 0 || rowdata.length < 1 || rowDataLength > this.maxColumnsPerSlide);

    if (this.isChartView) {
      const isMultiPunchRow = this.filterDataByCalculationType(rowdata, 'multipunch');
      const isMultiPunchColumn = this.filterDataByCalculationType(columndata, 'multipunch');
      const isDefaultRespGrp = this.filterDataByCalculationType(rowdata, 'respgrp');
      const isMeanMetric = this.filterDataByCalculationType(rowdata, 'mean');

      const isShareMetric = rowdata.filter((parent) => {
        return parent.Data.some((child) => child.CalculationType.toLowerCase() === 'share');
      });
      const rowDataLengthForTrend = this.getDistinctChildValues(this.OutputdataObject.Row as any);
      const isLineChartAvailable = TimePeriodinColumn.length === 1 &&
        ((isShareMetric.length > 0 || isMeanMetric.length > 0) && rowDataLengthForTrend.length <= this.maxRowsPerSlide);
      this.disableLineChart = !isLineChartAvailable;


      if (rowdata.length == 1) {
        let filteredData: any = [];
        const disctinctRowValues = this.getDistinctChildValues(this.dataObject.Row);
        const pipeParts = this.getDistinctPipeParts(disctinctRowValues);
        this.StackFlag = this.calculateStackFlag(pipeParts);

        if (this.StackFlag) {
          rowdata[0].Data.forEach((item) => {
            filteredData = this.filterByPipeLevels(item.Child);
          });
        }

        this.disableStackChart = (
          isMultiPunchRow.length > 0 ||
          isMultiPunchColumn.length > 0 ||
          isDefaultRespGrp.length > 0 ||
          isMeanMetric.length > 0
        ) ? false : (rowdata[0].Data.length !== filteredData.length);
      }
    }

    this.DefaultDataDropDown = block;
    if (block === 'Data') {
      this.isData = true;
      this.isSampleSize = false;
      this.isWeightedLabel = false;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
      this.disableLineChart = TimePeriodinColumn.length == 1 ? true : false;
    } else if (block === 'Sample Size') {
      this.isData = false;
      this.isSampleSize = true;
      this.isWeightedLabel = false;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
    } else if (block === 'Weighted Sample') {
      this.isData = false;
      this.isSampleSize = false;
      this.isWeightedLabel = true;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
    } else if (block === 'Weighted Numerator') {
      this.isData = false;
      this.isSampleSize = false;
      this.isWeightedLabel = false;
      this.isWeightedNumerator = true;
      this.isUnWeightedNumerator = false;
    } else if (block === 'Unweighted Numerator') {
      this.isData = false;
      this.isSampleSize = false;
      this.isWeightedLabel = false;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = true;
    }

    if (this.isIndex) {
      this.isChartView = false;
    }
  }

  toggleSigBlock(block: string): void {
    if (block === 'Sig') {
      this.isSig = true;
      this.isIndex = false;
      this.isChartView = true;
      this.isSampleSize = false;
      this.isWeightedLabel = false;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
      this.resetChartStates('table');
      this.is_Time_Period_Present = true;

      // When switching back to Significance from Index, ensure baseline "None" significance is processed
      if (this.mcode == 3 && this.lastCrosstabPayload) {
        this.callSignificancePayloadService("None");
      } else if (this.mcode == 2 && this.lastBrandAnalysisPayload) {
        this.callBrandAnalysisPayloadService("None");
      } else {
        this.createTable(false, Feature.CrosstabOutput, false);
      }
    } else if (block === 'Index') {
      this.displayTable = true;
      this.isData = true;
      this.isWeightedNumerator = false;
      this.isUnWeightedNumerator = false;
      this.DefaultDataDropDown = 'Data';
      this.resetChartStates('table');
      this.isSig = false;
      this.isIndex = true;
      this.isChartView = false;
      this.DefaultReferenceLevel = 'None';
      this.DefaultSampleSize = 'None';
      this.DefaultConfidenceLevel = 'None';
      this.SignificanceVsReference = '';
      this.isReference = false;
      this.selectedIndex = '';
      this.isPairWise = false;
      if (this.isTranspose) {
        this.isTranspose = false;
        this.reverseTranspose();
      }
      this.IndexData = this.getLastLevelColumnNestingValues();
    }
  }
  createTable(
    isSampleSize: boolean,
    feature: string = Feature.CrosstabOutput,
    isIndexing: boolean
  ) {
    this.variableTabData = this.crossTabService.getVarTabData || [];
    if (!this.variableTabData || this.variableTabData.length === 0) {
      console.warn('[METADATA-WARNING] variableTabData is missing in createTable. Attempting to recover...');
    }
    this.displayTable = true;
    this.isDemoStudy = false;
    this.isSig = isIndexing ? false : true;
    this.isIndex = isIndexing ? true : false;
    this.referenceLevelDropDown = false;
    this.DefaultReferenceLevel = isIndexing
      ? this.DefaultReferenceLevel
      : 'None';
    this.selectedIndex = isIndexing ? this.selectedIndex : '';
    const rowdata = this.OutputdataObject && this.OutputdataObject.Row?.length > 0 ? this.OutputdataObject.Row : this.dataObject['Row'];
    const RowNesting = this.dataObject['RowNesting'];
    const columndata = this.OutputdataObject && this.OutputdataObject.Column?.length > 0 ? this.OutputdataObject.Column : this.dataObject['Column'];
    const ColNesting = this.dataObject['ColNesting'];
    const Filter = this.dataObject['Filter'];
    let isTimePeriodPresent = (this.variableTabData || []).filter(
      (a: any) => a.is_time_Period_Present === true
    );
    const columnDataLength: number =
      columndata.length > 0 ? columndata.length : 0;
    let isDimensionPresent = (this.variableTabData || []).filter(
      (a: any) => a.is_dimension_Present === true
    );

    this.is_Time_Period_Present =
      isTimePeriodPresent.length == 0 ? false : true;
    this.is_dimension_Present = isDimensionPresent.length == 0 ? false : true;
    this.is_indexingShow =
      this.selectedDataFormat == 'Respondent Level' && this.is_indexing
        ? columnDataLength > 1
          ? false
          : true
        : false;
    this.isDisableReference = columnDataLength > 1 ? true : false;
    const TimePeriodinColumn = ((columndata as any[]) || []).filter((parent: any) => {
      return (parent.Data || []).some((child: any) => child.isTimePeriod === true || child.isTimePeriod === 'true');
    });

    const isDefaultRespGrp = this.filterDataByCalculationType(rowdata as any, 'respgrp');
    const isMeanMetric = this.filterDataByCalculationType(rowdata as any, 'mean');
    const isMultiPunchRow = this.filterDataByCalculationType(rowdata as any, 'multipunch');
    const isMultiPunchColumn = this.filterDataByCalculationType(columndata as any, 'multipunch');
    const rowDataLength: number =
      rowdata.length > 0 ? rowdata[0].Data.length : 0;
    const rowNestDataLength: number =
      RowNesting.length > 0 ? RowNesting[0].Data.length : 0;
    const colNestDataLength: number =
      ColNesting.length > 0 ? ColNesting[0].Data.length : 0;
    this.isChartView =
      rowNestDataLength > 0 ||
        colNestDataLength > 0 ||
        rowdata.length < 1 ||
        rowDataLength > 15
        ? false
        : true;
    if (this.isChartView) {
      this.disableLineChart = TimePeriodinColumn.length === 1 ? false : true;

      if (rowdata.length == 1) {
        let filteredData: any = [];
        const disctinctRowValues = this.getDistinctChildValues(this.dataObject.Row);
        const pipeParts = this.getDistinctPipeParts(disctinctRowValues);
        this.StackFlag = this.calculateStackFlag(pipeParts);

        if (this.StackFlag) {
          rowdata[0].Data.forEach((item) => {
            filteredData = this.filterByPipeLevels(item.Child);
          });
        }

        this.disableStackChart = (
          isMultiPunchRow.length > 0 ||
          isMultiPunchColumn.length > 0 ||
          isDefaultRespGrp.length > 0 ||
          isMeanMetric.length > 0
        ) ? false : (rowdata[0].Data.length !== filteredData.length);
      }
    }
    if (isSampleSize) {
      this.isLineChartClick = this.isLineChartClick || this.isTableClick;
      this.isVerticalGroupBarChartClick =
        this.isVerticalGroupBarChartClick || this.isTableClick;
      this.isVerticalBarChartClick =
        this.isVerticalBarChartClick || this.isTableClick;
      this.isVerticalStackChartClick =
        this.isVerticalStackChartClick || this.isTableClick;
      this.isTableClick = false;
      this.displayTable = !(
        this.isLineChartClick ||
        this.isVerticalGroupBarChartClick ||
        this.isVerticalStackChartClick
      );
      this.isData = !(
        this.isLineChartClick ||
        this.isVerticalGroupBarChartClick ||
        this.isVerticalStackChartClick
      );
    } else {
      this.isTableClick = false;
      this.isLineChartClick = false;
      this.isVerticalGroupBarChartClick = false;
      this.isVerticalBarChartClick = false;
      this.isVerticalStackChartClick = false;
      this.isData = true;
      this.DefaultDataDropDown = DEFAULT_VALUES.DATA;
      this.isTranspose = false;
      this.displayTable = true;
      this.isTotal = this.isIndex ? this.isTotal : false;
      if (
        this.dataObject.ColNesting.length === 0 &&
        this.dataObject.Column.length === 1 &&
        this.dataObject.Column[0].Data.length <= 10
      )
        this.isDisablePairWise = false;
    }
    this.isSampleSize = false;
    this.isWeightedLabel = false;
    this.sampleSizeDropdown = false;
    this.confidenceLevelDropDown = false;

    const matchColumnFound = this.isLevel1TimePeriodPresent(
      this.listCItemsList
    );
    const matchColumnNestFound = this.isLevel1TimePeriodPresent(
      this.listDItemsList
    );
    const matchFilterNestFound = this.isLevel1TimePeriodPresent(
      this.listEItemsList
    );

    const matchColumnDimension = this.isDimensionPresent(this.listCItemsList);

    const matchColumnNestDimension = this.isDimensionPresent(
      this.listDItemsList
    );

    const matchFilterDimension = this.isDimensionPresent(this.listEItemsList);

    const distinctValuesForListA = this.getDistinctLevel0Values(
      this.listAItemsList
    );

    const distinctValuesForListC = this.getDistinctLevel0Values(
      this.listCItemsList
    );
    const distinctValuesForListD = this.getDistinctLevel0Values(
      this.listDItemsList
    );
    const distinctValuesForListE = this.getDistinctLevel0Values(
      this.listEItemsList
    );

    const allDistinctValues = [
      ...distinctValuesForListC,
      ...distinctValuesForListD,
      ...distinctValuesForListE,
    ];

    const allDistinctValueAggregated = [
      ...distinctValuesForListA,
      ...distinctValuesForListC,
      ...distinctValuesForListD,
      ...distinctValuesForListE,
    ];

    const distinctEntryList = this.getDistinctENtryList(this.entryList);

    const distinctAggregatedMetric = this.getDistinctAggregaredMetrics(
      this.variableTabData
    );

    const allEntryListPresent = distinctEntryList.every((entry) =>
      allDistinctValues.includes(entry)
    );

    const allEntryListPresentAggregated = distinctAggregatedMetric.every(
      (entry) => allDistinctValueAggregated.includes(entry)
    );

    const matchingCount = distinctEntryList.filter((entry) =>
      allDistinctValues.includes(entry)
    ).length;

    let Isshowpopup = false;

    if (Isshowpopup == false) {

      this.SelectionSummary();
      this.isCreateBtnClick = true;
      this.clearOutputDataObject();
      this._loaderService.showLoader();
      var weightColumnName: string = '';
      var isBoostFactor: boolean = false;

      if (this.DefaultWeight.trim() == 'Boost Factor') {
        weightColumnName = this.WeightDropDownList[0].responseCode;
        isBoostFactor = true;
      }

      var istimePeriodWave = this.isWaveTimePeriod();
      this.AssignDataToPreviousDataObject(this.dataObject);

      this.$unSubscribeSubmitData4 = this.crossTabService
        .getOutPutData(
          this.previewDataObject,
          this.selected_client,
          this.selected_study,
          this.DefaultSampleSize,
          this.isFilteringActive,
          this.DefaultConfidenceLevel,
          this.isTotalBase,
          this.selectedWeight,
          weightColumnName,
          isBoostFactor,
          this.SignificanceVsReference,
          this.columnLength,
          this.dataArray,
          this.isBrandAnalysis,
          this.isAggregatedData,
          this.isSemiAggregatedData,
          this.isRespondentLevel,
          this.aggregatedVariables,
          istimePeriodWave,
          this.isTotal
        )
        .subscribe((result: results) => {
          if (result.HasValidData) {
            let JsonData = JSON.parse(result.Data);
            this.isReference = false;
            this.CrossTabOutPutEntireData = JsonData;
            this.normalizeNestedChildFields(this.CrossTabOutPutEntireData);
            let chartType = 'column';
            chartType = this.isTranspose ? 'column' : 'bar';
            if (this.CrossTabOutPutEntireData.length > 0) {
              this.CrossTabOutPutData = this.CrossTabOutPutEntireData;
              if (!this.isTotal)
                this.CrossTabOutPutData = this.CrossTabOutPutEntireData.filter(
                  (x: any) => {
                    return !x.isTotal;
                  }
                );
              if (this.isIndex && this.selectedIndex != '') {
                this.manipulateIndexData();
              }
              this.BindTableOutput(this.CrossTabOutPutData);
              this.sortOutputData();

              if (this.isTranspose) {
                this.handleOutputdataObjectOnTransposeSelect();
              }
              this.crossTabService.setCrossTabOuputData(
                this.CrossTabOutPutData
              );

              if (this.isLineChartClick) {
                this.onTrendChartIconClick();
              } else if (
                this.isVerticalGroupBarChartClick ||
                this.isVerticalBarChartClick
              ) {
                this.VerticalChartClick(chartType);
              } else if (this.isVerticalStackChartClick) {
                this.onVerticalStackBarChartIconClick(chartType);
              }
            }
          }
          this.usageDataLog(feature);
          this._loaderService.hideLoader();
        });
    }

    if (columnDataLength > 1) this.isDisableReference = true;
    else this.isDisableReference = false;
  }

  usageDataLog(feature: string) {
    let summarytext = '';
    if (this.summaryText != undefined && this.summaryText != null)
      summarytext = this.summaryText?.nativeElement.innerText;
    else summarytext = this.selectionSummary.replace(/<[^>]*>/g, '');
    this._usermanagementService.UsageData(
      COMMON_CONSTANTS.DataExplorerModuleId.toString(),
      this.selected_client,
      this.selected_study,
      feature,
      summarytext,
      ''
    );
  }

  AssignDataToPreviousDataObject(dataObject: DataObject) {
    this.previewDataObject.Row = dataObject.Row;
    this.previewDataObject.Column = dataObject.Column;
    this.previewDataObject.ColNesting = dataObject.ColNesting;
    this.previewDataObject.RowNesting = dataObject.RowNesting;
    this.previewDataObject.Filter = dataObject.Filter;
  }

  private isWaveTimePeriod() {
    if (
      this.mandatoryVariableMapping == undefined ||
      this.mandatoryVariableMapping == null
    )
      return false;
    else {
      let timePeriodEntries: any = this.mandatoryVariableMapping.filter(
        (entry: any) =>
          entry.variable_label === 'Time Period' &&
          entry.variable_code &&
          entry.variable_code.trim() !== ''
      );

      let isWaveTimePeriod =
        timePeriodEntries.length === 0 ||
        timePeriodEntries.every(
          (entry: any) =>
            entry.variable_code === timePeriodEntries[0].variable_code
        );

      return isWaveTimePeriod;
    }
  }

  clearOutputDataObject(): void {
    this.OutputdataObject = {
      Row: [],
      Column: [],
    };
    this.FinalOutputdataObject = {
      Row: [],
      Column: [],
    };
  }

  getDistinctAggregaredMetrics(list: any[]) {
    return DataTransformersHelper.getDistinctAggregaredMetrics(list);
  }

  getDistinctENtryList(list: any[]) {
    return DataTransformersHelper.getDistinctENtryList(list);
  }
  // Utility Methods
  private tokenizeSearchText(searchText: string): string[] {
    return DataTransformersHelper.tokenizeSearchText(searchText);
  }

  private matchesAllTokens(text: string, tokens: string[]): boolean {
    return DataTransformersHelper.matchesAllTokens(text, tokens);
  }

  private filterByVariableCode(dataArray: any[], variableCode: string, responseCode?: string): any[] {
    return DataTransformersHelper.filterByVariableCode(this.variableTabData, variableCode, responseCode);
  }

  private getDistinctValues<T, K extends keyof T>(list: T[], key: K): T[K][] {
    return DataTransformersHelper.getDistinctValues(list, key);
  }

  getDistinctLevel0Values(list: any[]) {
    return DataTransformersHelper.getDistinctLevel0Values(list);
  }

  getDistinctLevel1Values(list: any[]) {
    return DataTransformersHelper.getDistinctLevel1Values(list);
  }

  private sortByChildIndex(items: any[], referenceData: any[]): void {
    DataTransformersHelper.sortByChildIndex(items, referenceData);
  }

  private filterByPipeLevels(child: string): any[] {
    if (!this.variableTabData || this.variableTabData.length === 0) {
      this.variableTabData = this.crossTabService.getVarTabData || [];
    }
    return ChartUtilitiesHelper.filterByPipeLevels(child, this.variableTabData || []);
  }

  private resetChartStates(activeChart?: 'table' | 'line' | 'bar' | 'stack' | 'groupBar'): void {
    this.isTableClick = activeChart === 'table';
    this.isLineChartClick = activeChart === 'line';
    this.isVerticalBarChartClick = activeChart === 'bar';
    this.isVerticalStackChartClick = activeChart === 'stack';
    this.isVerticalGroupBarChartClick = activeChart === 'groupBar';
  }

  private getShareNumber(item: CrossTabOutputItem): number | null {
    // Hardcoded to Answer base and 'Weight' as per user request
    return ChartUtilitiesHelper.getShareNumber(item, false, 'Weight');
  }

  private calculatePercentageValue(shareNumber: number | null, item: CrossTabOutputItem): number | string {
    return ChartUtilitiesHelper.calculatePercentageValue(shareNumber, item);
  }

  private getChangeVsPY(item: CrossTabOutputItem): number | string {
    // Hardcoded to Answer base as per user request
    return ChartUtilitiesHelper.getChangeVsPY(item, false);
  }

  private getSignificanceString(item: CrossTabOutputItem): string {
    // Hardcoded to Answer base as per user request
    return ChartUtilitiesHelper.getSignificanceString(item, false);
  }

  private getSampleSizeString(item: CrossTabOutputItem): string {
    // Hardcoded to Answer base as per user request, with fallback for nulls to avoid 'I/S'
    const s = ChartUtilitiesHelper.getSampleSizeString(item, false);
    return s === '0' ? (item.totalUnweightedBase?.toString() || '999') : s;
  }

  private getDistinctChildValuesFormatted(dataObject: checkboxSelectionWithParent[]): string[] {
    return ChartUtilitiesHelper.getDistinctChildValuesFormatted(dataObject);
  }

  private filterDataByCalculationType(data: checkboxSelectionWithParent[], type: 'multipunch' | 'respgrp' | 'mean'): checkboxSelectionWithParent[] {
    return ChartUtilitiesHelper.filterDataByCalculationType(data || [], type);
  }

  private initializeChartData(chart: LineChart | StackChart | GroupBarChart): void {
    ChartUtilitiesHelper.initializeChartData(chart);
  }

  private sortChartDataBySeriesName(chartData: any[], distinctRowChildValues: string[]): void {
    ChartUtilitiesHelper.sortChartDataBySeriesName(chartData, distinctRowChildValues);
  }

  private getDistinctPipeParts(rowValues: string[]): { first: string[], second: string[], third: string[], fourth: string[], fifth: string[] } {
    return ChartUtilitiesHelper.getDistinctPipeParts(rowValues);
  }

  private calculateStackFlag(parts: { first: string[], second: string[], third: string[], fourth: string[], fifth: string[] }): boolean {
    return ChartUtilitiesHelper.calculateStackFlag(parts);
  }

  private getDistinctColumnChildValues(): string[] {
    return ChartUtilitiesHelper.getDistinctColumnChildValues(this.OutputdataObject as any);
  }

  isDimensionPresent(list: any[]): boolean {
    return DataTransformersHelper.isDimensionPresent(list);
  }

  isLevel1TimePeriodPresent(list: any[]): boolean {
    return DataTransformersHelper.isLevel1TimePeriodPresent(list);
  }

  getLastLevelColumnNestingValues() {
    var indexData;
    if (this.OutputdataObject.Column.length > 0) {
      if (this.OutputdataObject['Column'][0]['Data'].length > 0) {
        let firstLevelLength =
          this.OutputdataObject['Column'][0]['Data'].length;

        if (firstLevelLength > 0) {
          let level0 =
            this.OutputdataObject['Column'][0]['Data'][firstLevelLength - 1];
          if (level0.NestedArray.length > 0) {
            let secondLevelLength = level0.NestedArray.length;
            if (secondLevelLength > 0) {
              let level1 = level0.NestedArray[secondLevelLength - 1];

              if (level1.NestedArray.length > 0) {
                let finalData =
                  this.OutputdataObject['Column'][0]['Data'][
                    firstLevelLength - 1
                  ].NestedArray[secondLevelLength - 1].NestedArray;
                indexData = finalData;
                this.columnLength = 2;
              } else {
                indexData = level0.NestedArray;
                this.columnLength = 1;
              }
            }
          } else {
            indexData = this.OutputdataObject['Column'][0]['Data'];
            this.columnLength = 0;
          }
        }
      }
    }

    return indexData;
  }

  SelectionSummary() {
    const disctinctRowValues = this.getDistinctChildValues(this.dataObject.Row);
    const disctinctRowNestingValues = this.getDistinctChildValues(
      this.dataObject.RowNesting
    );
    const disctinctColumnValues = this.getDistinctChildValues(
      this.dataObject.Column
    );
    const disctinctColumnNestingValues = this.getDistinctChildValues(
      this.dataObject.ColNesting
    );
    const FilterValues = this.getDistinctChildValues(this.dataObject.Filter);

    const RowValues = this.transformData(disctinctRowValues);
    const RowNestingValues = this.transformData(disctinctRowNestingValues);
    const ColumnValues = this.transformData(disctinctColumnValues);
    const ColumnNestingValues = this.transformData(
      disctinctColumnNestingValues
    );
    const FilterData = this.transformData(FilterValues);
    this.BindSelectionSummary(
      RowValues,
      RowNestingValues,
      ColumnValues,
      ColumnNestingValues,
      FilterData,
      false
    );
  }

  BindSelectionSummary(
    RowValues: string[],
    RowNestingValues: string[],
    ColumnValues: string[],
    ColumnNestingValues: string[],
    FilterData: string[],
    isSavedSelection: boolean
  ) {
    this.selectionSummary = SelectionSummaryHelper.buildSelectionSummaryText(
      RowValues,
      RowNestingValues,
      ColumnValues,
      ColumnNestingValues,
      FilterData,
      isSavedSelection,
      {
        selectedDataFormat: this.selectedDataFormat,
        DefaultSampleSize: this.DefaultSampleSize,
        SignificanceVsReference: this.SignificanceVsReference,
        DefaultConfidenceLevel: this.DefaultConfidenceLevel,
        selectedIndex: this.selectedIndex,
        isIndex: this.isIndex,
        DefaultWeight: this.DefaultWeight,
        isTotalBase: this.isTotalBase,
        selected_study: this.selected_study,
        isFilteringActive: this.isFilteringActive,
        BASE_TYPES: BASE_TYPES
      }
    );
  }

  transformData(dataList: string[]): string[] {
    return SelectionSummaryHelper.transformData(dataList);
  }

  reverseTranspose() {
    if (
      this.OutputdataObject != null &&
      (this.OutputdataObject['Row'].length > 0 ||
        this.OutputdataObject['Column'].length > 0)
    ) {
      let tempRow = [...this.OutputdataObject.Column];
      let tempColumn = [...this.OutputdataObject.Row];
      this.OutputdataObject.Row = [...tempRow];
      this.OutputdataObject.Column = [...tempColumn];
    }
  }

  async SampleSizeDropDownClick(SelectedValue: string) {
    this.isPairWise = false;
    this.isReference = false;

    if (SelectedValue == 'Reference') {
      this.isReference = true;

      this.IndexData = this.getLastLevelColumnNestingValues();
    } else {
      this.SignificanceVsReference = '';
      this.isReference = false;
      this.DefaultDataDropDown = 'Data';
      this.DefaultSampleSize = SelectedValue;
      const isPreviousYear = SelectedValue === 'Previous Year' || (SelectedValue && SelectedValue.includes('Previous Year'));
      const isPreviousPeriod = SelectedValue === 'Previous Period' || (SelectedValue && SelectedValue.includes('Previous Period'));
      const isNone = SelectedValue === 'None';

      console.log('[SIGNIFICANCE-DEBUG] SampleSizeDropDownClick Evaluation:', {
        SelectedValue,
        isPreviousYear,
        isPreviousPeriod,
        isNone,
        currentMcode: this.mcode,
        hasCrosstabPayload: !!this.lastCrosstabPayload
      });

      if (isNone) {
        this.DefaultConfidenceLevel = 'None';
      }

      // Specialized Payload Service Call for "Previous Year", "Previous Period" or "None" (Crosstab)
      if ((isPreviousYear || isPreviousPeriod || isNone) && this.mcode == 3 && this.lastCrosstabPayload) {
        console.log('[SIGNIFICANCE-DEBUG] Triggering specialized crosstabPayloadService call');
        this.sampleSizeDropdown = false;
        const significanceType = isNone ? "None" : (isPreviousYear ? "Previous Year" : "Previous Period");
        this.callSignificancePayloadService(significanceType);
        return;
      }

      // Specialized Payload Service Call for "Previous Year", "Previous Period" or "None" (Brand Analysis)
      if ((isPreviousYear || isPreviousPeriod || isNone) && this.mcode == 2 && this.lastBrandAnalysisPayload) {
        console.log('[SIGNIFICANCE-DEBUG] Triggering specialized brandAnalysisPayloadService call');
        this.sampleSizeDropdown = false;
        const significanceType = isNone ? "None" : (isPreviousYear ? "Previous Year" : "Previous Period");
        this.callBrandAnalysisPayloadService(significanceType);
        return;
      }

      if (SelectedValue == 'None') {
        this.DefaultConfidenceLevel = 'None';
      } else if (SelectedValue == 'Pairwise') {
        this.DefaultConfidenceLevel =
          this.is_confidenceLevel.length > 0
            ? this.is_confidenceLevel[0]['key']
            : '95%';
        this.isPairWise = true;
      } else {
        this.DefaultConfidenceLevel =
          this.is_confidenceLevel.length > 0
            ? this.is_confidenceLevel[0]['key']
            : '95%';
      }
      this.sampleSizeDropdown = false;
      this.createTable(true, Feature.Significance, false);
    }
  }

  processPayloadServiceResponse(res: any) {
    if (res && res.response) {
      let resultData = res.response;

      // The backend might return a result object that has a 'Data' string or direct object
      let parsedData: any[] = [];
      try {
        if (resultData.Data) {
          parsedData = typeof resultData.Data === 'string' ? JSON.parse(resultData.Data) : resultData.Data;
        } else {
          parsedData = typeof resultData === 'string' ? JSON.parse(resultData) : resultData;
        }
      } catch (e) {
        console.error('Error parsing response data:', e);
        return;
      }

      if (!Array.isArray(parsedData)) {
        console.error('Response data is not an array:', parsedData);
        return;
      }

      this.CrossTabOutPutEntireData = parsedData;
      this.normalizeNestedChildFields(this.CrossTabOutPutEntireData);
      this.CrossTabOutPutData = this.isTotal
        ? this.CrossTabOutPutEntireData
        : this.CrossTabOutPutEntireData.filter((x: any) => !x.isTotal);

      this.BindTableOutput(this.CrossTabOutPutData);
      this.sortOutputData();

      if (this.isTranspose) {
        this.handleOutputdataObjectOnTransposeSelect();
      }

      this.crossTabService.setCrossTabOuputData(this.CrossTabOutPutData);

      // Trigger chart updates
      const chartType = this.isTranspose ? 'column' : 'bar';
      if (this.isLineChartClick) {
        this.onTrendChartIconClick();
      } else if (this.isVerticalGroupBarChartClick || this.isVerticalBarChartClick) {
        this.VerticalChartClick(chartType);
      } else if (this.isVerticalStackChartClick) {
        this.onVerticalStackBarChartIconClick(chartType);
      }
    }
  }

  async confidenceDropDownClick(SelectedValue: string) {
    this.DefaultConfidenceLevel = SelectedValue;
    this.confidenceLevelDropDown = false;
    this.DefaultDataDropDown = 'Data';

    const isPreviousYear = this.DefaultSampleSize === 'Previous Year' || (this.DefaultSampleSize && this.DefaultSampleSize.includes('Previous Year'));
    const isPreviousPeriod = this.DefaultSampleSize === 'Previous Period' || (this.DefaultSampleSize && this.DefaultSampleSize.includes('Previous Period'));
    const isNone = this.DefaultSampleSize === 'None';

    if ((isPreviousYear || isPreviousPeriod || isNone) && this.mcode == 3 && this.lastCrosstabPayload) {
      const significanceType = isNone ? "None" : (isPreviousYear ? "Previous Year" : "Previous Period");
      this.callSignificancePayloadService(significanceType);
      return;
    }

    if ((isPreviousYear || isPreviousPeriod || isNone) && this.mcode == 2 && this.lastBrandAnalysisPayload) {
      const significanceType = isNone ? "None" : (isPreviousYear ? "Previous Year" : "Previous Period");
      this.callBrandAnalysisPayloadService(significanceType);
      return;
    }

    this.createTable(true, Feature.ConfidenceLevel, false);
  }

  async callSignificancePayloadService(significanceType: string) {
    this._loaderService.showLoader();
    try {
      const token = await this.getBearerToken();
      const payload = {
        bearer_token: token,
        session_id: this.guidChatId,
        client_name: this.selected_client,
        study: this.selected_study,
        payload: this.lastCrosstabPayload,
        Significance: significanceType,
        SignificanceVsReference: "",
        "Confidence Level": this.DefaultConfidenceLevel,
        Base: "Answer Base",
        Weight: "Weight"
      };

      this.apiService.crosstabPayloadService(payload).subscribe({
        next: (res: any) => {
          this.processPayloadServiceResponse(res);
          this._loaderService.hideLoader();
        },
        error: (err: any) => {
          console.error('Error calling crosstab-payload-service:', err);
          this._loaderService.hideLoader();
        }
      });
    } catch (e) {
      console.error('Exception in Significance specialized call:', e);
      this._loaderService.hideLoader();
    }
  }

  async callBrandAnalysisPayloadService(significanceType: string) {
    this._loaderService.showLoader();
    try {
      const token = await this.getBearerToken();
      const payload = {
        bearer_token: token,
        session_id: this.guidChatId,
        client_name: this.selected_client,
        study: this.selected_study,
        payload: this.lastBrandAnalysisPayload,
        Significance: significanceType,
        SignificanceVsReference: "",
        "Confidence Level": this.DefaultConfidenceLevel,
        Base: "Answer Base",
        Weight: "Weight"
      };

      console.log('[SIGNIFICANCE-DEBUG] Calling brandAnalysisPayloadService with payload:', {
        significanceType,
        confidenceLevel: this.DefaultConfidenceLevel,
        hasBrandAnalysisPayload: !!this.lastBrandAnalysisPayload
      });

      this.apiService.brandAnalysisPayloadService(payload).subscribe({
        next: (res: any) => {
          this.processPayloadServiceResponse(res);
          this._loaderService.hideLoader();
        },
        error: (err: any) => {
          console.error('Error calling brand-analysis-payload-service:', err);
          this._loaderService.hideLoader();
        }
      });
    } catch (e) {
      console.error('Exception in Brand Analysis Significance specialized call:', e);
      this._loaderService.hideLoader();
    }
  }

  referenceDropDownClickIndexSignificance(SelectedValue: string) {
    this.SignificanceVsReference = SelectedValue;
    this.DefaultConfidenceLevel =
      this.is_confidenceLevel.length > 0
        ? this.is_confidenceLevel[0]['key']
        : '95%';
    this.DefaultSampleSize = 'Reference';
    this.DefaultDataDropDown = 'Data';
    this.createTable(true, Feature.Significance, false);
  }

  referenceDropDownClick(SelectedValue: string) {
    this.DefaultReferenceLevel = this.replacePipe(SelectedValue);
    this.selectedIndex = SelectedValue;
    this.createTable(false, Feature.Index, true);
  }

  togglePanel(SelectedDropDown: string) {
    if (SelectedDropDown == 'significance') {
      this.sampleSizeDropdown = !this.sampleSizeDropdown;
      this.isReference = false;
    } else if (SelectedDropDown == 'confidence') {
      this.confidenceLevelDropDown = !this.confidenceLevelDropDown;
    } else if (SelectedDropDown == 'reference') {
      this.referenceLevelDropDown = !this.referenceLevelDropDown;
    } else if (SelectedDropDown == 'weight') {
      this.weightDropDown = !this.weightDropDown;
    } else if (SelectedDropDown == 'datadropdown') {
      this.dataDropDown = !this.dataDropDown;
    }
  }

  handleExportClick() {
    ExportHandlerHelper.handleExportClick(this);
  }

  OnTransposeClick() {
    this.handleOutputdataObjectOnTransposeSelect();
    this.isTableClick = false;
    this.isTranspose = !this.isTranspose;
    this.disableLineChart = this.isTranspose ? false : true;
    this.isLineChartClick = false;
    this.isSignificanceContainerDisabled =
      !this.isSignificanceContainerDisabled;
    if (
      (this.isVerticalGroupBarChartClick || this.isVerticalBarChartClick) &&
      this.isTranspose
    ) {
      this.VerticalChartClick(CHART_TYPES.BAR);
    } else if (
      (this.isVerticalGroupBarChartClick || this.isVerticalBarChartClick) &&
      !this.isTranspose
    ) {
      this.VerticalChartClick(CHART_TYPES.COLUMN);
    } else if (this.isVerticalStackChartClick && this.isTranspose) {
      this.onVerticalStackBarChartIconClick(CHART_TYPES.BAR);
    } else if (this.isVerticalStackChartClick && !this.isTranspose) {
      this.onVerticalStackBarChartIconClick(CHART_TYPES.COLUMN);
    }
  }

  handlePPTExportClick() {
    ExportHandlerHelper.handlePPTExportClick(this);
  }

  fetchDiagnostic() {
    this.inputValue = '';
    this.apiService.getDiagonistics().subscribe((dt) => {
      try {
        const result = typeof dt === 'string' ? JSON.parse(dt) : dt;
        const data: Array<DiagnosticData> = JSON.parse(result.Data);
        this.displayDiagnosticData(data);
      } catch (err) {
        alert('Failed to load diagnostics data.');
      }
    });
  }

  displayDiagnosticData(data: DiagnosticData[]) {
    DiagnosticViewerHelper.displayDiagnosticData(data);
  }

  afterSubmit() {
    this.outputData = this._configService.standardSnapOutputData;

    if (
      this._configService.selectedcompareacrossOption == 'Multiple Brands' ||
      this._configService.selectedcompareacrossOption == 'Multiple Markets'
    ) {
      this._configService.standardSnapOutputData.sort((a: any, b: any) => {
        const sortIdA =
          this._configService.brandSortId.find(
            (item: any) => item.name === a.colChild.split('|')[1]
          )?.sortId ?? Infinity;
        const sortIdB =
          this._configService.brandSortId.find(
            (item: any) => item.name === b.colChild.split('|')[1]
          )?.sortId ?? Infinity;
        return sortIdA - sortIdB;
      });
    }

    this.outputData = Array.from(
      new Set(
        this.outputData
          .map((item: any) => {
            try {
              return JSON.stringify(item);
            } catch (err) {
              return null;
            }
          })
          .filter((item: any) => item !== null)
      )
    )
      .map((item: any) => {
        try {
          return JSON.parse(item);
        } catch (err) {
          return null;
        }
      })
      .filter((item) => item !== null);
    let arr: any[] = [];
    let arrWithoutTrend: any[] = [];

    if (!this.widgetData || this.widgetData.length === 0) {
      return;
    }

    this.items = _.cloneDeep(this.widgetData);
    if (this._configService.selectedcompareacrossOption.includes('Multiple')) {
      if (this.items) {
        this.items.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;

              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = DataTransformersHelper.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                this.outputData.forEach((row: any) => {
                  if (row.rowChild == metric.option) {
                    outputRow.push(row);
                    return true;
                  }
                  return false;
                });
                if (
                  this._configService.selectedcompareacrossOption ==
                  'Multiple Brands'
                ) {
                  outputRow.sort((a: any, b: any) => {
                    const sortIdA =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === a.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    const sortIdB =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === b.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    return sortIdA - sortIdB;
                  });
                }

                metric.option = DataTransformersHelper.handlemetricname(metric.option, result);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,
                  });

                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });

                metric.data = this.sortTrendTimeporiodData(metric.data);
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              const metrics = this.outputData.filter(
                (row: any) => item.widget_name == row.widgetName
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              let result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));
              let maxmetriclimit = JSON.parse(
                item?.customizationProperties
              )?.maxMetricLimit;
              if (maxmetriclimit != undefined) {
                result = result.slice(0, maxmetriclimit);
              }

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    metricName: DataTransformersHelper.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,
                    });

                    metricsAvailable[index].data = this.sortTrendTimeporiodData(
                      metricsAvailable[index].data
                    );
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }
            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arr.push(this.items);

      this.itemWithoutTrendItems = _.cloneDeep(this.widgetData);
      let brands: string[] = _.uniq(
        this.outputData.map((metric: any) => metric.colChild)
      );
      if (this.itemWithoutTrendItems) {
        this.itemWithoutTrendItems.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = DataTransformersHelper.checkMetrics(metrics);
              let resultBrands = DataTransformersHelper.checkBrands(brands);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];

                for (const row of this.outputData) {
                  if (
                    row.rowChild === metric.option &&
                    item.widget_name === row.widgetName &&
                    this._configService.selectedTPforNonTrendView ==
                    row.Level1ColChild
                  ) {
                    outputRow.push(row);
                  }
                }

                if (
                  this._configService.selectedcompareacrossOption ==
                  'Multiple Brands'
                ) {
                  outputRow.sort((a: any, b: any) => {
                    const sortIdA =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === a.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    const sortIdB =
                      this._configService.brandSortId.find(
                        (item: any) => item.name === b.colChild.split('|')[1]
                      )?.sortId ?? Infinity;
                    return sortIdA - sortIdB;
                  });
                }

                metric.option = DataTransformersHelper.handlemetricname(metric.option, result);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: DataTransformersHelper.handleBrandName(row.colChild, resultBrands),
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,
                  });
                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              const metrics = this.outputData.filter(
                (row: any) =>
                  item.widget_name == row.widgetName &&
                  this._configService.selectedTPforNonTrendView ==
                  row.Level1ColChild
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              const result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              if (result.slice(0, 6).length > 0) {
                result.slice(0, 6).forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    option: DataTransformersHelper.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,
                    });
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }

            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arrWithoutTrend.push(this.itemWithoutTrendItems);
    } else {
      if (this.items) {
        this.items.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = DataTransformersHelper.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                this.outputData.forEach((row: any) => {
                  if (row.rowChild == metric.option) {
                    outputRow.push(row);
                    return true;
                  }
                  return false;
                });

                metric.option = DataTransformersHelper.handlemetricname(metric.option, result);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,
                  });

                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });

                metric.data = this.sortTrendTimeporiodData(metric.data);
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              const metrics = this.outputData.filter(
                (row: any) => item.widget_name == row.widgetName
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              const result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    metricName: DataTransformersHelper.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,
                    });

                    metricsAvailable[index].data = this.sortTrendTimeporiodData(
                      metricsAvailable[index].data
                    );
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }
            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arr.push(this.items);

      this.itemWithoutTrendItems = _.cloneDeep(this.widgetData);
      if (this.itemWithoutTrendItems) {
        this.itemWithoutTrendItems.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );
              let result = DataTransformersHelper.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];

                for (const row of this.outputData) {
                  if (
                    row.rowChild === metric.option &&
                    item.widget_name === row.widgetName &&
                    this._configService.selectedTPforNonTrendView ==
                    row.Level1ColChild
                  ) {
                    outputRow.push(row);
                  }
                }

                metric.option = DataTransformersHelper.handlemetricname(metric.option, result);
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    changeVsPY:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    Significance_Value:
                      this.baseselected.toLowerCase() == 'total base'
                        ? row.Significance_Total
                        : row.Significance_Answer,

                  });
                  if (row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                });
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              const metrics = this.outputData.filter(
                (row: any) =>
                  item.widget_name == row.widgetName &&
                  this._configService.selectedTPforNonTrendView ==
                  row.Level1ColChild
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              let result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));
              //;
              let maxmetriclimit = JSON.parse(
                item?.customizationProperties
              )?.maxMetricLimit;
              if (maxmetriclimit != undefined) {
                result = result.slice(0, maxmetriclimit);
              }

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    option: DataTransformersHelper.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      changeVsPY:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      Significance_Value:
                        this.baseselected.toLowerCase() == 'total base'
                          ? row.Significance_Total
                          : row.Significance_Answer,
                    });
                    if (row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }

            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arrWithoutTrend.push(this.itemWithoutTrendItems);
    }
    this._configService.allPageOutputData = arr;
    this._configService.allPageOutputDataWithoutTrend = arrWithoutTrend;
    this.output_details = {
      pageData: this.pageData,
      widgetData: this.itemWithoutTrendItems,
    };

    this._configService.allPageOutputData = arr;
    this._configService.allPageOutputDataWithoutTrend = arrWithoutTrend;
    this._configService.itemWithTrendData = arr;
    this.selectedWidgetName = 'Awareness';
    this.selectedWidgetID = this.promptData.Widget_ID;


    this.filteredWidgetData = this.output_details.widgetData.filter(
      (widget: any) => widget.previewChartPostion == this.selectedWidgetID
    )[0];
    this.filteredWidgetID = this.filteredWidgetData.previewChartPostion;



    const widgetName = this.filteredWidgetData?.widget_name || 'Widget';
    const compareAcross = this.promptData?.Snapshot_Type || SNAPSHOT_TYPES.SINGLE_BRAND;
    const metrics = this.filteredWidgetData?.metric?.[0]?.metric_value || [];
    const pData = this.promptData || {};
    const marketsData = pData.Markets || pData.markets || pData.Market || pData.market || [];
    const timesData = pData.Time_Period || pData.time_period || pData.TimePeriod || pData.timeperiod || [];
    const filtersData = pData.Filter_Audience || pData.filter_audience || pData.Filter || pData.filter || [];

    const extractNameValue = (item: any) => {
      if (typeof item === 'string') {
        const parts = item.split('|');
        if (parts.length >= 2) {
          return parts[parts.length - 2] + ': ' + parts[parts.length - 1];
        }
        return parts.pop();
      }
      if (item && item.name) return item.name;
      if (item && item.Child) return item.Child;
      if (item && item.option) return item.option;
      return String(item);
    };

    const metricNames = metrics.map((m: any) => m.option || m.metric_option || '').filter((name: string) => name).join(', ');
    const baseType = this.promptData?.isTotalBase ? BASE_TYPES.TOTAL : BASE_TYPES.ANSWER;

    const extractLastPart = (item: any) => {
      if (typeof item === 'string') return item.split('|').pop();
      if (item && item.name) return item.name;
      if (item && item.Child) return item.Child;
      if (item && item.option) return item.option;
      return String(item);
    };

    const marketNames = marketsData.length > 0 ? marketsData.map((m: any) => extractLastPart(m)).join(', ') : 'All Markets';
    const timePeriodNames = timesData.length > 0 ? timesData.map((t: any) => extractNameValue(t)).join(', ') : 'All Time Periods';
    const filterNames = filtersData.length > 0 ? filtersData.map((f: any) => extractNameValue(f)).join(', ') : 'All Respondents';
    const brandsData = pData.Primary_Brands || pData.primary_brands || pData.Brands || pData.brands || [];
    const brandsNames = brandsData.length > 0 ? brandsData.map((b: any) => extractNameValue(b)).join(', ') : 'All Brands';

    let selections = 'Time Period: ' + timePeriodNames + '; Brands: ' + brandsNames;
    if (filtersData.length > 0) {
      selections += '; Filters: ' + filterNames;
    }

    this._configService.selectionSummaryTextTitle =
      'Compare Across: ' + compareAcross + ': ' + widgetName +
      ' || Entry Point: Markets: ' + marketNames +
      ' || Selections: ' + selections +
      ' || Significance: None' +
      ' || Base: ' + baseType +
      ' || Weight: Primary Weight';


    if (!this.Snapshotdataforexport) {
      this.Snapshotdataforexport = this._configService.getDropdownValues();
    }

    this.Snapshotdataforexport.compareAcross = compareAcross;
    this.Snapshotdataforexport.snapshotName = this.promptData?.Snapshot_Name || 'Snapshot';
    this.Snapshotdataforexport.clientName = this.selected_client;
    this.Snapshotdataforexport.studyName = this.selected_study;
    this.Snapshotdataforexport.selectionSummary = this._configService.selectionSummaryTextTitle;
    this.Snapshotdataforexport.baseType = baseType;

    setTimeout(() => this.showSnapshot = true, 5);
    setTimeout(() => MarkdownPayloadHelper.buildSnapshotMarkdown(this), 500);
  }


  sortTrendTimeporiodData(metricData: any[]): any[] {
    let filteredLeftPanelData = this._configService.leftPanelData?.filter(
      (item: any) =>
        item.Level0 === 'Time Period' || item.Level1 === 'Time Period'
    );
    filteredLeftPanelData?.sort((a: any, b: any) => {
      return a.level1_sort_id - b.level1_sort_id;
    });

    metricData?.sort((a: any, b: any) => {
      const indexA = filteredLeftPanelData?.findIndex(
        (item: any) => item.MetricOption === a.lvl1Child.split('|')[1]
      );
      const indexB = filteredLeftPanelData?.findIndex(
        (item: any) => item.MetricOption === b.lvl1Child.split('|')[1]
      );
      return indexA - indexB;
    });
    metricData?.sort((a: any, b: any) => {
      const [monthA, yearA] = a.lvl1Child?.split('|')[1].split('_');
      const [monthB, yearB] = b.lvl1Child?.split('|')[1].split('_');
      const dateA: any = new Date(yearA, this.getMonthNumber(monthA) - 1);
      const dateB: any = new Date(yearB, this.getMonthNumber(monthB) - 1);
      return dateA - dateB;
    });

    return metricData;
  }

  getMonthNumber(monthAbbr: any) {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return months.indexOf(monthAbbr) + 1;
  }

  OnInsigthsbuttonClick(isChatResponse = false, getSnapshotInsights?: any, getSnapshotInsightsTrend?: any) {
    console.log('[DEBUG] OnInsigthsbuttonClick called:', { isChatResponse, hasSnapshotInsights: !!getSnapshotInsights });
    let WidgetId = this.Widget_Id;
    this.arktabaccess = false;
    let data = [];
    this.InsightsResponse = [];
    let ShareColumn = (this.selectedDataFormat != 'Respondent Level' ? 'value' : (this.isTotalBase
      ? (this.selectedWeight == "Unweighted" ? 'totalUnweightedShare' : 'totalWeightedShare')
      : (this.selectedWeight == "Unweighted" ? 'answerUnweightedShare' : 'answerWeightedShare')));
    let BaseColumn = !this.isTotalBase
      ? 'totalUnweightedBase'
      : 'answerUnweightedBase';

    if (!this.Snapshotdataforexport) {
      this.Snapshotdataforexport = this._configService.getDropdownValues();
    }

    this.Snapshotdataforexport.selectionSummary = this.selectionSummary;
    this.isInsightspopupOpen = true;
    if (getSnapshotInsights && isChatResponse) {
      // Re-normalize everything into component properties for view consistency:
      let rawText = '';
      if (typeof getSnapshotInsights === 'string') rawText = getSnapshotInsights;
      else if (getSnapshotInsights?.insights?.Value) rawText = getSnapshotInsights.insights.Value;
      else if (getSnapshotInsights?.Value) rawText = getSnapshotInsights.Value;

      if (rawText.includes('[[[SPLIT]]]')) {
        console.log('[CHATBOT] Splitting combined insights from history...');
        const parts = rawText.split('[[[SPLIT]]]');
        this.snapshotinsights_standard_text = parts[0];
        this.snapshotinsights_trendline_text = parts[1];
      } else {
        this.snapshotinsights_standard_text = rawText;
        // Check if there was separate trend insights (previous migration format)
        if (getSnapshotInsightsTrend) {
          if (typeof getSnapshotInsightsTrend === 'string') this.snapshotinsights_trendline_text = getSnapshotInsightsTrend;
          else if (getSnapshotInsightsTrend?.insights?.Value) this.snapshotinsights_trendline_text = getSnapshotInsightsTrend.insights.Value;
          else if (getSnapshotInsightsTrend?.Value) this.snapshotinsights_trendline_text = getSnapshotInsightsTrend.Value;
        }
      }

      const targetText = this.isTrendActive ? (this.snapshotinsights_trendline_text || this.snapshotinsights_standard_text) : this.snapshotinsights_standard_text;
      this.insightsVal = this.formatInsightsIntoPoints(targetText);
    } else {
      this.insightsVal = (getSnapshotInsights && !isChatResponse) ? this.formatInsightsIntoPoints(getSnapshotInsights) : '';
    }

    (getSnapshotInsights && isChatResponse ? of(getSnapshotInsights) :
      this.apiService.getInsightsData(
        this.isIndexSelected,
        this.MainResult,
        this.selected_study,
        this.selected_client,
        this.selectionSummary,
        this.confidenceLevel,
        ShareColumn,
        BaseColumn,
        this._configService.getDropdownValues().compareAcross,
        "",
        "",
        WidgetId,
        localStorage.getItem('useremail') ?? '',
        '',
        'ARK'
      ))
      .subscribe({
        next: (result: string) => {
          // Requirement: Save insights data to Elasticsearch chat history for mcode==1 (snapshot module)
          if (!isChatResponse) {
            let snapshotInsightsText = 'No data Available';
            try {
              if (result && typeof result === 'string') {
                let insightsValue = result;
                try {
                  const parsed = JSON.parse(result);
                  const firstKey = Object.keys(parsed)[0];
                  if (firstKey && parsed[firstKey] && parsed[firstKey].Value) {
                    insightsValue = parsed[firstKey].Value;
                  }
                } catch (parseError) {
                }
                const insights = insightsValue.split('- ').map(item => item.trim()).filter(item => item.length > 0);
                if (insights.length > 0) {
                  snapshotInsightsText = insights.slice(0, 2).map(insight => {
                    let cleaned = insight.replace(/\*\*/g, ''); // Remove bold asterisks
                    cleaned = cleaned.replace(/^[^:]+:\s*/, ''); // Remove header before colon
                    cleaned = cleaned.replace(/\\n/g, ' '); // Remove escaped newlines
                    cleaned = cleaned.replace(/\n/g, ' '); // Remove actual newlines
                    return cleaned.trim();
                  }).join(' ');
                }
              }
            } catch (e) {
              console.log('Error extracting snapshot insights:', e);
            }
            this.updateQuestionAnswerForSelectedMessage(snapshotInsightsText);
            this.pushChatResponseEntry('getSnapshotInsights', result);
            this.saveChatList(
              this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue,
              this.chatResponse,
              snapshotInsightsText
            );
            this.chatResponse = [];
          }
          this.showSnapshot = true;

          if (!isChatResponse) {
            let parsedResult: any;

            try {
              parsedResult = JSON.parse(result);
            } catch {
              parsedResult = null;
            }

            if (parsedResult && !parsedResult.success) {
              this.insightsVal = this.formatInsightsIntoPoints(parsedResult.message || "No Data Available");
            }
            else if (result && result.trim() !== "") {
              let parsedInsightsObj = JSON.parse(result);
              let combinedInsightsText = '';
              for (const section in parsedInsightsObj) {
                if (parsedInsightsObj[section] && parsedInsightsObj[section].Value) {
                  combinedInsightsText += parsedInsightsObj[section].Value + '\n';
                }
              }
              this.insightsVal = this.formatInsightsIntoPoints(combinedInsightsText);
            } else {
              this.insightsVal = ["No Data Available"];
            }
            this.InsightsResponse = {
              header: this.failedCase ? (this.errorHeader || 'Error:') : 'Insights',
              message: this.insightsVal.join('\n'),
              show: true
            };
            this.stopAiLoader();
            this.arktabaccess = false; // Stop loader
          }
          else {
            let parsedResult: any;

            if (typeof result === "string") {
              try {
                parsedResult = JSON.parse(result);
              } catch (e) {
                parsedResult = null;
              }
            } else if (typeof result === "object") {
              parsedResult = result;
            } else {
              parsedResult = null;
            }
            if (parsedResult && typeof parsedResult === 'object') {
              let combinedInsightsText = '';
              let insightsFound = false;

              for (const section in parsedResult) {
                if (parsedResult[section] && parsedResult[section].Value) {
                  combinedInsightsText += parsedResult[section].Value + '\n';
                  insightsFound = true;
                }
              }

              if (insightsFound) {
                this.insightsVal = this.formatInsightsIntoPoints(combinedInsightsText);
              } else {
                this.insightsVal = ["No Data Available"];
              }
            } else {
              this.insightsVal = ["No Data Available"];
            }
            this.InsightsResponse = {
              header: this.failedCase ? (this.errorHeader || 'Error:') : 'Insights',
              message: this.insightsVal.join('\n'),
              show: true
            };
          }
          this._insightsSerive.showInisghts(this.InsightsResponse);
          this.stopAiLoader();
          this.arktabaccess = false;
        },
        error: (error) => {
          console.error('Error fetching insights for snapshot:', error);
          this.insightsVal = ['Failed to generate insights. Please try again.'];
          this.failedCase = true;
          this.stopAiLoader();
          this.arktabaccess = false;
        }
      });
  }

  async callInsightsAPI(
    mcode: number,
    markdown: string,
    query?: string,
    widget_details?: any
  ): Promise<void> {
    if (this.failedCase) {
      console.warn('[ORCHESTRATION] callInsightsAPI skipped: failedCase is true (preceding error detected)');
      return;
    }
    this.insightsStreamingText = '';
    this.insightsStreamingPoints = [];
    this.isInsightspopupOpen = true;
    this.insightsVal = '';
    this.failedCase = false;

    try {
      // Determine default active view for snapshots:
      // (1 brand AND 1 market) -> Trend View is best for temporal analysis
      // (Multi-brand OR Multi-market) -> Normal View is best for cross-comparison
      const bArray = this.promptData?.Primary_Brands || this.promptData?.primary_brands || this.promptData?.Brands || this.promptData?.brands || [];
      const mArray = this.promptData?.Markets || this.promptData?.markets || [];
      const isSingleFocus = (bArray.length === 1 && (mArray.length <= 1));

      if (mcode === 1 && this.filteredWidgetData?.trendline_response && isSingleFocus) {
        this.isTrendActive = true;
        console.log('[Snapshot Dual View] Defaulting to Trend View (Single focus detected)');
      } else {
        this.isTrendActive = false;
        console.log('[Snapshot Dual View] Defaulting to Normal View (Multi-comparison detected)');
      }

      const basePayload = await MarkdownPayloadHelper.buildMarkdownPayload(this);
      if (!basePayload) {
        throw new Error('Payload construction failed');
      }


      this.insightsVal = [];
      this.insightsStreamingText = '';
      this.insightsStreamingPoints = [];
      this.isInsightspopupOpen = true;
      this.stopInsightsAutoScroll();

      this.InsightsResponse = {
        header: 'Insights (Connecting...)',
        message: 'Connecting to specialized intelligence stream...',
        show: true,
      };
      this._insightsSerive.showInisghts(this.InsightsResponse);

      let insightsResponse = '';
      let qnaResponse = '';
      let insightsCompleted = false;
      let qnaCompleted = false;
      let firstChunkReceived = false;

      // Reset specific snapshot text storage
      this.snapshotinsights_standard_text = '';
      this.snapshotinsights_trendline_text = '';

      // Check if we need dual calls for snapshot trend context
      const isSnapshotTrend = (mcode === 1 && !!this.filteredWidgetData?.trendline_response);
      let standardDone = false;
      let trendDone = !isSnapshotTrend;

      const finalizeDualInsights = () => {
        if (standardDone && trendDone) {
          console.log('[Snapshot Dual Intelligence] Both streams finished. Finalizing history entry...');
          const combinedRaw = (this.snapshotinsights_standard_text || "No Data Available").trim() +
            "[[[SPLIT]]]" +
            (this.snapshotinsights_trendline_text || "No Data Available").trim();
          const jsonFormatted = JSON.stringify({ "insights": { "Value": combinedRaw } });

          this.pushChatResponseEntry('getSnapshotInsights', jsonFormatted);

          insightsCompleted = true;
          this.checkStreamCompletion(insightsCompleted, qnaCompleted, jsonFormatted, qnaResponse, mcode);
        }
      };

      if (isSnapshotTrend) {
        console.log('[ORCHESTRATION] Snapshot TREND detected: Starting concurrent streams for standard and trendline insights...');

        // --- CALL 1: Standard Summary ---
        this.apiService.snapshotSummaryAgentStream({ ...basePayload, stream: true }).subscribe({
          next: (event) => {
            const text = this.extractTextFromStreamEvent(event);
            if (text && text !== 'done') {
              this.snapshotinsights_standard_text += text;
              if (!this.isTrendActive) {
                if (!firstChunkReceived) {
                  firstChunkReceived = true;
                  this.InsightsResponse = { header: 'Insights (Streaming...)', message: 'Generating standard insights...', show: true };
                  this._insightsSerive.showInisghts(this.InsightsResponse);
                }
                insightsResponse = this.snapshotinsights_standard_text;
                this.processInsightsChunkRealTime(text, insightsResponse);
              }
            }
          },
          error: (err) => {
            console.error('[Standard Insights Error]:', err);
            this.snapshotinsights_standard_text += '\n[Standard Insights Error]\n';
            if (!this.isTrendActive) {
              insightsCompleted = true;
              this.checkStreamCompletion(insightsCompleted, qnaCompleted, this.snapshotinsights_standard_text, qnaResponse, mcode);
            }
          },
          complete: () => {
            console.log('[Insights Stream] Standard Complete');
            standardDone = true;

            if (!this.isTrendActive) {
              const finalStandard = this.snapshotinsights_standard_text;
              insightsResponse = finalStandard;
              this.processInsightsChunkFinal(finalStandard);
              // Show UI as done, but let finalizeDualInsights handle history/completion if needed
            }
            finalizeDualInsights();
          }
        });

        // --- CALL 2: Trend Summary ---
        (async () => {
          const trendBasePayload = await MarkdownPayloadHelper.buildMarkdownPayload(this, true); // Get trend markdown
          this.apiService.snapshotSummaryAgentStream({ ...trendBasePayload, stream: true }).subscribe({
            next: (event) => {
              const text = this.extractTextFromStreamEvent(event);
              if (text && text !== 'done') {
                this.snapshotinsights_trendline_text += text;
                if (this.isTrendActive) {
                  if (!firstChunkReceived) {
                    firstChunkReceived = true;
                    this.InsightsResponse = { header: 'Trend Insights (Streaming...)', message: 'Generating trend analysis...', show: true };
                    this._insightsSerive.showInisghts(this.InsightsResponse);
                  }
                  insightsResponse = this.snapshotinsights_trendline_text;
                  this.processInsightsChunkRealTime(text, insightsResponse);
                }
              }
            },
            error: (err) => {
              console.error('[Trend Insights Error]:', err);
              this.snapshotinsights_trendline_text += '\n[Trend Insights Error]\n';
              if (this.isTrendActive) {
                insightsCompleted = true;
                this.checkStreamCompletion(insightsCompleted, qnaCompleted, this.snapshotinsights_trendline_text, qnaResponse, mcode);
              }
            },
            complete: () => {
              console.log('[Insights Stream] Trendline Complete');
              trendDone = true;

              if (this.isTrendActive) {
                const finalTrend = this.snapshotinsights_trendline_text;
                insightsResponse = finalTrend;
                this.processInsightsChunkFinal(finalTrend);
              }
              finalizeDualInsights();
            }
          });
        })();

      } else {
        // 1. Single Summary Agent logic
        let summaryObs$: Observable<any> | null = null;
        const summaryPayload = { ...basePayload, stream: true };

        if (mcode === 1) summaryObs$ = this.apiService.snapshotSummaryAgentStream(summaryPayload);
        else if (mcode === 2) summaryObs$ = this.apiService.brandAnalysisSummaryAgentStream(summaryPayload);
        else if (mcode === 3) summaryObs$ = this.apiService.crosstabSummaryAgentStream(summaryPayload);

        if (summaryObs$) {
          summaryObs$.subscribe({
            next: (event) => {
              if (!firstChunkReceived) {
                firstChunkReceived = true;
                this.InsightsResponse = {
                  header: 'Insights (Streaming...)',
                  message: 'AI is generating insights in real-time...',
                  show: true,
                };
                this._insightsSerive.showInisghts(this.InsightsResponse);
              }

              const text = this.extractTextFromStreamEvent(event);

              if (text && text !== 'done') {
                insightsResponse += text;
                this.processInsightsChunkRealTime(text, insightsResponse);
              }
            },
            error: (err) => {
              console.error('[Insights Stream Error]:', err);
              insightsResponse += '\n[Insights Error]\n';
              insightsCompleted = true;
              this.insightsVal = ['Insights Generation failed.'];
              this.updateInsightsPopupFinal();
              this.checkStreamCompletion(insightsCompleted, qnaCompleted, insightsResponse, qnaResponse, mcode);
            },
            complete: () => {
              insightsCompleted = true;
              if (insightsResponse && !this.insightsStreamingText) this.insightsStreamingText = insightsResponse;
              this.processInsightsChunkFinal(this.insightsStreamingText || insightsResponse);

              let formattedInsights = this.insightsStreamingText || insightsResponse;
              if (mcode === 1) {
                formattedInsights = JSON.stringify({ "insights": { "Value": (formattedInsights || "No Data Available").trim() } });
              }
              this.pushChatResponseEntry((mcode === 1 ? 'getSnapshotInsights' : 'getInsights'), formattedInsights);
              this.checkStreamCompletion(insightsCompleted, qnaCompleted, formattedInsights, qnaResponse, mcode);
            }
          });
        }
      }

      // 2. Q&A Agent - Always streaming for real-time interaction
      let qnaObs$: Observable<any> | null = null;
      const qnaPayload = { ...basePayload, stream: true };

      if (mcode === 1) qnaObs$ = this.apiService.snapshotQaAgentStream(qnaPayload);
      else if (mcode === 2) qnaObs$ = this.apiService.brandAnalysisQaAgentStream(qnaPayload);
      else if (mcode === 3) qnaObs$ = this.apiService.crosstabQaAgentStream(qnaPayload);

      if (qnaObs$) {
        qnaObs$.subscribe({
          next: (event) => {
            if (this.arktabaccess) {
              this.stopAiLoader();
              this.arktabaccess = false;
            }

            let text = '';
            if (event.event === 'text_delta') {
              text = event.data?.delta || '';
            } else if (typeof event.data === 'string') {
              text = event.data;
            } else if (event.data) {
              text = event.data.delta || event.data.chunk || event.data.Value || '';
            }

            if (text && text !== 'done') {
              qnaResponse += text;
              this.updateMarkdownTextRealTime(qnaResponse);
            }
          },
          error: (err) => {
            console.error('[QnA Stream Error]:', err);
            qnaResponse += '\n[QnA Stream Error]\n';
            qnaCompleted = true;
            this.checkStreamCompletion(insightsCompleted, qnaCompleted, insightsResponse, qnaResponse, mcode);
          },
          complete: () => {
            qnaCompleted = true;
            this.pushChatResponseEntry('getQnA', qnaResponse);
            this.checkStreamCompletion(insightsCompleted, qnaCompleted, insightsResponse, qnaResponse, mcode);
          }
        });
      }
    } catch (error) {
      console.error('[Insights Error]:', error);
      this.insightsVal = ['Failed to authenticate or build payload.'];
      this.stopAiLoader();
      this.arktabaccess = false;
    }
  }

  private processInsightsChunkRealTime(newChunk: string, fullResponse: string): void {
    try {
      this.insightsStreamingText += newChunk;
      this.insightsStreamingPoints = this.formatInsightsIntoPoints(this.insightsStreamingText);
      this.cdr.detectChanges();
      this.updateInsightsPopupRealTime();
      this.scrollInsightsDownSmooth();
    } catch (error) {
    }
  }

  private processInsightsChunkFinal(fullInsightsResponse: string): void {
    try {
      const rawInsightsForSaving = fullInsightsResponse;
      let parsedInsights: any;
      try {
        parsedInsights = JSON.parse(fullInsightsResponse);
      } catch (e) {
        parsedInsights = null;
      }

      if (parsedInsights && typeof parsedInsights === 'object') {
        let combinedInsightsText = '';
        let insightsFound = false;

        for (const section in parsedInsights) {
          if (parsedInsights[section] && parsedInsights[section].Value) {
            combinedInsightsText += parsedInsights[section].Value + '\n';
            insightsFound = true;
          }
        }

        if (insightsFound) {
          this.insightsVal = this.formatInsightsIntoPoints(combinedInsightsText);
        } else {
          this.insightsVal = ["No Data Available"];
        }
      } else if (fullInsightsResponse && fullInsightsResponse.trim() !== "") {
        this.insightsVal = this.formatInsightsIntoPoints(fullInsightsResponse);
      } else {
        this.insightsVal = ["No Data Available"];
      }
      this.updateInsightsPopupFinal();

      setTimeout(() => {
        this.scrollInsightsToTopSmooth();
      }, 1000);

    } catch (error) {
      this.insightsVal = ['Failed to process insights.'];
      this.updateInsightsPopupFinal();

      setTimeout(() => {
        this.scrollInsightsToTopSmooth();
      }, 500);
    }
  }

  private formatInsightsIntoPoints(text: any): string[] {
    if (!text) {
      return [];
    }

    let rawText = '';

    // Determine the raw source text based on data type
    if (typeof text === 'string') {
      rawText = text;
    } else if (typeof text === 'object') {
      // Handle the case where we've received or parsed an object structure
      // Case 1: Direct Value property (e.g. { Value: "..." })
      if (text.Value && typeof text.Value === 'string') {
        rawText = text.Value;
      }
      // Case 2: Nested insights (e.g. { insights: { Value: "..." } })
      else if (text.insights && text.insights.Value && typeof text.insights.Value === 'string') {
        rawText = text.insights.Value;
      }
      // Case 3: Keyed sections (common in original insights Response e.g. { "Section 1": { Value: "..." } })
      else {
        let combinedVal = '';
        let foundValue = false;

        for (const key in text) {
          if (text[key] && text[key].Value && typeof text[key].Value === 'string') {
            combinedVal += text[key].Value + '\n';
            foundValue = true;
          }
        }

        if (foundValue) {
          rawText = combinedVal;
        } else {
          // If no recognized structure, fallback to string representation
          try {
            rawText = JSON.stringify(text);
          } catch (e) {
            rawText = String(text);
          }
        }
      }
    } else {
      rawText = String(text);
    }

    // Handle dual-view snapshot insights (Standard vs Trend)
    if (rawText.includes('[[[SPLIT]]]')) {
      const parts = rawText.split('[[[SPLIT]]]');
      rawText = this.isTrendActive ? (parts[1] || parts[0]) : parts[0];
    }

    // Safety check that rawText is now a string and has a trim method
    if (!rawText || typeof rawText.trim !== 'function' || rawText.trim() === '') {
      return [];
    }

    let cleanedText = this.cleanStreamingArtifacts(rawText);

    cleanedText = cleanedText
      .replace(/##+\s*/g, '')   // Remove all markdown headers (# ## ### etc.)
      .replace(/---+/g, '')     // Remove markdown dividers
      .replace(/\n\n+/g, '\n')  // Collapse multiple newlines
      .trim();

    // SPLIT LOGIC: Use a stateful parser to identify points while keeping tables whole
    const lines = cleanedText.split(/\n/);
    let points: string[] = [];
    let currentPoint = '';
    let inTable = false;

    lines.forEach(line => {
      const trimmedLine = line.trim();
      const isTableLine = trimmedLine.startsWith('|');

      if (isTableLine) {
        // If we were building a non-table point, save it and start the table
        if (!inTable && currentPoint.trim() !== '') {
          points.push(currentPoint.trim());
          currentPoint = '';
        }
        inTable = true;
        currentPoint += (currentPoint ? '\n' : '') + line;
      } else {
        // If we're coming out of a table, save the table block first
        if (inTable) {
          points.push(currentPoint.trim());
          currentPoint = '';
          inTable = false;
        }

        // Handle normal point splitting: Start a new point for every non-empty line
        if (trimmedLine !== '') {
          if (currentPoint.trim() !== '') {
            points.push(currentPoint.trim());
          }
          currentPoint = line;
        }
      }
    });

    // Push the final remaining point
    if (currentPoint.trim() !== '') {
      points.push(currentPoint.trim());
    }

    let finalPoints = points
      .map((pointText: string) => {
        // Only clean non-table lines deeply
        if (pointText.includes('|')) {
          return pointText;
        }

        let cleaned = pointText
          .replace(/^[-•*]\s*/, '')  // Remove bullet markers at start of the point
          .replace(/^\s*-\s*/, '')   // Remove hyphens
          .replace(/\s+/g, ' ')       // Collapse multiple internal spaces
          .trim();

        // Ensure each distinct point (if sentence-like) has a period if not ending in punctuation
        if (cleaned && !cleaned.match(/[.!?]$/) && cleaned.length > 20) {
          cleaned += '.';
        }

        return cleaned;
      })
      .filter((p: string) => p.length > 2); // Keep all valid points

    return finalPoints.length > 0 ? finalPoints : ["No Data Available"];
  }

  private extractTextFromStreamEvent(event: any): string {
    if (!event) return '';
    if (event.event === 'text_delta') {
      return event.data?.delta || '';
    } else if (typeof event.data === 'string') {
      return event.data;
    } else if (event.data) {
      let text = event.data.delta || event.data.chunk || event.data.Value || (typeof event.data === 'string' ? event.data : '');
      if (!text && event.data.insights && event.data.insights.Value) {
        text = event.data.insights.Value;
      }
      return text;
    }
    return '';
  }

  private cleanStreamingArtifacts(text: string): string {
    let cleaned = text;

    cleaned = cleaned.replace(/data:\s*/gi, '');
    cleaned = cleaned.replace(/event:\s*\w+/gi, '');

    // Fix Unicode character encoding issues common in streaming
    cleaned = cleaned.replace(/â€œ/g, '"');  // Opening quote
    cleaned = cleaned.replace(/â€/g, '"');   // Closing quote  
    cleaned = cleaned.replace(/â€'/g, '—');  // Em dash
    cleaned = cleaned.replace(/â€'/g, '-');  // En dash

    // Fix Unicode character encoding issues common in streaming

    // Fix spacing between numbers and words (e.g., "past12months" → "past 12 months")
    cleaned = cleaned.replace(/([a-z])(\d+)/gi, '$1 $2');
    cleaned = cleaned.replace(/(\d+)([a-z])/gi, '$1 $2');

    // Fix hyphenated or dashed words that got spaces (e.g., "12 -month" → "12-month")
    cleaned = cleaned.replace(/(\d+)\s*-\s*([a-z]+)/gi, '$1-$2');

    // Fix both literal string "\n" and encoded "\\n" artifacts
    cleaned = cleaned.replace(/\\n/g, '\n');

    // Collapse multiple horizontal spaces only (preserve newlines for list splitting)
    cleaned = cleaned.replace(/[ \t]+/g, ' ');

    return cleaned;
  }

  private updateInsightsPopupRealTime(): void {
    try {
      if (!this.isInsightspopupOpen) {
        this.isInsightspopupOpen = true;
      }

      const currentText = Array.isArray(this.insightsVal) && this.insightsVal.length > 0
        ? this.insightsVal[0]
        : '';

      this.InsightsResponse = {
        header: 'Insights (Streaming...)',
        message: currentText,
        show: true,
      };
      this._insightsSerive.showInisghts(this.InsightsResponse);

    } catch (error) {
    }
  }

  private updateInsightsPopupFinal(): void {
    try {
      this.InsightsResponse = {
        header: 'Insights',
        message: Array.isArray(this.insightsVal) ? this.insightsVal.join('\n') : String(this.insightsVal),
        show: true,
      };

      this._insightsSerive.showInisghts(this.InsightsResponse);

    } catch (error) {
    }
  }


  private scrollInsightsDownSmooth(): void {
    try {
      this.stopInsightsAutoScroll();

      if (this.insightsContainer && this.insightsContainer.nativeElement) {
        const scrollableContainer = this.insightsContainer.nativeElement.closest('.output-insights');

        if (scrollableContainer) {
          const currentScrollTop = scrollableContainer.scrollTop;
          const maxScrollTop = scrollableContainer.scrollHeight - scrollableContainer.clientHeight;

          if (maxScrollTop > 0 && currentScrollTop < maxScrollTop) {
            this.isInsightsScrolling = true;
            const scrollStep = Math.max(2, Math.ceil((maxScrollTop - currentScrollTop) / 20));

            this.insightsScrollInterval = setInterval(() => {
              const newScrollTop = scrollableContainer.scrollTop + scrollStep;

              if (newScrollTop >= maxScrollTop) {
                scrollableContainer.scrollTop = maxScrollTop;
                this.stopInsightsAutoScroll();
              } else {
                scrollableContainer.scrollTop = newScrollTop;
              }
            }, 50);
          }
        }
      }
    } catch (error) {
      console.warn('Error during insights auto-scroll:', error);
      this.stopInsightsAutoScroll();
    }
  }

  private scrollInsightsToTopSmooth(): void {
    try {
      this.stopInsightsAutoScroll();

      if (this.insightsContainer && this.insightsContainer.nativeElement) {
        const scrollableContainer = this.insightsContainer.nativeElement.closest('.output-insights');

        if (scrollableContainer) {
          const currentScrollTop = scrollableContainer.scrollTop;

          if (currentScrollTop > 0) {
            this.isInsightsScrolling = true;

            const scrollStep = Math.max(3, Math.ceil(currentScrollTop / 15));

            this.insightsScrollInterval = setInterval(() => {
              const newScrollTop = scrollableContainer.scrollTop - scrollStep;

              if (newScrollTop <= 0) {
                scrollableContainer.scrollTop = 0;
                this.stopInsightsAutoScroll();
              } else {
                scrollableContainer.scrollTop = newScrollTop;
              }
            }, 40);
          }
        }
      }
    } catch (error) {
      console.warn('Error during insights scroll to top:', error);
      this.stopInsightsAutoScroll();
    }
  }


  private stopInsightsAutoScroll(): void {
    if (this.insightsScrollInterval) {
      clearInterval(this.insightsScrollInterval);
      this.insightsScrollInterval = null;
    }
    this.isInsightsScrolling = false;
  }

  private updateMarkdownTextRealTime(qnaResponse: string): void {
    try {
      if (qnaResponse && qnaResponse.trim() !== "") {
        let cleanedQnaText = this.cleanQnaTextForParaOnly(qnaResponse);

        cleanedQnaText = cleanedQnaText
          .replace(/\s+/g, ' ')  // Collapse multiple spaces
          .replace(/^\s+|\s+$/g, '')  // Trim
          .trim();

        this.updateQuestionAnswerForSelectedMessage(cleanedQnaText);
      }
    } catch (error) {
      console.warn('Error updating markdown text in real-time:', error);
    }
  }

  /**
   * Helper to strip markdown tables from QnA text, leaving only paragraphs.
   */
  private cleanQnaTextForParaOnly(text: string): string {
    if (!text) return "";

    // Split by actual newlines or literal \n strings common in streams
    const lines = text.split(/\n|\\n/);

    return lines
      .filter(line => {
        const trimmed = line.trim();
        // Ignore lines that look like markdown table rows or separators
        if (trimmed.startsWith('|') || (trimmed.startsWith('+-') && trimmed.endsWith('-+')) || (trimmed.startsWith('|-') && trimmed.endsWith('-|'))) {
          return false;
        }
        return true;
      })
      .join('\n')
      .trim();
  }

  private checkStreamCompletion(
    insightsCompleted: boolean,
    qnaCompleted: boolean,
    insightsResponse: string,
    qnaResponse: string,
    mcode: number
  ): void {
    if (insightsCompleted && qnaCompleted) {
      if (mcode === 1) {
        let snapshotQnaText = 'No data Available';
        try {
          if (qnaResponse && qnaResponse.trim() !== "") {
            snapshotQnaText = this.cleanQnaTextForParaOnly(qnaResponse)
              .replace(/^[^:]+:\s*/, '')  // Remove prefixes like "Answer:"
              .replace(/\\n/g, ' ')  // Replace escaped newlines
              .replace(/\n/g, ' ')  // Replace actual newlines
              .trim();
          }
        } catch (e) {
          console.warn('Error processing snapshot QnA text:', e);
        }
        this.updateQuestionAnswerForSelectedMessage(snapshotQnaText);

        this.saveChatList(
          this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue,
          this.chatResponse,
          snapshotQnaText
        );
        this.chatResponse = [];
      } else {
        let processedQnaText = 'No data Available';
        try {
          if (qnaResponse && qnaResponse.trim() !== "") {
            processedQnaText = this.cleanQnaTextForParaOnly(qnaResponse)
              .replace(/^[^:]+:\s*/, '')  // Remove prefixes like "Answer:"
              .replace(/\\n/g, ' ')  // Replace escaped newlines
              .replace(/\n/g, ' ')  // Replace actual newlines
              .trim();
          }
        } catch (e) {
          console.warn('Error processing crosstab/brand analysis QnA text:', e);
        }

        this.updateQuestionAnswerForSelectedMessage(processedQnaText);
        this.saveChatList(
          this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue,
          this.chatResponse,
          processedQnaText
        );
        this.chatResponse = [];
      }

      this._insightsSerive.showInisghts(this.InsightsResponse);
      this.stopAiLoader();
      this.arktabaccess = false;
    }
  }

  buildSnapshotMarkdownForAPI(): string {
    return InsightsGeneratorHelper.buildSnapshotMarkdownForAPI(
      this.OutputData,
      this.isTotalBase,
      this.selectedWeight
    );
  }

  buildCrosstabMarkdownForAPI(): string {
    return InsightsGeneratorHelper.buildCrosstabMarkdownForAPI(
      this.CrossTabOutPutData,
      this.isTotalBase,
      this.selectedWeight
    );
  }

  sendInputMessage(ChatResponse?: any, isChatResponse: boolean = false) {
    this.streamStatusText = '';
    this.currentView = 'chat';
    if (this.isNewChatStarted && !isChatResponse && this.abandoningSessionId) {
      this.isNewChatStarted = false;
      const sessionToDelete = this.abandoningSessionId;
      from(this.getBearerToken()).pipe(
        switchMap(token => forkJoin([
          this.apiService.deleteRestrictedCache(token, sessionToDelete, true),
          this.apiService.deleteClientStudyContext(token, sessionToDelete)
        ]))
      ).subscribe({
        next: () => {
          this.abandoningSessionId = '';
        },
        error: (err) => console.error('[ChatbotService] Error deleting abandoned session cache/context:', err)
      });
    }

    if (!isChatResponse)
      this.selectedChatId = null;
    this.moduleSelectionToggle = false;
    this.showModuleDropdown = false;
    this.askMeLanding = false;
    if (this.inputValue !== '' || isChatResponse) {
      this.displayTable = false;
      this.showSnapshot = false;
      this.isCreateBtnClick = false;
      this.insightsVal = '';
      this.insightsStreamingText = '';
      this.insightsStreamingPoints = [];
      this.isselectionsummarycollapse = false;
      this.isselectionsummarycollapse2 = false;
      this.OutputdataObject.Row = [];
      this.OutputdataObject.Column = [];
      this.MainResult = undefined;
      this.OutputData = [];
      this.CrossTabOutPutData = [];
      this._configService.updateSignificanceValue('None');
      this._configService.updateConfedenceValue('None');
      this._configService.IndexSelected = false;
      this._configService.baseSelected = 'Total Base';
      this._configService.isTotalBase = true;
      this.arktabaccess = true;
      this.isStreamFinished = false;
      this.startAiLoader();
      this.isVerticalGroupBarChartClick = false;
      this.isVerticalBarChartClick = false;
      this.isVerticalStackChartClick = false;
      this.isLineChartClick = false;
      this.isInsightspopupOpen = false;

      if (this.chatResponse && this.chatResponse.length > 0 && this.chatPreviewBlocks.length > 0) {
        const lastQuestion = this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1];
        const questionAnswer = lastQuestion.QuestionAnswer || this.defaultQuestionAnswer;

        this.saveChatList(
          lastQuestion.question,
          this.chatResponse,
          questionAnswer
        );
      }

      if (!isChatResponse && this.inputValue && this.inputValue.trim()) {
        this.chatPreviewBlocks.push({
          question: this.inputValue,
          response: this.chatResponse && this.chatResponse.length > 0 ? this.chatResponse[0]['response'] || '' : '',
          isLiked: null,
          isStarred: false,
          feedbackSaved: false,
          showDislikeInput: false,
          dislikeReason: '',
          QuestionAnswer: this.defaultQuestionAnswer
        });
      } else if (isChatResponse) {
      }
      this.failedCase = false;
      this.chatResponse = [];
      let AgentPayload: any = null;
      let getSnapshotConfiguration: any = null;
      let GetCustomSnapshotWidget: any = null;
      let GetQuery: any = null;
      let getSnapshotOutput: any = null;
      let getSnapshotLoadData: any = null;
      let getConfiguration: any = null;
      let getSnapshotInsights: any = null;
      let getSnapshotInsightsTrend: any = null;
      let getInsights: any = null;
      let getQnA: any = null;
      let parsedHistory: any = null;

      if (isChatResponse) {
        const parsed = this.parseChatResponse(ChatResponse);
        parsedHistory = parsed;

        AgentPayload = parsed['AgentPayload'] || parsed['GetMcode'];
        getSnapshotConfiguration = parsed['getSnapshotConfiguration'];
        GetCustomSnapshotWidget = parsed['GetCustomSnapshotWidget'];
        GetQuery = parsed['GetQuery'];
        getSnapshotOutput = parsed['getSnapshotOutput'];
        getSnapshotLoadData = parsed['getSnapshotLoadData'];
        getConfiguration = parsed['getConfiguration'];
        getSnapshotInsights = parsed['getSnapshotInsights'];
        getSnapshotInsightsTrend = parsed.getSnapshotInsightsTrend;
        getInsights = parsed['getInsights'];
        getQnA = parsed['getQnA'];

        // Determine default view for historical snapshot: 1 brand -> Trend, Multi -> Normal
        if (AgentPayload && AgentPayload.promptData) {
          const pData = AgentPayload.promptData;
          const brands = pData.Primary_Brands || pData.primary_brands || pData.Brands || pData.brands || [];
          const combinedInsights = getSnapshotInsights || '';
          const hasTrendInsights = !!getSnapshotInsightsTrend || (typeof combinedInsights === 'string' && combinedInsights.includes('[[[SPLIT]]]'));

          if (hasTrendInsights && brands.length === 1) {
            this.isTrendActive = true;
            console.log('[HISTORY DEFAULT VIEW] 1 brand + Trend available: Defaulting to Trend View');
          } else {
            this.isTrendActive = false;
          }
        }
        // Assign restored configuration to service for analytical controls
        if (getSnapshotConfiguration) {
          console.log('[CHATBOT] Restoring configuration for analytical controls...');
          this._configService.outputSnapshotData = getSnapshotConfiguration;
          this.snapshotConfiguration = getSnapshotConfiguration; // Pass directly to popup
          if (getSnapshotConfiguration.brandMetadata) {
            console.log('[CHATBOT] Restoring brandData (count:', getSnapshotConfiguration.brandMetadata.length, ')');
            this._configService.brandData = getSnapshotConfiguration.brandMetadata;
          }
          if (getSnapshotConfiguration.weights) {
            console.log('[CHATBOT] Restoring weights (count:', getSnapshotConfiguration.weights.length, ')');
            this._configService.weights = getSnapshotConfiguration.weights;
          }
        } else {
          console.warn('[CHATBOT] No getSnapshotConfiguration found in parsed response.');
        }
        this.snapshotinsights_standard_text = getSnapshotInsights || '';
        this.snapshotinsights_trendline_text = getSnapshotInsightsTrend || '';
      }

      console.log('[DEBUG] Analysis settings at start:', {
        isChatResponse,
        SignificanceVsReference: this.SignificanceVsReference,
        DefaultConfidenceLevel: this.DefaultConfidenceLevel,
        selectedWeight: this.selectedWeight
      });

      const needAccessCheck = !isChatResponse && (!this.validatedSessionId || this.validatedSessionId !== this.guidChatId);


      const accessCheckRequest$ = needAccessCheck ? from(this.getBearerToken()).pipe(
        switchMap(token => {
          return this.apiService.accessCheck(
            this.selected_client,
            this.selected_study,
            token,
            this.guidChatId || ''
          );
        }),
        tap((res: any) => {
          if (res && res.session_id) {
            this.guidChatId = res.session_id;
            this.modulesAccess = res.modules_access;
            this.isCacheGenerated = false;
          }
          this.validatedSessionId = this.guidChatId;
        }),
        catchError((error) => {
          console.error('[ACCESS-CHECK ERROR] Access check failed:', error);
          return throwError(() => error);
        })
      ) : of(null);

      const generateCacheRequest$ = accessCheckRequest$.pipe(
        switchMap(() => {
          if (!this.isCacheGenerated && this.modulesAccess) {
            const activeModules: any = {};
            for (const [key, value] of Object.entries(this.modulesAccess)) {
              if ((value as any).has_access) {
                activeModules[key] = value;
              }
            }

            return from(this.getBearerToken()).pipe(
              switchMap(token => forkJoin([
                this.apiService.generateRestrictedCache(
                  this.selected_client,
                  this.selected_study,
                  token,
                  this.guidChatId,
                  activeModules
                ),
                this.apiService.generateClientStudyContext(
                  this.selected_client,
                  this.selected_study,
                  token,
                  this.guidChatId,
                  activeModules
                )
              ])),
              tap(() => {
                this.isCacheGenerated = true;
              }),
              catchError(err => {
                console.error('[CACHE ERROR] Cache/Context generation failed:', err);
                return of(null);
              })
            );
          }
          return of(null);
        })
      );

      const orchestrationRequest$ = AgentPayload && isChatResponse
        ? of(AgentPayload)
        : generateCacheRequest$.pipe(
          switchMap(() => {
            return this.getOrchestrationRequest();
          }),
          catchError((error) => {
            console.error('[ORCHESTRATION PIPE ERROR] Error in orchestration pipeline:', error);
            return throwError(() => error);
          })
        );

      if (AgentPayload && isChatResponse) {
      } else {
      }

      orchestrationRequest$.pipe(
        finalize(() => {
          if (isChatResponse) {
            this._loaderService.hideLoader();
          }
        })
      ).subscribe({
        next: async (response) => {
          let data = response;

          // Handle Snapshot Agent streaming events
          if (data && data.event) {
            if (data.event === 'final_result') {
              const rawData = data.data;
              let mcode = data.mcode || rawData.priority_mcode || rawData.mcode || rawData.final_output?.mcode || (rawData.member_responses ? Object.values(rawData.member_responses)[0] as any : {})?.mcode;

              // Fallback logic: If Team API returned mcode 99 (error) but we have multi-module access,
              // check if any specialized agent has a valid result in member_responses to use as fallback.
              const activeCount = (this.hasSnapshotActive ? 1 : 0) + (this.hasBrandAnalysisActive ? 1 : 0) + (this.hasCrosstabActive ? 1 : 0);
              if (mcode === 99 && activeCount > 1 && rawData.member_responses) {
                if (this.hasCrosstabActive && rawData.member_responses.crosstab) {
                  console.warn('[ORCHESTRATION] Team API returned 99. Falling back to Crosstab results.');
                }
                /* else if (this.hasBrandAnalysisActive && (rawData.member_responses.brand_analysis || rawData.member_responses.brandanalysis)) {
                  console.warn('[ORCHESTRATION] Team API returned 99. Falling back to Brand Analysis results.');
                  mcode = 2;
                } */
              }

              // Priority extraction for Step 2 Payload: final_output -> member_responses -> result
              let result = rawData.final_output;
              if (!result || Object.keys(result).length === 0 || mcode !== rawData.final_output?.mcode) {
                if (rawData.member_responses) {
                  // Select member response based on current (possibly fallback) mcode
                  if (mcode === 1) result = rawData.member_responses.snapshot;
                  else if (mcode === 2) result = rawData.member_responses.brand_analysis || rawData.member_responses.brandanalysis;
                  else if (mcode === 3) result = rawData.member_responses.crosstab;

                  // Absolute fallback to first available agent response if still empty
                  if (!result) result = Object.values(rawData.member_responses)[0];
                }
              }

              if (!result || Object.keys(result).length === 0) {
                result = rawData.result || {};
              }
              const basePayload: any = {
                client_name: rawData.client_name,
                study: rawData.study,
                session_id: rawData.session_id,
                bearer_token: this.currentOrchToken,
                significance: "None",
                confidence_level: "None",
                base: "ANSWER",
                weight: "Weight"
              };

              const constructSpecialized = (code: number, res: any) => {
                let p = { ...basePayload, mcode: code };
                if (code === 1) {
                  return {
                    ...p,
                    snapshot_type: res.snapshot_type || res.Snapshot_Type,
                    primary_brands: res.Primary_Brands || res.primary_brands,
                    primary_metrics: res.Primary_Metrics || res.primary_metrics || res.primary_metircs,
                    market: res.Markets || res.market,
                    timeperiod: res.Time_Period || res.timeperiod,
                    Filter_Audience: res.Filter_Audience || res.filter_audience,
                    Metric_Filters: res.Metric_Filters || res.metric_filters,
                    Snapshot_Name: res.Snapshot_Name || res.snapshot_name,
                    Section: res.Section || res.section,
                    Widget_ID: res.Widget_ID || res.widget_id,
                    Widget_Name: res.Widget_Name || res.widget_name,
                    selected_doc_id: res.selected_doc_id,
                    snapshot_index: rawData.snapshot_index,
                    widget_snapshot_index: rawData.widget_snapshot_index
                  };
                } else if (code === 2) {
                  return {
                    ...p,
                    brand_analysis_index: rawData.brand_analysis_index,
                    row: res.Row,
                    column: res.Column,
                    row_nesting: res.Row_Nesting,
                    column_nesting: res.Column_Nesting,
                    filters: res.Filters
                  };
                } else if (code === 3) {
                  return {
                    ...p,
                    crosstab_index: rawData.crosstab_index,
                    row: res.Row,
                    column: res.Column,
                    row_nesting: res.Row_Nesting,
                    column_nesting: res.Column_Nesting,
                    filters: res.Filters
                  };
                }
                return p;
              };

              this.chatPayload = constructSpecialized(mcode, result);

              // Construct Parallel Payload for Background Step 2 (if multi-module)
              this.parallelChatPayload = null;
              if (activeCount > 1 && rawData.member_responses) {
                // Secondary fallback: Crosstab > Brand Analysis
                if (this.hasCrosstabActive && mcode !== 3 && rawData.member_responses.crosstab) {
                  this.parallelChatPayload = constructSpecialized(3, rawData.member_responses.crosstab);
                }
                /* else if (this.hasBrandAnalysisActive && mcode !== 2) {
                  const baRes = rawData.member_responses.brand_analysis || rawData.member_responses.brandanalysis;
                  if (baRes) this.parallelChatPayload = constructSpecialized(2, baRes);
                } */
              }

              // Update UI state with the result data
              this.promptData = result;
              this.isTotalBase = result.isTotalBase ?? false;
              this.selectedWeight = result.weight || 'Unweighted';

              // Normalize data structure for downstream dependencies
              const { timeline, total_elapsed_seconds, ...rest } = rawData;
              data = {
                ...rest,
                ...result,
                response: result || {}
              };
            } else if (['done', 'meta'].includes(data.event)) {
              return; // Skip system events
            } else {
              // Intermediate stream events

              // Only display 'status' event messages in the UI loader
              if (data.event === 'status') {
                const statusMsg = data.data?.message || '';
                if (statusMsg && statusMsg.trim() !== '') {
                  const displayText = statusMsg.trim();
                  this.queueStatusMessage(displayText);
                }
              }

              this.cdr.detectChanges(); // Force update UI
              return; // Wait for final_result before processing core UI logic
            }
          }

          // Clear queue when final result is received
          this.statusQueue = [];
          this.isProcessingStatusQueue = false;
          this.isStreamFinished = true;

          const effectivePayload = isChatResponse ? data : this.chatPayload;

          if (isChatResponse) {

            // Restore Step 2 data from history
            const restoredResponse = (effectivePayload?.mcode === 1) ? getSnapshotOutput : getConfiguration;
            if (restoredResponse) {
              // Flatten the saved data to match fresh query structure
              data.response = restoredResponse.response ? restoredResponse.response : restoredResponse;
              if (restoredResponse.customization_Properties) {
                data.customization_Properties = restoredResponse.customization_Properties;
              }
              if (restoredResponse.quadrantText) {
                data.quadrantText = restoredResponse.quadrantText;
              }

              if (effectivePayload?.mcode == 3 && restoredResponse.crosstab_payload) {
                this.lastCrosstabPayload = restoredResponse.crosstab_payload;
              } else if (effectivePayload?.mcode == 1 && restoredResponse.snapshot_payload) {
                this.lastSnapshotPayload = restoredResponse.snapshot_payload;
              } else if (effectivePayload?.mcode == 2) {
                // Backend returns 'brand_anlysis_payload' (typo) — handle both spellings + effectivePayload fallback
                this.lastBrandAnalysisPayload = restoredResponse.brand_analysis_payload || restoredResponse.brand_anlysis_payload || effectivePayload;
              }

              console.log('[HISTORY-RESTORE] Found saved response data (flattened)');
            }

            // Restore UI context from history (Significance, Weight etc, and Error flags)
            if (parsedHistory) {
              if (parsedHistory['SignificanceVsReference']) this.SignificanceVsReference = parsedHistory['SignificanceVsReference'];
              if (parsedHistory['DefaultConfidenceLevel']) this.DefaultConfidenceLevel = parsedHistory['DefaultConfidenceLevel'];
              if (parsedHistory['selectedWeight']) this.selectedWeight = parsedHistory['selectedWeight'];
              if (parsedHistory['failedCase'] !== undefined) this.failedCase = parsedHistory['failedCase'];
              if (parsedHistory['noContentFlag'] !== undefined) this.noContentFlag = parsedHistory['noContentFlag'];
              if (parsedHistory['errorHeader'] !== undefined) this.errorHeader = parsedHistory['errorHeader'];
            }

            // Ensure promptData is available for downstream dataObject reconstruction
            data.promptData = effectivePayload;
          }

          if (!isChatResponse) {
            this.pushChatResponseEntry('AgentPayload', effectivePayload);
            this.pushChatResponseEntry('SignificanceVsReference', this.SignificanceVsReference);
            this.pushChatResponseEntry('DefaultConfidenceLevel', this.DefaultConfidenceLevel);
            this.pushChatResponseEntry('selectedWeight', this.selectedWeight);
            this.pushChatResponseEntry('failedCase', this.failedCase);
            this.pushChatResponseEntry('noContentFlag', this.noContentFlag);
            this.pushChatResponseEntry('errorHeader', this.errorHeader);
          }

          this.promptData = effectivePayload || {};
          this.mcode = effectivePayload?.mcode;


          // Requirement: Step 2 - Call unified endpoint with chatPayload to get finalized output data (Analytical Task)
          if (!isChatResponse && this.chatPayload) {
            let opData: any;
            const activeCount = (this.hasSnapshotActive ? 1 : 0) + (this.hasBrandAnalysisActive ? 1 : 0) + (this.hasCrosstabActive ? 1 : 0);

            try {
              if (response && response.isPreFetched && response.payload) {
                console.log(`[ORCHESTRATION] Using pre-fetched payload for mcode ${this.mcode}`);
                opData = response.payload;
              } else {
                console.log(`[ORCHESTRATION] Requesting finalized output (Step 2) for mcode ${this.mcode}`);

                // Parallel background fetch for fallback modules (if not already handled by pre-fetch)
                if (this.parallelChatPayload) {
                  console.log('[ORCHESTRATION] Triggering parallel background payload fetch for:', this.parallelChatPayload.mcode);
                  let pObs$ = this.parallelChatPayload.mcode === 3 ? this.apiService.crosstabPayloadAPI(this.parallelChatPayload) :
                    (this.parallelChatPayload.mcode === 2 ? this.apiService.brandAnalysisPayloadAPI(this.parallelChatPayload) : null);
                  if (pObs$) pObs$.subscribe({ error: () => { } });
                }

                if (this.mcode === 1) opData = await this.apiService.snapshotPayloadAPI(this.chatPayload).toPromise();
                else if (this.mcode === 2) opData = await this.apiService.brandAnalysisPayloadAPI(this.chatPayload).toPromise();
                else if (this.mcode === 3) opData = await this.apiService.crosstabPayloadAPI(this.chatPayload).toPromise();
              }

              if (opData) {
                console.log('[ORCHESTRATION-SUCCESS] Analytical data ready for mcode:', this.mcode);
                data.response = opData.response || opData;
                data.payload = opData;

                console.log('[ORCHESTRATION-DEBUG] Saving specialized payloads if present:', {
                  mcode: this.mcode,
                  hasCrosstab: !!opData.crosstab_payload,
                  hasSnapshot: !!opData.snapshot_payload,
                  hasBrandAnalysis: !!opData.brand_analysis_payload
                });

                if (this.mcode == 3 && opData.crosstab_payload) {
                  this.lastCrosstabPayload = opData.crosstab_payload;
                  console.log('[ORCHESTRATION-DEBUG] lastCrosstabPayload saved');
                } else if (this.mcode == 1 && opData.snapshot_payload) {
                  this.lastSnapshotPayload = opData.snapshot_payload;
                } else if (this.mcode == 2) {
                  // Backend returns 'brand_anlysis_payload' (typo) — handle both spellings + chatPayload fallback
                  const bPayload = opData.brand_analysis_payload || opData.brand_anlysis_payload || this.chatPayload;
                  this.lastBrandAnalysisPayload = bPayload;
                  console.log('[ORCHESTRATION-DEBUG] lastBrandAnalysisPayload saved, source:',
                    opData.brand_analysis_payload ? 'brand_analysis_payload' :
                      opData.brand_anlysis_payload ? 'brand_anlysis_payload (typo key)' : 'chatPayload fallback');
                }

                // History Bundling & Metadata persistence
                if (opData.response_payload_trendline) {
                  this.currentRowPayloadTrendline = opData.response_payload_trendline;
                  data.response.response_payload_trendline = opData.response_payload_trendline;
                  console.log('[DEBUG] Bundled response_payload_trendline');
                }
                if (opData.trendline_response) {
                  this.currentTrendlineResponse = opData.trendline_response;
                  data.response.trendline_response = opData.trendline_response;
                  console.log('[DEBUG] Bundled trendline_response');
                }
                if (opData.customization_Properties_trendline) {
                  this.currentCustomizationTrendline = opData.customization_Properties_trendline;
                  data.response.customization_Properties_trendline = opData.customization_Properties_trendline;
                }
                // Store response_payload for significance re-render support
                if (opData.response_payload) {
                  data.response.response_payload = opData.response_payload;
                  console.log('[DEBUG] Bundled response_payload for significance support');
                }
                if (opData.customization_Properties) data.customization_Properties = opData.customization_Properties;
                if (opData.quadrantText) data.quadrantText = opData.quadrantText;
                data.promptData = this.promptData;

                if (!isChatResponse) {
                  const key = (this.mcode === 1) ? 'getSnapshotOutput' : 'getConfiguration';
                  this.pushChatResponseEntry(key, opData);
                  this.pushChatResponseEntry('getConfiguration', opData);
                  this.pushChatResponseEntry('getSnapshotConfiguration', this.promptData);

                  if (this.mcode !== 1 && this.mcode !== 2 && this.mcode !== 3 && activeCount <= 1) {
                    console.log(`[SAVE-HISTORY] Saving immediate response for fallback mcode ${this.mcode}`);
                    this.saveChatList(this.inputValue || this.promptData?.user_input || 'Analytics Question', this.chatResponse, this.defaultQuestionAnswer);
                  }
                }
                this.cdr.detectChanges();
              }
            } catch (err: any) {
              console.error(`[API-ERROR] Failed to finalize analysis for mcode ${this.mcode}:`, err);
              this.isStreamFinished = false;
              this.stopAiLoader();
              this.failedCase = true;

              let errorMsg = 'I apologize, but I encountered an unexpected error while finalizing your analysis. Please try again.';
              this.errorHeader = 'Analysis Error:';

              if (err.status === 400) {
                errorMsg = 'Problem with the request parameters. Please refine your query.';
                this.errorHeader = 'Invalid Request:';
              } else if (err.status === 500) {
                errorMsg = 'Server error occurred while finalizing analysis.';
                this.errorHeader = 'Server Error:';
              }

              if (!isChatResponse) {
                this.pushChatResponseEntry('failedCase', true);
                this.pushChatResponseEntry('errorHeader', this.errorHeader);
                if (this.chatPreviewBlocks.length > 0) {
                  this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].QuestionAnswer = 'An error occurred during final processing.';
                }
              }

              this.insightsVal = errorMsg;
              this._insightsSerive.showInisghts({
                header: this.errorHeader || 'Analysis Error',
                message: errorMsg,
                show: true,
              });
              this.isInsightspopupOpen = true;
              return;
            }
          }



          if (!isChatResponse && (!data?.response || Object.keys(data.response).length === 0)) {
            const noContentMsg = 'I apologize, but I couldn\'t find any relevant data for your question. This might be because:<br><br>• The requested data is not available in the current study<br>• Your query might need to be more specific<br>• There may be data access restrictions<br><br>Please try rephrasing your question or contact your administrator for assistance.';
            const shortNoContentMsg = 'No relevant data found for the current study. Please rephrase your question.';

            this.failedCase = true;
            this.noContentFlag = true;
            this.errorHeader = 'Data Status:';
            this.isStreamFinished = false;
            this.arktabaccess = false;
            this.insightsVal = noContentMsg;

            if (!isChatResponse) {
              this.pushChatResponseEntry('failedCase', true);
              this.pushChatResponseEntry('noContentFlag', true);
              this.pushChatResponseEntry('errorHeader', this.errorHeader);
            }

            if (this.chatPreviewBlocks.length > 0) {
              const lastIdx = this.chatPreviewBlocks.length - 1;
              this.chatPreviewBlocks[lastIdx].QuestionAnswer = shortNoContentMsg;
              // Removed saveChatList to prevent recording 'no data' questions in history
            } else if (this.inputValue) {
              this.chatPreviewBlocks.push({
                question: this.inputValue,
                response: '',
                QuestionAnswer: shortNoContentMsg
              });
              // Removed saveChatList to prevent recording 'no data' questions in history
            }

            setTimeout(() => {
              const chatScroll = document.querySelector('.chat-history-scroll');
              if (chatScroll) {
                chatScroll.scrollTop = chatScroll.scrollHeight;
              }
            }, 100);

            const noContentObj: InsightsModel = {
              header: this.errorHeader,
              message: noContentMsg,
              show: true,
            };
            this._insightsSerive.showInisghts(noContentObj);
            this.isInsightspopupOpen = true;
            return;
          }
          const rowData = data.payload?.Row || data.promptData?.row || data.promptData?.Row;
          const colData = data.payload?.Column || data.promptData?.column || data.promptData?.Column;
          const colNestData = data.payload?.ColNesting || data.promptData?.col_nesting || data.promptData?.column_nesting || [];
          const rowNestData = data.payload?.RowNesting || data.promptData?.row_nesting || [];
          const filters = data.payload?.Filter || data.promptData?.filters || {};

          if (rowData && Array.isArray(rowData) && rowData.length > 0) {

            if (typeof rowData[0] === 'object' && rowData[0].Parent) {
              this.AssignDataToDataObject(data.payload || data.promptData);
            } else {

              const convertToDataObject = (arr: any, fallbackType: string): checkboxSelectionWithParent[] => {
                let actualArr: string[] = [];
                if (Array.isArray(arr)) {
                  actualArr = arr;
                } else if (typeof arr === 'string' && arr.trim() !== '') {
                  actualArr = [arr];
                }

                if (actualArr.length === 0) return [];

                const groups: { [key: string]: string[] } = {};
                actualArr.forEach(item => {
                  const parts = item.split('|');
                  const parent = parts.length > 1 ? parts[0] : fallbackType;
                  if (!groups[parent]) groups[parent] = [];
                  groups[parent].push(item);
                });

                return Object.keys(groups).map(parent => ({
                  Parent: parent,
                  SortId: 0,
                  Data: groups[parent].map((item, index): checkboxSelection => {
                    const parts = item.split('|');
                    // Normalize: If top 2 levels are identical, trim the redundant first level
                    // e.g. "Brands|Brands|Value" -> "Brands|Value"
                    // Also strip the parent prefix from Child since rowChild/colChild in the
                    // API data don't include the parent level
                    let normalizedChild: string;
                    if (parts.length >= 3 && parts[0] === parts[1]) {
                      normalizedChild = parts.slice(1).join('|');
                    } else if (parts.length >= 3 && parts[0] === parent) {
                      normalizedChild = parts.slice(1).join('|');
                    } else {
                      normalizedChild = item;
                    }
                    return {
                      CheckboxStatus: true,
                      Child: normalizedChild,
                      variablecode: '',
                      responsecode: '',
                      isDerviedVariable: false,
                      CalculationType: 'share',
                      sort_id: index + 1,
                      year_response_code: '',
                      year_variable_code: '',
                      Date: '',
                      isMultiPunch: 0,
                      isTimePeriod: parent.toLowerCase().includes('time'),
                      isMarket: parent.toLowerCase().includes('market'),
                      multiPunchMetric: '',
                      MultiPunchNumber: 0,
                      isCustomGroup: false,
                      kibanaFilterScript: '',
                      customGroupId: '',
                      isRolling: false,
                      isCustomCalculation: false,
                      customCalculationId: ''
                    };
                  }),
                  isMultiPunch: false,
                  MultiPunchNumber: 0,
                  isCustomGroup: false,
                  customGroupId: '',
                  isCustomCalculation: false,
                  customCalculationId: '',
                  brandanalysisCode: (this.mcode === 2) ? 1 : 0,
                  is_entrypoint: false
                }));
              };

              this.dataObject.Row = convertToDataObject(rowData, 'Row');
              this.dataObject.Column = convertToDataObject(colData, 'Column');
              this.dataObject.ColNesting = convertToDataObject(colNestData, 'ColNesting');
              this.dataObject.RowNesting = convertToDataObject(rowNestData, 'RowNesting');

              // Handle new filters object structure { market: "", time_period: "", audience: [] }
              let filterList: string[] = [];
              if (Array.isArray(filters)) {
                filterList = filters;
              } else if (typeof filters === 'object' && filters !== null) {
                if (filters.market) filterList.push(filters.market);
                if (filters.time_period) filterList.push(filters.time_period);
                if (filters.audience && Array.isArray(filters.audience)) {
                  filterList = [...filterList, ...filters.audience];
                }
              }
              this.dataObject.Filter = convertToDataObject(filterList, 'Filter');

            }
          }


          if (this.promptData && typeof this.promptData === 'object') {
            this.promptData.entryPointData = this.dataArray;
            this.isTotalBase = this.promptData.isTotalBase !== undefined ? this.promptData.isTotalBase : false;
            this.selectedWeight = this.promptData.weight || 'Unweighted';
            if (!isChatResponse && this.chatPreviewBlocks.length === 0 && this.promptData?.user_input) {
              this.chatPreviewBlocks.push({ question: this.promptData.user_input, response: '', QuestionAnswer: this.defaultQuestionAnswer });
            }
          } else {
            this.isTotalBase = false;
            this.selectedWeight = 'Unweighted';
          }
          // Requirement: Snapshot module (mcode==1) with Elasticsearch chat history support
          // Support both fresh API responses and saved chat data from Elasticsearch
          if (this.mcode == 1) {
            this._configService.snapshotProductType = 'custom';
            this._configService.selectedSnapshotType = data.promptData?.Snapshot_Type || data.promptData?.snapshot_type;
            this.selectedSection = data.promptData?.Section || data.promptData?.section;
            this.widget_Id = data.promptData?.Widget_ID || data.promptData?.widget_id;
            this.widget_Name = data.promptData?.Widget_Name || data.promptData?.widget_name;

            this.widegtconfigdetails.section = this.promptData?.Section || this.promptData?.section || '';
            // Select data source: getSnapshotOutput for saved chats, data.response for fresh queries
            let snapshotDataSource = null;
            if (isChatResponse && getSnapshotOutput) {
              snapshotDataSource = getSnapshotOutput;
              // Ensure trendline data is available for historical chats
              if (snapshotDataSource.response_payload_trendline) {
                this.currentRowPayloadTrendline = snapshotDataSource.response_payload_trendline;
              }
              if (snapshotDataSource.trendline_response) {
                this.currentTrendlineResponse = snapshotDataSource.trendline_response;
              }
              if (snapshotDataSource.customization_Properties_trendline) {
                this.currentCustomizationTrendline = snapshotDataSource.customization_Properties_trendline;
              }
              console.log('[DEBUG] Historical snapshotDataSource loaded with trend component properties presence:', !!this.currentTrendlineResponse);
            } else if (data != null && data != undefined && data != '' && data.response != null && data.response.Data != null) {
              snapshotDataSource = data.response;
            } else {
            }

            if (snapshotDataSource != null && snapshotDataSource.Data != null) {
              try {
                let opData = JSON.parse(snapshotDataSource.Data);
                this.MainResult = opData;


                // Requirement: Save snapshot output to Elasticsearch for chat history persistence
                if (!isChatResponse) {
                  this.pushChatResponseEntry('getSnapshotOutput', snapshotDataSource);
                }

                const sortedOPdata = opData.sort(
                  (a: any, b: any) => a.widgetNumber - b.widgetNumber
                );

                const snapTypeVal = this.promptData.Snapshot_Type || this.promptData.snapshot_type;
                if (snapTypeVal) {
                  this._configService.selectedcompareacrossOption = snapTypeVal;
                }

                try {
                  this.SelectionSummary();
                } catch (error) {
                  const studyInfo = this.selected_study || 'BHT 2';
                  const snapshotType = this.promptData.Snapshot_Type || this.promptData.snapshot_type || 'Single Brand';
                  const widgetName = sortedOPdata[0]?.widgetName || 'Analysis';

                  const pData = this.promptData || {};
                  const mktData = pData.Markets || pData.markets || pData.Market || pData.market || [];
                  const tpData = pData.Time_Period || pData.time_period || pData.TimePeriod || pData.timeperiod || [];

                  const extractName = (item: any) => {
                    if (typeof item === 'string') {
                      const parts = item.split('|');
                      if (parts.length >= 2) {
                        return parts[parts.length - 2] + ': ' + parts[parts.length - 1];
                      }
                      return parts.pop();
                    }
                    if (item && item.name) return item.name;
                    if (item && item.Child) return item.Child;
                    return String(item);
                  };

                  const marketNames = mktData.length > 0 ? mktData.map((m: any) => extractName(m)).join(', ') : 'All Markets';
                  const timePeriodNames = tpData.length > 0 ? tpData.map((t: any) => extractName(t)).join(', ') : 'All Time Periods';

                  this.selectionSummary = `<span class="summary-label">Study:</span> ${studyInfo} <span class="grey-separator"> || </span> ` +
                    `<span class="summary-label">Snapshot Type:</span> ${snapshotType} <span class="grey-separator"> || </span> ` +
                    `<span class="summary-label">Market:</span> ${marketNames} <span class="grey-separator"> || </span> ` +
                    `<span class="summary-label">Time Period:</span> ${timePeriodNames} <span class="grey-separator"> || </span> ` +
                    `<span class="summary-label">Widget:</span> ${widgetName}`;

                }

                this._configService.standardSnapOutputData = sortedOPdata;
                this.OutputData = sortedOPdata;

                if (sortedOPdata && sortedOPdata.length > 0) {

                  // Requirement: Prepare filteredWidgetData structure for output-popup component
                  if (this.widgetData && this.widgetData.length > 0) {
                    const matchedWidget = this.widgetData.find(
                      (widget: any) => widget.previewChartPostion == this.promptData.Widget_ID
                    );

                    if (matchedWidget) {
                      matchedWidget.customizationProperties = this.getFormattedCustomProperties(matchedWidget.customizationProperties, matchedWidget.widgetchart_name);

                      // Re-apply colChild formatting for multi-market in pre-structured widgetData
                      if (matchedWidget.metric?.[0]?.metric_value) {
                        matchedWidget.metric[0].metric_value.forEach((metricRow: any) => {
                          if (metricRow.data && Array.isArray(metricRow.data)) {
                            metricRow.data.forEach((dataArrEntry: any) => {
                              const colParts = (dataArrEntry.colChild || '').split('|');
                              const specificCol = colParts.pop() || dataArrEntry.colChild;
                              const parentLabel = colParts.pop() || 'Market';

                              // Use only market name as specific part (Table1 uses split('|')[1])
                              dataArrEntry.colChild = `${parentLabel}|${specificCol}`;
                            });
                          }
                        });
                      }

                      this.filteredWidgetData = matchedWidget;
                      this.filteredWidgetID = matchedWidget.previewChartPostion;
                    } else {

                      // SMART WIDGET SELECTION: Match question natively first, then query Widget_ID, then default
                      let selectedWidget: any = null;
                      const currentQuestion = (this.currentQuestion || '').toLowerCase();
                      const uniqueWidgets = _.uniqBy(sortedOPdata, 'widgetNumber');

                      if (currentQuestion) {
                        const matchedWidget: any = uniqueWidgets.find((widget: any) =>
                          currentQuestion.includes(widget.widgetName.toLowerCase())
                        );
                        if (matchedWidget) {
                          selectedWidget = matchedWidget;
                        }
                      }

                      if (!selectedWidget) {
                        const targetWidgetID = this.promptData?.Widget_ID || this.promptData?.widget_id;
                        if (targetWidgetID) {
                          const idMatchedWidget: any = uniqueWidgets.find((widget: any) => String(widget.widgetNumber) === String(targetWidgetID));
                          if (idMatchedWidget) {
                            selectedWidget = idMatchedWidget;
                          }
                        }
                      }

                      if (!selectedWidget) {
                        selectedWidget = sortedOPdata[0];
                      }

                      // Filter sortedOPdata to only include rows from the selected widget
                      const widgetFilteredData = sortedOPdata.filter((item: any) =>
                        item.widgetNumber === selectedWidget.widgetNumber
                      );


                      // Fallback base for rows with null base (like 'Overall Consideration')
                      const fallbackBase = widgetFilteredData.find((r: any) => r.answerUnweightedBase != null)?.answerUnweightedBase || 999;

                      // DEBUG: log raw colChild/Level1ColChild from backend (Path 1)
                      if (widgetFilteredData.length > 0) {
                        console.log('[MULTI-MARKET DEBUG Path1] First row raw data:', {
                          colChild: widgetFilteredData[0].colChild,
                          Level1ColChild: widgetFilteredData[0].Level1ColChild,
                          rowChild: widgetFilteredData[0].rowChild
                        });
                        console.log('[MULTI-MARKET DEBUG Path1] Unique colChild values:', [...new Set(widgetFilteredData.map((r: any) => r.colChild))]);
                        console.log('[MULTI-MARKET DEBUG Path1] Unique Level1ColChild values:', [...new Set(widgetFilteredData.map((r: any) => r.Level1ColChild))]);
                      }

                      const uniqueMetrics = _.uniqBy(widgetFilteredData, 'rowChild').map((item: any) => ({
                        option: item.rowChild,
                        selectOrder: 0,
                        typeofmetric: 'METRIC',
                        metric_group: '',
                        data: widgetFilteredData
                          .filter((row: any) => row.rowChild === item.rowChild)
                          .map((row: any) => {
                            const dataValue = row.answerWeightedShare;
                            const data2Value = row.answerWeightedShareIndex;

                            // Specific Market extraction for Table1Component compatibility:
                            const colParts = (row.colChild || '').split('|');
                            const specificCol = colParts.pop() || row.colChild;
                            const parentLabel = colParts.pop() || 'Market';

                            // Format: "Parent|Market" (Table1 uses split('|')[1])
                            const resolvedColChild = `${parentLabel}|${specificCol}`;

                            return {
                              data: dataValue,
                              data2: data2Value,
                              lvl1Child: row.Level1ColChild,
                              colChild: resolvedColChild,
                              rowChild: row.rowChild,
                              totalUnweightedBase: row.totalUnweightedBase,
                              totalUnweightedShare: row.totalUnweightedShare,
                              totalWeightedBase: row.totalWeightedBase,
                              totalWeightedShare: row.totalWeightedShare,
                              totalWeightedShareIndex: row.totalWeightedShareIndex,
                              answerUnweightedBase: row.answerUnweightedBase,
                              answerUnweightedShare: row.answerUnweightedShare,
                              answerWeightedBase: row.answerWeightedBase,
                              answerWeightedShare: row.answerWeightedShare,
                              answerWeightedShareIndex: row.answerWeightedShareIndex,
                              changeVsPY_Answer: row.changeVsPY_Answer,
                              changeVsPY_Total: row.changeVsPY_Total,
                              Level1ColResponseCode: row.Level1ColResponseCode,
                              Level1NestColVariableCode: row.Level1NestColVariableCode,
                              CalculationType: row.CalculationType || 'share',
                              CalculationTypeIndex: row.CalculationTypeIndex || 'index',
                              baseValueforLSorIs: row.answerUnweightedBase ?? fallbackBase,
                              changeVsPY: row.changeVsPY_Answer,
                              Significance_Value: row.Significance_Answer
                            };
                          })
                      }));

                      // Sort uniqueMetrics in descending order of values
                      uniqueMetrics.sort((a: any, b: any) => {
                        const valA = a.data?.[0]?.data ?? 0;
                        const valB = b.data?.[0]?.data ?? 0;
                        return valB - valA; // Descending
                      });

                      const isBubbleChart = selectedWidget.widgetChartType.toLowerCase().includes('bubble');

                      this.filteredWidgetData = {
                        widgetchart_name: selectedWidget.widgetChartType,
                        widget_name: selectedWidget.widgetName,
                        previewChartPostion: selectedWidget.widgetNumber,
                        customizationProperties: this.getFormattedCustomProperties(data.customization_Properties || selectedWidget.customization_Properties, selectedWidget.widgetChartType),
                        quadrantText: data.quadrantText ? JSON.stringify(data.quadrantText) : null,
                        metric: isBubbleChart ? [
                          { metric_option: 'XAxis Metric', metric_group: '', metric_value: [uniqueMetrics[0]] },
                          { metric_option: 'YAxis Metric', metric_group: '', metric_value: [uniqueMetrics[1]] },
                          { metric_option: 'ZAxis Metric', metric_group: '', metric_value: [uniqueMetrics[2]] }
                        ] : [{
                          metric_option: 'Data',
                          metric_group: '',
                          metric_value: uniqueMetrics
                        }],
                        response_payload_trendline: data.response_payload_trendline,
                        trendline_response: data.trendline_response
                      };
                      this.filteredWidgetID = selectedWidget.widgetNumber;

                    }
                  } else {

                    // SMART WIDGET SELECTION: Match question to widget name first, fallback to payload Widget_ID, then default to first
                    let selectedWidget: any = null;
                    const currentQuestion = (this.currentQuestion || '').toLowerCase();
                    const uniqueWidgets = _.uniqBy(sortedOPdata, 'widgetNumber');


                    // 1. Try to find widget whose name matches the user's question
                    if (currentQuestion) {
                      const matchedWidget: any = uniqueWidgets.find((widget: any) =>
                        currentQuestion.includes(widget.widgetName.toLowerCase())
                      );

                      if (matchedWidget) {
                        selectedWidget = matchedWidget;
                      }
                    }

                    // 2. If no text match, fallback to what the Python orchestrator provided
                    if (!selectedWidget) {
                      const targetWidgetID = this.promptData?.Widget_ID || this.promptData?.widget_id;
                      if (targetWidgetID) {
                        const idMatchedWidget: any = uniqueWidgets.find((widget: any) => String(widget.widgetNumber) === String(targetWidgetID));
                        if (idMatchedWidget) {
                          selectedWidget = idMatchedWidget;
                        }
                      }
                    }

                    // 3. Absolute fallback to first index
                    if (!selectedWidget) {
                      selectedWidget = sortedOPdata[0];
                    }

                    // Filter sortedOPdata to only items from the selected widget
                    const widgetFilteredData = sortedOPdata.filter((item: any) =>
                      item.widgetNumber === selectedWidget.widgetNumber
                    );


                    // Fallback base for rows with null base (like 'Overall Consideration')
                    const fallbackBase = widgetFilteredData.find((r: any) => r.answerUnweightedBase != null)?.answerUnweightedBase || 999;

                    // DEBUG: log raw colChild/Level1ColChild from backend (Path 2)
                    if (widgetFilteredData.length > 0) {
                      console.log('[MULTI-MARKET DEBUG Path2] First row raw data:', {
                        colChild: widgetFilteredData[0].colChild,
                        Level1ColChild: widgetFilteredData[0].Level1ColChild,
                        rowChild: widgetFilteredData[0].rowChild
                      });
                      console.log('[MULTI-MARKET DEBUG Path2] Unique colChild values:', [...new Set(widgetFilteredData.map((r: any) => r.colChild))]);
                      console.log('[MULTI-MARKET DEBUG Path2] Unique Level1ColChild values:', [...new Set(widgetFilteredData.map((r: any) => r.Level1ColChild))]);
                    }

                    const uniqueMetrics = _.uniqBy(widgetFilteredData, 'rowChild').map((item: any) => ({
                      option: item.rowChild,
                      selectOrder: 0,
                      typeofmetric: 'METRIC',
                      metric_group: '',
                      data: widgetFilteredData
                        .filter((row: any) => row.rowChild === item.rowChild)
                        .map((row: any) => {
                          const dataValue = row.answerWeightedShare;
                          const data2Value = row.answerWeightedShareIndex;

                          // Specific Market extraction for Table1Component compatibility:
                          const colParts = (row.colChild || '').split('|');
                          const specificCol = colParts.pop() || row.colChild;
                          const parentLabel = colParts.pop() || 'Market';

                          // Format: "Parent|Market" (Table1 uses split('|')[1])
                          const resolvedColChild = `${parentLabel}|${specificCol}`;

                          return {
                            data: dataValue,
                            data2: data2Value,
                            lvl1Child: row.Level1ColChild,
                            colChild: resolvedColChild,
                            rowChild: row.rowChild,
                            totalUnweightedBase: row.totalUnweightedBase,
                            totalUnweightedShare: row.totalUnweightedShare,
                            totalWeightedBase: row.totalWeightedBase,
                            totalWeightedShare: row.totalWeightedShare,
                            totalWeightedShareIndex: row.totalWeightedShareIndex,
                            answerUnweightedBase: row.answerUnweightedBase,
                            answerUnweightedShare: row.answerUnweightedShare,
                            answerWeightedBase: row.answerWeightedBase,
                            answerWeightedShare: row.answerWeightedShare,
                            answerWeightedShareIndex: row.answerWeightedShareIndex,
                            changeVsPY_Answer: row.changeVsPY_Answer,
                            changeVsPY_Total: row.changeVsPY_Total,
                            Level1ColResponseCode: row.Level1ColResponseCode,
                            Level1NestColVariableCode: row.Level1NestColVariableCode,
                            CalculationType: row.CalculationType || 'share',
                            CalculationTypeIndex: row.CalculationTypeIndex || 'index',
                            baseValueforLSorIs: row.answerUnweightedBase ?? fallbackBase,
                            changeVsPY: row.changeVsPY_Answer,
                            Significance_Value: row.Significance_Answer
                          };
                        })
                    }));

                    // Sort uniqueMetrics in descending order of values as per user request
                    uniqueMetrics.sort((a: any, b: any) => {
                      const valA = a.data?.[0]?.data ?? 0;
                      const valB = b.data?.[0]?.data ?? 0;
                      return valB - valA; // Descending
                    });

                    const isBubbleChart = selectedWidget.widgetChartType.toLowerCase().includes('bubble');

                    this.filteredWidgetData = {
                      widgetchart_name: selectedWidget.widgetChartType,
                      widget_name: selectedWidget.widgetName,
                      previewChartPostion: selectedWidget.widgetNumber,
                      customizationProperties: this.getFormattedCustomProperties(data.customization_Properties || selectedWidget.customization_Properties, selectedWidget.widgetChartType),
                      quadrantText: data.quadrantText ? JSON.stringify(data.quadrantText) : null,
                      metric: isBubbleChart ? [
                        { metric_option: 'XAxis Metric', metric_group: '', metric_value: [uniqueMetrics[0]] },
                        { metric_option: 'YAxis Metric', metric_group: '', metric_value: [uniqueMetrics[1]] },
                        { metric_option: 'ZAxis Metric', metric_group: '', metric_value: [uniqueMetrics[2]] }
                      ] : [{
                        metric_option: 'Data',
                        metric_group: '',
                        metric_value: uniqueMetrics  // Array of objects, not JSON string
                      }],
                      response_payload_trendline: data.response_payload_trendline,
                      trendline_response: data.trendline_response
                    };
                    this.filteredWidgetID = selectedWidget.widgetNumber;


                    const compareAcross = data.promptData?.Snapshot_Type || data.promptData?.snapshot_type;
                    const section = data.promptData?.Section || data.promptData?.section;

                    const pData = data.promptData || {};
                    const marketsArray = pData.Markets || pData.markets || pData.Market || pData.market || [];
                    const brandsArray = pData.Primary_Brands || pData.primary_brands || pData.Brands || pData.brands || [];
                    const timeperiodArray = pData.Time_Period || pData.time_period || pData.TimePeriod || pData.timeperiod || [];
                    const metricsArray = pData.Primary_Metrics || pData.primary_metrics || pData.Metrics || pData.metrics || pData.Selected_Metrics || [];
                    const filtersArray = pData.Filter_Audience || pData.filter_audience || pData.Filters || pData.filters || [];


                    const extractValue = (item: any) => {
                      if (typeof item === 'string') {
                        const parts = item.split('|');
                        if (parts.length >= 2) {
                          return parts[parts.length - 2] + ': ' + parts[parts.length - 1];
                        }
                        return parts.pop();
                      }
                      if (item && item.name) return item.name;
                      if (item && item.Child) return item.Child;
                      return String(item);
                    };

                    const extractLastPartOnly = (item: any) => {
                      if (typeof item === 'string') return item.split('|').pop();
                      if (item && item.name) return item.name;
                      if (item && item.Child) return item.Child;
                      return String(item);
                    };

                    const markets = marketsArray.length > 0 ? marketsArray.map((f: any) => extractLastPartOnly(f)).join(', ') : '';
                    const entryPoint = 'Markets: ' + markets;

                    const brands = brandsArray.length > 0 ? brandsArray.map((c: any) => extractValue(c)).join(', ') : '';
                    const timeperiod = timeperiodArray.length > 0 ? timeperiodArray.map((f: any) => extractValue(f)).join(', ') : '';
                    const filters = filtersArray.length > 0 ? filtersArray.map((f: any) => extractValue(f)).join(', ') : 'All Respondents';

                    const primaryMetric = metricsArray.map((r: any) => extractValue(r)).join(', ');
                    const metricNames = primaryMetric || uniqueMetrics.map((m: any) => m.option).join(', ');

                    const baseType = data.promptData?.isTotalBase ? BASE_TYPES.TOTAL : BASE_TYPES.ANSWER;


                    let selections = 'Time Period: ' + timeperiod + '; Brands: ' + brands;
                    if (filtersArray.length > 0) {
                      selections += '; Filters: ' + filters;
                    }

                    this._configService.selectionSummaryTextTitle =
                      'Compare Across: ' + compareAcross + ': ' + section +
                      ' || Entry Point: Markets: ' + markets +
                      ' || Selections: ' + selections +
                      ' || Significance: None' +
                      ' || Base: ' + baseType +
                      ' || Weight: Primary Weight';

                    this.GenerateSelectionSummary();

                    if (!this.Snapshotdataforexport) {
                      this.Snapshotdataforexport = this._configService.getDropdownValues();
                    }

                    this.Snapshotdataforexport.compareAcross = compareAcross;
                    if (marketsArray.length > 1) {
                      this._configService.selectedSnapshotType = 'Multiple Markets';
                    } else {
                      this._configService.selectedSnapshotType = compareAcross || 'Standard Chart';
                    }
                    this.Snapshotdataforexport.snapshotName = data.promptData?.Snapshot_Name || 'Snapshot';
                    this.Snapshotdataforexport.clientName = this.selected_client;
                    this.Snapshotdataforexport.studyName = this.selected_study;
                    this.Snapshotdataforexport.selectionSummary = this._configService.selectionSummaryTextTitle;
                    this.Snapshotdataforexport.baseType = baseType;
                  }
                } else {
                }


                if (this.widgetData && this.widgetData.length > 0) {
                  this.afterSubmit();
                } else {
                  this.outputData = sortedOPdata;

                  // Populate allPageOutputData / allPageOutputDataWithoutTrend so
                  // editablePPTClicked() and excelexportClicked() can find the data
                  // even when afterSubmit() was not called.
                  if (this.filteredWidgetData) {
                    const widgetItems = [this.filteredWidgetData];
                    this._configService.allPageOutputData = [widgetItems];
                    this._configService.allPageOutputDataWithoutTrend = [widgetItems];
                  }
                }

                const outputViewDiv = document.querySelector('.output-view');
                if (outputViewDiv) {
                  outputViewDiv?.classList.remove('DN');
                }

                console.log('[SNAPSHOT DEBUG] Setting showSnapshot = true');
                console.log('[SNAPSHOT DEBUG] State before showSnapshot:', {
                  showSnapshot: this.showSnapshot,
                  arktabaccess: this.arktabaccess,
                  failedCase: this.failedCase,
                  filteredWidgetData: !!this.filteredWidgetData,
                  filteredWidgetID: this.filteredWidgetID
                });

                // [UNIVERSAL TREND INJECTION] 
                // Hard-inject stored trend components into filteredWidgetData just before exposing to UI
                if (this.filteredWidgetData) {
                  if (this.currentRowPayloadTrendline) this.filteredWidgetData.response_payload_trendline = this.currentRowPayloadTrendline;
                  if (this.currentTrendlineResponse) this.filteredWidgetData.trendline_response = this.currentTrendlineResponse;
                  if (this.currentCustomizationTrendline) this.filteredWidgetData.customization_Properties_trendline = this.currentCustomizationTrendline;
                  // Inject response_payload so the popup can call snapshotPayloadService on significance change
                  const storedResponsePayload = data?.response?.response_payload;
                  if (storedResponsePayload && !this.filteredWidgetData.response_payload) {
                    this.filteredWidgetData.response_payload = storedResponsePayload;
                    console.log('[SNAPSHOT DEBUG] response_payload injected into filteredWidgetData for significance API support');
                  }

                  console.log('[SNAPSHOT DEBUG] Trendline data universally injected from component properties presence check:',
                    !!this.filteredWidgetData.trendline_response);
                }

                this.showSnapshot = true;


                setTimeout(() => MarkdownPayloadHelper.buildSnapshotMarkdown(this), 500);
              } catch (error) {
              }
            } else {
            }

            this.Snapshotdataforexport = this._configService.getDropdownValues();

            if (!this.selectionSummary || this.selectionSummary === '') {
              this.selectionSummary = 'Snapshot Analysis';
            }
            if (!this.confidenceLevel || this.confidenceLevel === '') {
              this.confidenceLevel = '90%';
            }
            if (!this.selected_study) {
              this.selected_study = this.landingdata?.study || 'BHT 2';
            }
            if (!this.selected_client) {
              this.selected_client = this.landingdata?.client_code || this.promptData?.Client_Code;
            }

            const insightsStartTime = performance.now();

            // Call insights API for snapshot (mcode == 1)
            const markdownData = this.buildSnapshotMarkdownForAPI();
            const widget_details = {
              snapshot_type: this.promptData?.Snapshot_Type || this.promptData?.snapshot_type || '',
              snapshot_name: this.promptData?.Snapshot_Name || this.promptData?.snapshot_name || '',
              section: this.promptData?.Section || this.promptData?.section || '',
              widget_id: this.promptData?.Widget_ID || this.promptData?.widget_id || '',
              widget_name: this.promptData?.Widget_Name || this.promptData?.widget_name || ''
            };

            if (isChatResponse) {
              if (getSnapshotInsights) {
                this.OnInsigthsbuttonClick(isChatResponse, getSnapshotInsights, getSnapshotInsightsTrend);
                this.stopAiLoader();
                this.arktabaccess = false;
              } else {
                this.insightsVal = ['Insights not available for this historical chat.'];
                this.stopAiLoader();
                this.arktabaccess = false;
              }
            } else {
              if (!this.failedCase) {
                setTimeout(() => {
                  this.callInsightsAPI(this.mcode, markdownData, this.currentQuestion, widget_details);
                }, 600);
              }
            }
          }

          if (this.mcode != 1) {
            this.LoadRibbonData(this.filteredlist);

            // Force crosstab view for mcode 2 and 3
            this.showSnapshot = false;
            this.arktabaccess = false;
            this.isDiagnostic = true;
            this.existingquery = this.inputValue;
            this.OutputdataObject.Row = [];
            this.OutputdataObject.Column = [];
            this.CrossTabOutPutData = [];



            if (data.response != null && data.response.HasValidData !== false) {
              let outputstring = data.response;
              this.displayTable = true;
              this.resetChartStates('table');

              try {
                if (typeof outputstring.Data === 'string') {
                  this.CrossTabOutPutData = JSON.parse(outputstring.Data);
                } else if (Array.isArray(outputstring.Data)) {
                  this.CrossTabOutPutData = outputstring.Data;
                } else {
                  console.error('Unexpected outputstring.Data format:', typeof outputstring.Data);
                  this.CrossTabOutPutData = [];
                }
              } catch (parseError) {
                console.error('Error parsing outputstring.Data:', parseError);
                console.error('Raw outputstring.Data:', outputstring.Data);
                this.CrossTabOutPutData = [];
              }
              this.SelectionSummary();

              this.variableTabData = this.receivedData;
              if (typeof outputstring.Data === 'string') {
                this.CrossTabOutPutEntireData = JSON.parse(outputstring.Data);
              } else if (Array.isArray(outputstring.Data)) {
                this.CrossTabOutPutEntireData = outputstring.Data;
              } else {
                console.error('Unexpected outputstring.Data format for EntireData:', typeof outputstring.Data);
                this.CrossTabOutPutEntireData = [];
              }
              this.normalizeNestedChildFields(this.CrossTabOutPutEntireData);
              let chartType = 'column';
              chartType = this.isTranspose ? 'column' : 'bar';
              if (this.CrossTabOutPutEntireData.length > 0) {
                this.CrossTabOutPutData = this.CrossTabOutPutEntireData;
              }
              this.isTranspose = false;
              this.insufficientBase = this.insufficentBase || '';
              this.DefaultConfidenceLevel = 'None';
              this.isAnswerBase = false;
              this.isSampleSize = false;
              this.isWeightedLabel = false;
              this.LowBase = this.lowBase || '';
              this.isPairWise = false;
              this.DefaultSampleSize = 'None';
              this.threshold = '';
              this.selectedIndex = '';
              this.isIndex = false;
              this.selectedWeight = this.promptData.weight;
              this.isBrandAnalysis = this.promptData.mcode == 2 ? true : false;


              if (!this.isTotal) {
                const preFilterCount = this.CrossTabOutPutEntireData.length;
                this.CrossTabOutPutData = this.CrossTabOutPutEntireData.filter(
                  (x: any) => {
                    return !x.isTotal;
                  }
                );
              } else {
              }

              if (this.isIndex && this.selectedIndex != '') {
                this.manipulateIndexData();
              }

              this.BindTableOutput(this.CrossTabOutPutData);
              this.sortOutputData();


              this.isCreateBtnClick = true;
              if (this.isTranspose) {
                this.handleOutputdataObjectOnTransposeSelect();
              }
              if (
                this.OutputdataObject.Row.length != 0 &&
                this.OutputdataObject.Column.length != 0
              ) {
                this.displayTable = true;
                setTimeout(() => MarkdownPayloadHelper.storeTableAsMarkdown(this), 300);
              }
              const columndata = this.dataObject['Column'];

              const TimePeriodinColumn = columndata.filter((parent) => {
                return parent.Data.some((child) => child.isTimePeriod === true);
              });

              const rowdata = this.dataObject['Row'];
              const isMeanMetric = rowdata.filter((parent) => {
                return parent.Data.some((child) =>
                  child.CalculationType.toLowerCase() === 'mean' &&
                  child.isDerviedVariable == true);
              });

              const isShareMetric = rowdata.filter((parent) => {
                return parent.Data.some((child) => child.CalculationType.toLowerCase() === 'share');
              });

              const rowDataLengthForTrend = this.getDistinctChildValues(this.OutputdataObject.Row as any);
              const isLineChartAvailable = TimePeriodinColumn.length === 1 &&
                ((isShareMetric.length > 0 || isMeanMetric.length > 0) && rowDataLengthForTrend.length <= this.maxRowsPerSlide);
              this.disableLineChart = !isLineChartAvailable;

              const rowDataLength: number = rowdata.length > 0 ? (rowdata[0].Data?.length || 0) : 0;
              const rowNestData = this.dataObject['RowNesting'] || [];
              const colNestData = this.dataObject['ColNesting'] || [];

              this.isChartView = (rowNestData.length > 0 || colNestData.length > 0 || rowdata.length < 1 || rowDataLength > this.maxColumnsPerSlide || this.isIndex) ? false : true;


              this.crossTabService.setCrossTabOuputData(
                this.CrossTabOutPutData
              );
              if (this.isLineChartClick) {
                this.onTrendChartIconClick();
              } else if (
                this.isVerticalGroupBarChartClick ||
                this.isVerticalBarChartClick
              ) {
                this.VerticalChartClick(this.chartType);
              } else if (this.isVerticalStackChartClick) {
                this.onVerticalStackBarChartIconClick(this.chartType);
              }
              this.is_Time_Period_Present = true;

            } else {
              console.error('==== NO VALID RESPONSE DATA ====');
              console.error('data.response is null or HasValidData is false');
              console.error('Cannot populate CrossTabOutPutData');
              this.CrossTabOutPutData = [];
            }

            this.isInsightspopupOpen = false;
            this.arktabaccess = true;
            this.isInsightsBtnEnabled = true;


            if (this.CrossTabOutPutData && this.CrossTabOutPutData.length > 0) {
              const hasNonZeroData = this.CrossTabOutPutData.some((item: any) => {
                const hasValue = (item.totalWeightedShare > 0 ||
                  item.totalUnweightedShare > 0 ||
                  item.answerWeightedShare > 0 ||
                  item.answerUnweightedShare > 0 ||
                  item.value > 0);
                return hasValue;
              });


              if (!hasNonZeroData) {
                this.insightsVal = isChatResponse ? (getInsights || ['No insights available for this selection.']) : ['Metric values are zero or null for the selected criteria.'];
              }

              const markdownData = this.buildCrosstabMarkdownForAPI();

              if (isChatResponse) {
                if (getInsights) {
                  this.openInsights(isChatResponse, getInsights);
                } else {
                  this.insightsVal = ['Insights not available for this historical chat.'];
                  this.isInsightspopupOpen = true;
                  this.arktabaccess = false;
                }
              } else {
                if (!this.failedCase) {
                  setTimeout(() => {
                    this.callInsightsAPI(this.mcode, markdownData, this.currentQuestion, {});
                  }, 600);
                }
              }
            } else {
              console.error('[Insights Check] CrossTabOutPutData is empty, cannot generate insights');
              this.insightsVal = ['No output data available for this question.'];
              this.failedCase = true;
              this.isInsightspopupOpen = true;
              this.arktabaccess = false;
              if (!isChatResponse) {
                this.saveChatList(this.currentQuestion || 'Analytics Question', this.chatResponse, 'No output data available for this question.');
              }
            }
            if (isChatResponse || !this.CrossTabOutPutData || this.CrossTabOutPutData.length === 0) {
              this.arktabaccess = false;
            }
            this.LoadRibbonData(this.filteredlist);
            // OLD code - 08/12/2025
          }

          if (this.mcode == 99) {
            this.insightsVal = this.fallbackMessage();
            this.failedCase = true;
            this.errorHeader = 'Analysis Status:';
            this.isInsightspopupOpen = true;
            this.currentView = 'chat';

            if (!isChatResponse) {
              this.pushChatResponseEntry('failedCase', true);
              this.pushChatResponseEntry('errorHeader', this.errorHeader);
            }

            const errorMessage = this.fallbackMessage();
            const shortErrorMessage = 'I encountered an issue processing your query. Please try again.';
            if (this.chatPreviewBlocks.length > 0) {
              this.updateQuestionAnswerForSelectedMessage(shortErrorMessage);
            }

            // Removed saveChatList to prevent recording mcode 99 errors in history
            this.isDiagnostic = true;

            if (this.promptData && typeof this.promptData === 'object' && Object.keys(this.promptData).length > 0) {
              this.apiService.getOutputData(
                this.inputValue,
                this.landingdata.client_code,
                this.landingdata.study,
                [],
                this.promptData,
                this.weightFilter
              ).subscribe(
                (outputResponse) => {
                  this.promptData = outputResponse;
                  this.insightsVal = outputResponse.p_user_response || this.fallbackMessage();
                  this.Widget_Id = outputResponse.Widget_ID;
                  this.isTotalBase = outputResponse.isTotalBase;
                  this.failedCase = true;
                  this.errorHeader = 'Analysis Status:';
                  this.isInsightspopupOpen = true;
                  this.arktabaccess = false;
                  this.isDiagnostic = true;

                  if (!isChatResponse) {
                    this.pushChatResponseEntry('failedCase', true);
                    this.pushChatResponseEntry('errorHeader', this.errorHeader);
                  }
                },
                (error) => {
                  console.error('getOutputData error:', error);
                  this.arktabaccess = false;
                  this.inputValue = '';
                }
              );
            } else {
              this.arktabaccess = false;
              this.inputValue = '';
            }
          }
        },
        error: (error: any) => {
          console.error('[ORCHESTRATION ERROR] Orchestration API failed:', error);
          this.stopAiLoader();
          this.arktabaccess = false;

          let errorMessage = 'Unable to process your request. Please try again.';
          let shortErrorMessage = 'Unable to process your request. Please try again.';
          this.errorHeader = 'Analysis Error:';
          if (error.status === 401) {
            errorMessage = 'Session expired. Please refresh the page to continue asking questions in this chat.';
            shortErrorMessage = 'Session expired. Please refresh page.';
            this.errorHeader = 'Authentication Error:';
            console.error('[ORCHESTRATION ERROR] 401 - Authentication failed, likely expired session for old chat');
          } else if (error.status === 403) {
            errorMessage = 'Access denied. You do not have permission to perform this action.';
            shortErrorMessage = 'Access denied. Permission required.';
            this.errorHeader = 'Access Denied:';
          } else if (error.status === 404) {
            errorMessage = 'Service not found. Please contact administrator.';
            shortErrorMessage = 'Service connection failed.';
            this.errorHeader = 'Invalid Request:';
          } else if (error.status === 500) {
            errorMessage = 'Server error. Please contact administrator.';
            shortErrorMessage = 'Internal server error.';
            this.errorHeader = 'Server Error:';
          } else if (error.status === 0) {
            errorMessage = 'Network error. Please check your connection and try again.';
            shortErrorMessage = 'Network error. Please check your connection.';
            this.errorHeader = 'Network Error:';
          }

          if (this.chatPreviewBlocks.length > 0) {
            this.updateQuestionAnswerForSelectedMessage(shortErrorMessage);
          } else if (!isChatResponse) {
            this.chatPreviewBlocks.push({
              question: this.inputValue || 'Question',
              response: '',
              isLiked: null,
              isStarred: false,
              feedbackSaved: false,
              showDislikeInput: false,
              dislikeReason: '',
              QuestionAnswer: shortErrorMessage
            });
          }

          if (!isChatResponse) {
            this.pushChatResponseEntry('failedCase', true);
            this.pushChatResponseEntry('noContentFlag', true);
            this.pushChatResponseEntry('errorHeader', this.errorHeader);
          }

          this.insightsVal = errorMessage;
          this.failedCase = true;
          this.noContentFlag = true;
          this.isInsightspopupOpen = true;
          const errorObj: InsightsModel = {
            header: this.errorHeader || 'Error',
            message: errorMessage,
            show: true,
          };
          this._insightsSerive.showInisghts(errorObj);

          // Removed saveChatList to prevent recording orchestration error questions in history
          this.currentView = 'chat';
        }
      })
    }
  }

  AssignDataToDataObject(datamodel: any) {
    this.dataObject.Row = datamodel.Row;
    this.dataObject.Column = datamodel.Column;
    this.dataObject.ColNesting = datamodel.ColNesting;
    this.dataObject.RowNesting = datamodel.RowNesting;
    this.dataObject.Filter = datamodel.Filter;
    this.isTotalBaseFromPrompt = datamodel.isTotalBase;
  }

  LoadRibbonData(receivedData: any) {
    if (this.SampleSizeList.length == 0) {
      for (const item of receivedData.comparison_point) {
        if (item.value) {
          this.SampleSizeList.push(item);
        }
      }
    }
    this.is_indexing = receivedData.output_page[1].value;
    this.isRowNesting =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? receivedData.nesting[0].is_selected
        : false;
    this.isColumnNesting = receivedData.nesting[1].is_selected;
    this.is_TransposeBtn =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? receivedData.output_page[0].value
        : false;
    this.filteringAnsBlock =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? receivedData.filter_function[0].value
        : false;
    this.AnsBaseBlock =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? receivedData.filter_function[1].value
        : false;
    this.is_sigtesting =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? receivedData.output_page[2].value
        : false;
    (this.is_brand_analysis = receivedData.is_brand_analysis),
      (this.is_chart_visualization = receivedData.is_chart_visualization),
      (this.is_sticky_selection = receivedData.is_sticky_selection),
      (this.is_reset_selection = receivedData.is_reset_selection),
      (this.is_Transpose = receivedData.output_page[0].value),
      (this.is_sigtesting = receivedData.output_page[2].value),
      (this.is_ranking = receivedData.output_page[3].value),
      (this.is_confidenceLevel = receivedData.confidence_level);
    (this.isFilterToggle = receivedData.filter_function[0].value),
      (this.isAnswerToggle = receivedData.filter_function[1].value),
      (this.excelExport = receivedData.export_download[0].value),
      (this.repository = receivedData.export_download[2].value),
      (this.lowBaseIdentifier = receivedData.export_download[3].value),
      (this.is_AI_Integration = receivedData.is_AI_Integration),
      (this.is_StoryBoard = receivedData.is_StoryBoard),
      (this.is_Column_Row_Percentage = receivedData.is_Column_Row_Percentage),
      (this.insufficentBase = receivedData.low_base_identifier[0].data_value),
      (this.insufficientBase = receivedData.low_base_identifier[0].data_value),
      (this.lowBase = receivedData.low_base_identifier[1].data_value),
      (this.LowBase = receivedData.low_base_identifier[1].data_value),
      (this.threshold = receivedData.threshold_identifier[0].data_value),
      (this.iscustomgrp = receivedData.custom_content[0].value),
      (this.iscustomCalc = receivedData.custom_content[1].value),
      (this.iscustomreport = receivedData.custom_content[2].value),
      (this.changeEntryPoint = receivedData.save_selection[1].value),
      (this.aggregatedVariables = receivedData.aggregatedvariables),
      (this.isWeightedBase =
        receivedData.aggregatedvariables[1].data_value == '' ? false : true),
      (this.isSampleSize =
        receivedData.aggregatedvariables[2].data_value == '' ? false : true),
      (this.mandatoryVariableMapping = receivedData.mandatory_variable_mapping),
      (this.isSelectAllMetrics = receivedData.is_SelectAll_Metrics);
    this.isSelectAllMetricsLevel = receivedData.isSelectAllMetrics;
    this.SampleSizeContainer =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? true
        : receivedData.isWeightedBase || receivedData.isSampleSize
          ? true
          : false;
    this.isSampleSizeBlock =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? true
        : receivedData.isSampleSize;
    this.isWeightedSampleBlock =
      receivedData.dataformat[0].key == 'Respondent Level'
        ? true
        : receivedData.isWeightedBase;
    this.selectedDataFormat = receivedData.dataformat[0].key;
    const noneexists = this.SampleSizeList.some(
      (item: { key: string }) => item.key === 'None'
    );
    if (!noneexists) {
      let newPair = { key: 'None', value: true };
      this.SampleSizeList.unshift(newPair);
    }
  }

  manipulateIndexData() {
    let level = 0;
    if (this.dataObject.ColNesting.length > 0) {
      level = this.dataObject.ColNesting.length;
    }
    let selectedIndexData = this.CrossTabOutPutData.filter((x: any) => {
      if (level == 1) return x.Level1ColChild == this.selectedIndex;
      else if (level == 2) return x.Level2ColChild == this.selectedIndex;
      else return x.colChild == this.selectedIndex;
    });
    if (selectedIndexData.length > 0) {
      selectedIndexData = JSON.parse(JSON.stringify(selectedIndexData));
      selectedIndexData.forEach((item: any) => {
        let indexData = this.CrossTabOutPutData.filter((x: any) => {
          if (level == 1) {
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild &&
              x.colChild == item.colChild
            );
          } else if (level == 2) {
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild &&
              x.colChild == item.colChild &&
              x.Level1ColChild == item.Level1ColChild
            );
          } else
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild
            );
        });
        if (indexData.length > 0) {
          indexData.forEach((indexItem: any) => {
            if (this.selectedWeight == 'Unweighted') {
              indexItem.totalUnweightedShare = isNaN(
                indexItem.totalUnweightedShare / item.totalUnweightedShare
              )
                ? null
                : isFinite(
                  indexItem.totalUnweightedShare / item.totalUnweightedShare
                )
                  ? indexItem.totalUnweightedShare / item.totalUnweightedShare
                  : null;
              indexItem.answerUnweightedShare = isNaN(
                indexItem.answerUnweightedShare / item.answerUnweightedShare
              )
                ? null
                : isFinite(
                  indexItem.answerUnweightedShare / item.answerUnweightedShare
                )
                  ? indexItem.answerUnweightedShare / item.answerUnweightedShare
                  : null;
              indexItem.totalUnweightedShare_Index =
                indexItem.totalUnweightedShare;
              indexItem.answerUnweightedShare_Index =
                indexItem.answerUnweightedShare;
            } else {
              indexItem.totalWeightedShare = isNaN(
                indexItem.totalWeightedShare / item.totalWeightedShare
              )
                ? null
                : isFinite(
                  indexItem.totalWeightedShare / item.totalWeightedShare
                )
                  ? indexItem.totalWeightedShare / item.totalWeightedShare
                  : null;
              indexItem.answerWeightedShare = isNaN(
                indexItem.answerWeightedShare / item.answerWeightedShare
              )
                ? null
                : isFinite(
                  indexItem.answerWeightedShare / item.answerWeightedShare
                )
                  ? indexItem.answerWeightedShare / item.answerWeightedShare
                  : null;
              indexItem.totalWeightedShare_Index = indexItem.totalWeightedShare;
              indexItem.answerWeightedShare_Index =
                indexItem.answerWeightedShare;
            }
          });
        }
      });
    }
  }

  onVerticalStackBarChartIconClick(chartType: string, distinctColChildValues?: string[]) {
    if (this.disableStackChart) return;
    if (!distinctColChildValues) {
      distinctColChildValues = this.getDistinctColumnChildValues();
    }
    this.initializeChartData(this.StackChart);
    // Sync call with safe empty data to prevent BehaviorSubject crash in child component ngOnInit
    this.crossTabService.StackChartData(this.StackChart, [], 'None', this.DefaultConfidenceLevel, 'percentage', 'column');

    this.resetChartStates('stack');
    this.displayTable = false;
    let index = 1;

    this.CrossTabOutPutData.forEach((item: CrossTabOutputItem) => {
      const shareNumber = this.getShareNumber(item);
      const calculatedPercentage = this.calculatePercentageValue(shareNumber, item);
      const changePy = this.getChangeVsPY(item);

      this.StackChart.Data.push({
        'Series Name': item.rowChild.replaceAll('|', ' : '),
        'Category Name': item.colChild.replaceAll('|', ' : '),
        'Rounded Value': shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        Value: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        Label: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        'Change value vs PY': changePy.toString(),
        Significance: this.getSignificanceString(item),
        Significance1: this.getSignificanceString(item), // Required by StackBarProperties
        'Sample size': this.getSampleSizeString(item)
      });
      index++;
    });

    if (this.CrossTabOutPutData.length > 0) {
      this.StackChart.title = this.CrossTabOutPutData[0].colChild;
    }

    const numberType = this.CrossTabOutPutData?.[0]?.CalculationType || 'percentage';
    const distinctRowChildValues = this.getDistinctChildValuesFormatted(this.OutputdataObject.Row as any);

    this.StackChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: true,
      chartStyle: '',
      showLegend: true,
      gridlines: false,
      shadow: false,
      stacking: 100, // For stacked bar chart
      darkTheme: false,
      legendPosition: 'bottom',
      axisLabelOrientation: 'horizontal',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelStyle: this.DefaultSampleSize == 'None' ? 'datalabel' : 'change',
      axisImage: false,
      dataLabelPosition: 'center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'Center',
      datalabelFormat: (numberType == 'mean' || this.CrossTabOutPutData?.[0]?.rowChild?.toLowerCase().includes('mean')) ? '' : 'percentage',
      datalabelOrientation: 0,
      lineWidth: 0,
      gridLineDashStyle: '',
      markerLineWidth: 0,
      markerStyle: 'circle',
      title: '',
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    chartType = this.isTranspose ? 'bar' : 'column';
    this.sortChartDataBySeriesName(this.StackChart.Data, distinctRowChildValues);
    const selectedSignifcance = this.DefaultSampleSize === 'Pairwise' ? 'None' : this.DefaultSampleSize;
    setTimeout(() => {
      this.crossTabService.StackChartData(this.StackChart, distinctColChildValues, selectedSignifcance, this.DefaultConfidenceLevel, numberType, chartType);
    }, 100);
  }

  onTrendChartIconClick() {
    this.disableLineChart = false;
    this.initializeChartData(this.LineChart);
    // Sync call with safe empty data to prevent BehaviorSubject crash in child component ngOnInit
    this.crossTabService.LineChartData(this.LineChart, [], 'None', this.DefaultConfidenceLevel, 'percentage', 'column');

    this.resetChartStates('line');
    this.displayTable = false;
    const rowdata = this.OutputdataObject['Row'];
    const columndata = this.OutputdataObject['Column'];
    const isMultiPunchRow = this.filterDataByCalculationType(rowdata as any, 'multipunch');
    const isDefaultRespGrp = this.filterDataByCalculationType(rowdata as any, 'respgrp');
    const isMeanMetric = this.filterDataByCalculationType(rowdata as any, 'mean');

    const isShareMetric = (rowdata as any[]).filter((parent) => {
      return parent.Data.some((child: any) => child.CalculationType?.toLowerCase() === 'share');
    });

    const TimePeriodinColumn = ((columndata as any[]) || []).filter((parent) => {
      return parent.Data.some((child: any) => child.isTimePeriod === true || child.isTimePeriod === 'true');
    });

    if (rowdata.length == 1) {
      let filteredData: any = [];
      const disctinctRowValues = this.getDistinctChildValues(this.OutputdataObject.Row as any);
      const pipeParts = this.getDistinctPipeParts(disctinctRowValues);
      this.StackFlag = this.calculateStackFlag(pipeParts);

      if (this.StackFlag) {
        rowdata[0].Data.forEach((item: any) => {
          filteredData = this.filterByPipeLevels(item.Child);
        });
      }

      this.disableStackChart = (isMultiPunchRow.length > 0 || isDefaultRespGrp.length > 0 || isMeanMetric.length > 0 || (rowdata?.[0]?.Data?.length === (filteredData || []).length))
        ? false : true;

      const rowDataLengthForTrend = this.getDistinctChildValues(this.OutputdataObject.Row as any);
      const isLineChartAvailable = TimePeriodinColumn.length === 1 &&
        ((isShareMetric.length > 0 || isMeanMetric.length > 0) && rowDataLengthForTrend.length <= this.maxRowsPerSlide);
      this.disableLineChart = !isLineChartAvailable;
    }

    let numberType: string = 'percentage';
    const distinctColChildValues = this.getDistinctColumnChildValues();
    const distinctRowChildValues = this.getDistinctChildValuesFormatted(this.OutputdataObject.Row as any);

    this.CrossTabOutPutData.forEach((item: CrossTabOutputItem) => {
      let ShareNumber = this.isTotalBase
        ? this.selectedWeight == 'Unweighted'
          ? item.totalUnweightedShare
          : item.totalWeightedShare
        : this.selectedWeight == 'Unweighted'
          ? item.answerUnweightedShare
          : item.answerWeightedShare;
      let calculatedPercentage: number | string =
        item.isDerived && item.CalculationType == 'mean'
          ? ShareNumber == null
            ? 'NA'
            : Number(ShareNumber.toFixed(1))
          : ShareNumber == null
            ? 'NA'
            : Number((ShareNumber * 100).toFixed(1));
      let changevsPY = this.isTotalBase
        ? item.changeVsPY_Total
        : item.changeVsPY_Answer;

      let changePy: number | string =
        changevsPY == null
          ? 'NA'
          : item.isDerived && item.CalculationType == 'mean'
            ? Number(changevsPY.toFixed(1))
            : Number((changevsPY * 100).toFixed(1));

      this.LineChart.Data.push({
        'Series Name': item.rowChild.replaceAll('|', ' : '),
        'Category Name': item.colChild.replaceAll('|', ' : '),
        'Rounded Value': ShareNumber == null ? 'NA' : calculatedPercentage,
        XValue: '0',
        Value: calculatedPercentage,
        Label: calculatedPercentage.toString(),
        'Change value vs PY': changePy,
        Significance: this.isTotalBase
          ? (item.Significance_Total == null ? 0 : item.Significance_Total)
          : (item.Significance_Answer == null ? 0 : item.Significance_Answer),
        'Sample Size': this.isTotalBase
          ? (item.totalUnweightedBase == null ? 0 : item.totalUnweightedBase)
          : (item.answerUnweightedBase == null ? 0 : item.answerUnweightedBase),
      });
    });

    if (this.CrossTabOutPutData.length > 0) {
      this.LineChart.title = this.CrossTabOutPutData[0].colChild;
      numberType = this.CrossTabOutPutData[0].CalculationType;
    }

    this.LineChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: false,
      chartStyle: 'area',
      showLegend: true,
      gridlines: false,
      legendPosition: 'bottom',
      stacking: 0,
      darkTheme: false,
      axisLabelOrientation: 'center',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelFormat: (numberType == 'mean' || this.CrossTabOutPutData?.[0]?.rowChild?.toLowerCase().includes('mean')) ? '' : 'percentage',
      dataLabelPosition: 'center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'center',
      datalabelStyle: this.DefaultSampleSize == 'None' ? '' : 'sigchan',
      datalabelOrientation: 0,
      axisImage: false,
      lineWidth: 2,
      gridLineDashStyle: 'Solid',
      markerLineWidth: 1,
      markerStyle: 'circle',
      title: 'LineChart',
      shadow: false,
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    this.sortChartDataBySeriesName(this.LineChart.Data, distinctRowChildValues);
    let selectedSignifcance = this.DefaultSampleSize == 'Pairwise' ? 'None' : this.DefaultSampleSize;
    setTimeout(() => {
      this.crossTabService.LineChartData(this.LineChart, distinctColChildValues, selectedSignifcance, this.DefaultConfidenceLevel, numberType, '');
    }, 100);
  }

  getDistinctChildValues(data: checkboxSelectionWithParent[]): string[] {
    return ChartUtilitiesHelper.getDistinctChildValues(data || []);
  }

  onVerticalBarChartIconClick(chartType: string, distinctColChildValues?: string[]) {
    if (!distinctColChildValues) {
      distinctColChildValues = this.getDistinctColumnChildValues();
    }
    this.initializeChartData(this.BarChart);
    // Sync call with safe empty data to prevent BehaviorSubject crash in child component ngOnInit
    this.crossTabService.ChartData(this.BarChart, [], 'None', this.DefaultConfidenceLevel, 'percentage', 'column');

    this.resetChartStates('bar');
    let index = 1;

    this.CrossTabOutPutData.forEach((item: CrossTabOutputItem) => {
      const shareNumber = this.getShareNumber(item);
      const calculatedPercentage = this.calculatePercentageValue(shareNumber, item);
      const changePy = this.getChangeVsPY(item);

      this.BarChart.Data.push({
        'Series Name': item.rowChild.replaceAll('|', ' : '),
        'Category Name': item.colChild.replaceAll('|', ' : '),
        'Rounded Value': shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        Value: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        XValue: index.toString(),
        Label: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        'Change value vs PY': changePy.toString(),
        Significance: this.getSignificanceString(item),
        Significance2: this.getSignificanceString(item),
        'Sample size': this.getSampleSizeString(item)
      });
      index++;
    });

    if (this.CrossTabOutPutData.length > 0) {
      this.BarChart.title = this.CrossTabOutPutData[0].colChild;
    }

    const numberType = this.CrossTabOutPutData?.[0]?.CalculationType || 'percentage';
    const distinctRowChildValues = this.getDistinctChildValuesFormatted(this.OutputdataObject.Row as any);

    this.BarChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: true,
      chartStyle: '',
      showLegend: true,
      gridlines: false,
      shadow: false,
      stacking: 0,
      darkTheme: false,
      legendPosition: 'bottom',
      axisLabelOrientation: 'horizontal',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelStyle: this.DefaultSampleSize == 'None' ? 'datalabel' : 'change',
      axisImage: false,
      dataLabelPosition: 'center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'Center',
      datalabelFormat: (numberType == 'mean' || this.CrossTabOutPutData?.[0]?.rowChild?.toLowerCase().includes('mean')) ? '' : 'percentage',
      datalabelOrientation: 0,
      lineWidth: 0,
      gridLineDashStyle: '',
      markerLineWidth: 0,
      markerStyle: 'circle',
      title: '',
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    chartType = this.isTranspose ? 'bar' : 'column';
    this.sortChartDataBySeriesName(this.BarChart.Data, distinctRowChildValues);
    const selectedSignifcance = this.DefaultSampleSize === 'Pairwise' ? 'None' : this.DefaultSampleSize;
    setTimeout(() => {
      this.crossTabService.ChartData(this.BarChart, distinctColChildValues, selectedSignifcance, this.DefaultConfidenceLevel, numberType, chartType);
    }, 100);
  }

  onGroupVerticalChartClick(chartType: string, distinctColChildValues?: string[]) {
    if (!distinctColChildValues) {
      distinctColChildValues = this.getDistinctColumnChildValues();
    }
    this.initializeChartData(this.BarChart);
    // Sync call with safe empty data to prevent BehaviorSubject crash in child component ngOnInit
    this.crossTabService.GrpChartData(this.BarChart, [], 'None', this.DefaultConfidenceLevel, 'percentage', 'column');

    this.resetChartStates('groupBar');
    this.isVerticalBarChartClick = false;

    this.CrossTabOutPutData.forEach((item: CrossTabOutputItem) => {
      const shareNumber = this.getShareNumber(item);
      const calculatedPercentage = this.calculatePercentageValue(shareNumber, item);
      const changePy = this.getChangeVsPY(item);

      this.BarChart.Data.push({
        'Series Name': item.rowChild.replaceAll('|', ' : '),
        'Category Name': item.colChild.replaceAll('|', ' : '),
        'Rounded Value': shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        Value: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        XValue: '1',
        Label: shareNumber === null ? 'NA' : calculatedPercentage.toString(),
        'Change value vs PY': changePy.toString(),
        Significance: this.getSignificanceString(item),
        Significance2: this.getSignificanceString(item),
        'Sample size': this.getSampleSizeString(item)
      });
    });

    if (this.CrossTabOutPutData.length > 0) {
      this.BarChart.title = this.CrossTabOutPutData[0].colChild;
    }

    const numberType = this.CrossTabOutPutData?.[0]?.CalculationType || 'percentage';
    const distinctRowChildValues = this.getDistinctChildValuesFormatted(this.OutputdataObject.Row as any);

    this.BarChart.Properties.push({
      plotBands: false,
      lowSample: false,
      showNegative: false,
      allowOverlap: true,
      chartStyle: '',
      showLegend: true,
      gridlines: false,
      shadow: false,
      stacking: 0,
      darkTheme: false,
      legendPosition: 'bottom',
      axisLabelOrientation: 'horizontal',
      chartTitlePosition: 'center',
      showDataLabel: true,
      datalabelStyle: this.DefaultSampleSize == 'None' ? 'datalabel' : 'change',
      axisImage: false,
      dataLabelPosition: 'center',
      dataLabelColor: 'black',
      marker: 'disable',
      showRemaining: false,
      gradientBarColor: false,
      showPattern: false,
      dataLabelPositionPPT: 'Center',
      datalabelFormat: (numberType == 'mean' || this.CrossTabOutPutData?.[0]?.rowChild?.toLowerCase().includes('mean')) ? '' : 'percentage',
      datalabelOrientation: 0,
      lineWidth: 0,
      gridLineDashStyle: '',
      markerLineWidth: 0,
      markerStyle: 'circle',
      title: '',
      toolTipStyle: 'default',
      ChartCat: distinctColChildValues,
    });

    chartType = this.isTranspose ? 'bar' : 'column';
    this.sortChartDataBySeriesName(this.BarChart.Data, distinctRowChildValues);
    const selectedSignifcance = this.DefaultSampleSize === 'Pairwise' ? 'None' : this.DefaultSampleSize;
    setTimeout(() => {
      this.crossTabService.GrpChartData(this.BarChart, distinctColChildValues, selectedSignifcance, this.DefaultConfidenceLevel, numberType, chartType);
    }, 100);
  }

  VerticalChartClick(chartType: string) {
    this.variableTabData = this.crossTabService.getVarTabData || [];
    const rowdata = this.OutputdataObject['Row'];
    const rowDataLengthValue: number = rowdata.length > 1 ? rowdata.length : rowdata[0]?.Data?.length || 0;


    this.resetChartStates();
    this.displayTable = false;
    this.isLineChartClick = false;
    this.isVerticalStackChartClick = false;
    this.isVerticalBarChartClick = true;
    const columndata = this.OutputdataObject['Column'];


    const isMultiPunchRow = this.filterDataByCalculationType(rowdata as any, 'multipunch');
    const isMultiPunchColumn = this.filterDataByCalculationType(columndata as any, 'multipunch');
    const isDefaultRespGrp = this.filterDataByCalculationType(rowdata as any, 'respgrp');
    const isMeanMetric = this.filterDataByCalculationType(rowdata as any, 'mean');

    const isShareMetric = (rowdata as any[]).filter((parent) => {
      return parent.Data.some((child: any) => child.CalculationType?.toLowerCase() === 'share');
    });

    let filteredData: any = [];
    const disctinctRowValues = this.getDistinctChildValues(this.OutputdataObject.Row as any);
    const pipeParts = this.getDistinctPipeParts(disctinctRowValues);
    this.StackFlag = this.calculateStackFlag(pipeParts);

    if (this.StackFlag && rowdata.length > 0) {
      rowdata[0].Data.forEach((item: any) => {
        filteredData = this.filterByPipeLevels(item.Child);
      });
    }

    const rowNestData = this.dataObject['RowNesting'] || [];
    const colNestData = this.dataObject['ColNesting'] || [];
    const rowDataLength = rowdata?.[0]?.Data?.length || 0;

    const isStackEnabled = (
      rowdata.length === 1 &&
      isMultiPunchRow.length === 0 &&
      rowNestData.length === 0 &&
      colNestData.length === 0 &&
      rowDataLength <= 15 &&
      (rowdata?.[0]?.Data?.length === (filteredData || []).length)
    );

    this.disableStackChart = !isStackEnabled;


    const distinctColChildValues = this.getDistinctColumnChildValues();
    const TimePeriodinColumn = ((columndata as any[]) || []).filter((parent) => (parent.Data || []).some((child: any) => child.isTimePeriod === true || child.isTimePeriod === 'true'));

    const rowDataLengthForTrend = this.getDistinctChildValues(this.OutputdataObject.Row as any);
    const isTrendAvailable = TimePeriodinColumn.length === 1 &&
      ((isShareMetric.length > 0 || isMeanMetric.length > 0) && rowDataLengthForTrend.length <= this.maxRowsPerSlide);
    this.disableLineChart = !isTrendAvailable;

    if (rowDataLengthValue == 1) {
      this.onVerticalBarChartIconClick(chartType, distinctColChildValues);
    } else {
      this.onGroupVerticalChartClick(chartType, distinctColChildValues);
    }
  }

  getDistinctValuesByPipeCount(data: string[], pipeCount: number): string[] {
    return ChartUtilitiesHelper.getDistinctValuesByPipeCount(data, pipeCount);
  }

  handleOutputdataObjectOnTransposeSelect() {
    if (
      this.OutputdataObject != null &&
      (this.OutputdataObject['Row'].length > 0 ||
        this.OutputdataObject['Column'].length > 0)
    ) {
      let tempRow = [...this.OutputdataObject.Row];
      let tempColumn = [...this.OutputdataObject.Column];
      this.OutputdataObject.Row = [...tempColumn];
      this.OutputdataObject.Column = [...tempRow];
    }
  }

  openInsights(isChatResponse = false, getInsights?: any) {
    this.isExportspopup = false;

    if (getInsights && isChatResponse) {
      this.insightsVal = this.formatInsightsIntoPoints(getInsights);
    }

    if (this.noContentFlag) {
      this.isInsightspopupOpen = true;
      const noContentObj: InsightsModel = {
        header: this.errorHeader || 'Analysis Status:',
        message: this.insightsVal || 'No content, we will fix as soon as possible',
        show: true,
      };
      this._insightsSerive.showInisghts(noContentObj);
      return;
    }

    if (this.isInsightspopupOpen) {
      this.isInsightspopupOpen = false;
      return;
    }

    const insightsObj: InsightsModel = {
      header: this.failedCase ? (this.errorHeader || 'Error:') : 'Insights',
      message: '',
      show: false,
    };
    this._insightsSerive.showInisghts(insightsObj);

    const ShareColumn = (this.selectedDataFormat !== 'Respondent Level')
      ? 'value'
      : (this.isTotalBase
        ? (this.selectedWeight === 'Unweighted' ? 'totalUnweightedShare' : 'totalWeightedShare')
        : (this.selectedWeight === 'Unweighted' ? 'answerUnweightedShare' : 'answerWeightedShare'));

    const BaseColumn = this.isTotalBase
      ? 'totalUnweightedBase'
      : 'answerUnweightedBase';

    this.isInsightspopupOpen = true;
    if (!isChatResponse) {
      this.insightsVal = [];
      this.failedCase = false;
    }

    const initialObj: InsightsModel = {
      header: 'Insights (Processing...)',
      message: 'Analyzing data and preparing AI context...',
      show: true,
    };

    this._insightsSerive.showInisghts(initialObj);
    let currentStreamingText = '';
    let isFirstChunk = true;

    const processingTimeout = setTimeout(() => {
      if (isFirstChunk) {
        const stillProcessingObj: InsightsModel = {
          header: 'Insights (Still Processing...)',
          message: 'Complex analysis in progress, please wait...',
          show: true,
        };
        this._insightsSerive.showInisghts(stillProcessingObj);
      }
    }, 3000);

    const updateStreamingUI = () => {
      if (currentStreamingText.trim().length === 0) {
        return;
      }

      const streamingObj: InsightsModel = {
        header: 'Insights (Streaming...)',
        message: currentStreamingText,
        show: true,
      };
      this._insightsSerive.showInisghts(streamingObj);
      this.insightsVal = [currentStreamingText];
    };

    setTimeout(() => {
      if (!this.selectionSummary || this.selectionSummary.trim() === '') {
        const rowData = this.dataObject?.Row?.[0]?.Data?.map((d: any) => d.Child).join(', ') || 'N/A';
        const colData = this.dataObject?.Column?.[0]?.Data?.map((d: any) => d.Child).join(', ') || 'N/A';
        const pData = this.promptData || {};
        const mktData = pData.Markets || pData.markets || pData.Market || pData.market || [];
        const tpData = pData.Time_Period || pData.time_period || pData.TimePeriod || pData.timeperiod || [];

        const extractLabels = (item: any) => {
          if (typeof item === 'string') {
            const parts = item.split('|');
            if (parts.length >= 2) {
              return parts[parts.length - 2] + ': ' + parts[parts.length - 1];
            }
            return parts.pop();
          }
          if (item && item.name) return item.name;
          if (item && item.Child) return item.Child;
          return String(item);
        };

        const marketNames = mktData.length > 0 ? mktData.map((m: any) => extractLabels(m)).join(', ') : 'All Markets';
        const timePeriodNames = tpData.length > 0 ? tpData.map((t: any) => extractLabels(t)).join(', ') : 'All Time Periods';

        this.selectionSummary = `Study: ${this.selected_study || 'Unknown'} || Market: ${marketNames} || Time Period: ${timePeriodNames} || Row: ${rowData} || Column: ${colData}`;
      }

      let insightsDataToSend = this.CrossTabOutPutData;
      if (this.mcode === 2) {
        insightsDataToSend = this.CrossTabOutPutData.map((item: any) => {
          if (item.colChild === null || item.colChild === undefined || !item.colVariableCode) {
            const columnData = this.dataObject?.Column?.[0]?.Data?.[0];
            const columnLabel = columnData?.Child || 'Total';
            const columnVarCode = columnData?.variablecode || item.rowVariableCode || 'Total_Variable';
            return {
              ...item,
              colChild: item.colChild || columnLabel,
              colVariableCode: item.colVariableCode || columnVarCode
            };
          }
          return item;
        });
      }

      const insightsObservable = getInsights && isChatResponse
        ? of(getInsights)
        : this.crossTabService.getInsightsData(
          insightsDataToSend,
          this.selected_study,
          this.selected_client,
          this.selectionSummary,
          this.DefaultConfidenceLevel,
          ShareColumn,
          BaseColumn
        );

      insightsObservable.subscribe({
        next: (chunk: string) => {
          if (isFirstChunk) {
            clearTimeout(processingTimeout);
            isFirstChunk = false;
          }

          const chunkStr = typeof chunk === 'string' ? chunk : String(chunk);
          const isErrorMessage = /\b(error occurred|failed|exception|invalid)\b/i.test(chunkStr);

          if (isErrorMessage) {
            throw new Error(chunkStr);
          }

          if (isChatResponse && getInsights) {
            if (typeof chunk === 'string') {
              currentStreamingText = chunk;
            } else if (typeof chunk === 'object') {
              currentStreamingText = JSON.stringify(chunk);
            } else {
              currentStreamingText = String(chunk);
            }
          } else {
            currentStreamingText += chunk;
          }
          updateStreamingUI();
        },

        complete: () => {
          clearTimeout(processingTimeout);

          if (!currentStreamingText || currentStreamingText.trim().length === 0) {
            this.insightsVal = this.fallbackMessage();
            this.failedCase = true;

            if (this.chatPreviewBlocks.length > 0) {
              this.updateQuestionAnswerForSelectedMessage('No data Available');
            }

            if (!isChatResponse) {
              this.pushChatResponseEntry('getInsights', 'No data Available');
              // Removed saveChatList to prevent recording empty insights in history
              this.chatResponse = [];
            }
            const emptyObj: InsightsModel = {
              header: this.failedCase ? (this.errorHeader || 'Error:') : 'Insights',
              message: 'No data Available',
              show: true,
            };
            this._insightsSerive.showInisghts(emptyObj);
            this.arktabaccess = false;
            return;
          }

          let processedResult = currentStreamingText;
          try {
            const parsed = JSON.parse(currentStreamingText);

            if (Array.isArray(parsed)) {
              this.insightsVal = parsed;

              const insightsPlainText = this.getFirstTwoInsightsAsPlainText();
              const hasQnAResponse = this.chatResponse.some(entry => entry.hasOwnProperty('getQnA'));
              if (!hasQnAResponse && !isChatResponse) {
                this.updateQuestionAnswerForSelectedMessage(insightsPlainText || 'No data Available');
              }

              if (!isChatResponse) {
                this.pushChatResponseEntry('getInsights', currentStreamingText);
                this.saveChatList(
                  this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue,
                  this.chatResponse,
                  insightsPlainText || 'No data Available'
                );
                this.chatResponse = [];
              }

              this.arktabaccess = false;
              return;
            } else if (typeof parsed === 'object') {
              let combinedText = '';
              for (const key in parsed) {
                if (parsed[key] && typeof parsed[key] === 'object' && parsed[key].Value) {
                  combinedText += parsed[key].Value + '\n';
                } else if (typeof parsed[key] === 'string') {
                  combinedText += parsed[key] + '\n';
                }
              }
              processedResult = combinedText;
            } else {
              processedResult = String(parsed);
            }
          } catch (e) {
          }

          const finalInsights = processedResult
            .split('- ')
            .map(item => item.trim())
            .filter(item => item.length > 0 && !item.startsWith('```'))
            .map(item => item.replace(/```$/, '').trim());

          if (finalInsights.length === 0 && processedResult.trim().length > 0) {
            const altInsights = processedResult
              .split('\n')
              .map(item => item.trim())
              .filter(item => item.length > 0);

            if (altInsights.length > 0) {
              this.insightsVal = altInsights;
            } else {
              this.insightsVal = [processedResult.trim()];
            }
          } else {
            this.insightsVal = finalInsights;
          }
          const insightsPlainText = this.getFirstTwoInsightsAsPlainText();
          const hasQnAResponse = this.chatResponse.some(entry => entry.hasOwnProperty('getQnA'));
          if (!hasQnAResponse && !isChatResponse) {
            this.updateQuestionAnswerForSelectedMessage(insightsPlainText || 'No data Available');
          }

          if (!isChatResponse) {
            this.pushChatResponseEntry('getInsights', currentStreamingText);
            this.saveChatList(
              this.chatPreviewBlocks.length > 0 ? this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1].question : this.inputValue,
              this.chatResponse,
              insightsPlainText || 'No data Available'
            );
            this.chatResponse = [];
          }

          const finalInsightsObj: InsightsModel = {
            header: 'Insights',
            message: currentStreamingText,
            show: true,
          };
          this._insightsSerive.showInisghts(finalInsightsObj);
          this.arktabaccess = false;
        },

        error: (err) => {
          clearTimeout(processingTimeout);
          console.error('An error occurred while processing insights:', err);
          console.error('Error details:', {
            message: err.message,
            stack: err.stack,
            CrossTabOutPutData: this.CrossTabOutPutData?.length,
            selectionSummary: this.selectionSummary,
            selected_study: this.selected_study,
            selected_client: this.selected_client
          });

          const errorMessage = err.message || 'Unable to generate insights. Please check your data selection.';
          this.insightsVal = [errorMessage];
          this.failedCase = true;
          this.isInsightspopupOpen = true;

          const errorObj: InsightsModel = {
            header: 'Insights (Error)',
            message: errorMessage,
            show: true,
          };
          this._insightsSerive.showInisghts(errorObj);
          this.arktabaccess = false;
        },
      });
    }, 500);
  }

  SelectionsummaryCollapseExpand(text: any) {
    this.isselectionsummarycollapse = true;
    setTimeout(() => {
      this.isselectionsummarycollapse2 = true;
    }, 300);
    if (text == 'SelectionSummary') {
      this.isselectionHeader = "Selection Summary";
      this.issavedselectionblock = false;
    }
    else {
      this.isselectionHeader = "Save Selections";
      this.issavedselectionblock = true;
      this.SaveSelectiontext = '';
    }

    if (this.showSnapshot) {
      this.GenerateSelectionSummary()
    }
    else {
      const disctinctRowValues = this.getDistinctChildValues(this.dataObject.Row);
      const disctinctRowNestingValues = this.getDistinctChildValues(this.dataObject.RowNesting);
      const disctinctColumnValues = this.getDistinctChildValues(this.dataObject.Column);
      const disctinctColumnNestingValues = this.getDistinctChildValues(this.dataObject.ColNesting);
      const FilterValues = this.getDistinctChildValues(this.dataObject.Filter);
      const RowValues = this.transformData(disctinctRowValues);
      const RowNestingValues = this.transformData(disctinctRowNestingValues);
      const ColumnValues = this.transformData(disctinctColumnValues);
      const ColumnNestingValues = this.transformData(disctinctColumnNestingValues);
      const FilterData = this.transformData(FilterValues);
      let isSavedSelection = false
      this.Columnselections = [];
      this.Rowselections = [];
      this.AllSelections = [];

      this.Columnselections = ColumnValues.map(item => {
        const [key, ...valueParts] = item.split(':');
        return {
          key: key.trim(),
          value: valueParts.join(':').trim()
        };
      });

      this.Rowselections = RowValues.map(item => {
        const [key, ...valueParts] = item.split(':');
        return {
          key: key.trim(),
          value: valueParts.join(':').trim()
        };
      });

      if (FilterData.length > 0) {
        this.AllSelections = FilterData.map(item => {
          const [key, ...valueParts] = item.split(':');
          return {
            key: key.trim(),
            value: valueParts.join(':').trim()
          };
        });
      }

      if (RowNestingValues.length > 0) {
        let rowNestingSection = RowNestingValues.join(
          '&nbsp;,&nbsp;'
        );
        this.AllSelections.push({
          key: 'Row Nesting',
          value: rowNestingSection
        });
      }
      if (ColumnNestingValues.length > 0) {
        let colNestSection = ColumnNestingValues.join(
          '&nbsp;,&nbsp;'
        );
        this.AllSelections.push({
          key: 'Column Nesting',
          value: colNestSection
        });
      }

      if (!isSavedSelection && this.selectedDataFormat == 'Respondent Level') {
        let significanceSection;
        if (this.SignificanceVsReference != '') {
          significanceSection = `${this.DefaultSampleSize
            } : ${this.replacePipe(
              this.SignificanceVsReference
            )}`;
        } else {
          significanceSection = this.DefaultSampleSize;
        }
        this.AllSelections.push({
          key: 'Significance',
          value: significanceSection
        });

        this.AllSelections.push({
          key: 'Confidence Level',
          value: this.DefaultConfidenceLevel
        });
      }

      if (
        this.selectedIndex != '' &&
        this.isIndex &&
        this.selectedDataFormat == 'Respondent Level'
      ) {
        let Reference = `${this.replacePipe(
          this.selectedIndex
        )}`;

        this.AllSelections.push({
          key: 'Reference',
          value: Reference
        });
      }
      if (
        this.DefaultWeight != '' &&
        this.selectedDataFormat == 'Respondent Level'
      ) {
        this.AllSelections.push({
          key: 'Calculation Weight',
          value: this.DefaultWeight
        });
      }
      if (this.selectedDataFormat == 'Respondent Level') {
        let Base = `${this.isTotalBase ? BASE_TYPES.TOTAL : BASE_TYPES.ANSWER
          }`;
        this.AllSelections.push({
          key: 'Calculation Base',
          value: Base
        });
      }
    }

  }

  OnCloseClick() {
    setTimeout(() => {
      this.isselectionsummarycollapse = false;
    }, 500);
    this.isselectionsummarycollapse2 = false;
    this.issavedselectionblock = false;
  }

  Exportspopup() {
    this.isExportspopup = !this.isExportspopup;
  }

  GenerateSelectionSummary() {
    const result = SelectionSummaryHelper.parseSelectionSummary(
      this._configService.selectionSummaryTextTitle
    );
    this.titleSection = result.titleSection;
    this.entryPoints = result.entryPoints;
    this.selections = result.selections;
    this.selectionSummary = this._configService.selectionSummaryTextTitle;
  }

  getChatListData() {
    this.apiService.getChatList().subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          const allChats = JSON.parse(apiResponse.Data) as ChatListDocument[];
          this.allChatList = allChats;
          this.onChatSearch();

        } else {
          this.recentChats = [];
          this.olderChats = [];
          this.allChatList = [];
          this.chatAccordions = [];
        }
      },
      error: () => {
        this.recentChats = [];
        this.olderChats = [];
      }
    });
  }

  loadLatestChatIfExists() {
    if (this.isNewChatSession) {
      this.isNewChatSession = false;
      this.currentView = 'landing';
      this.arktabaccess = false;
      return;
    }

    setTimeout(() => {
      if (this.allChatList && this.allChatList.length > 0) {
        const sortedChats = ChatHistoryHelper.sortChatsByDate(this.allChatList);
        const latestChat = sortedChats[0];

        if (latestChat && latestChat.ChatId) {
          this.newChatId = latestChat.ChatId;
          this.guidChatId = latestChat.ChatId;
          this.selectedChatId = latestChat.ChatId;

          if (latestChat.ChatHistory && latestChat.ChatHistory.length > 0) {
            this.currentView = 'chat';
            const sortedHistory = ChatHistoryHelper.sortChatHistoryByIndex(latestChat.ChatHistory);
            this.chatPreviewBlocks = sortedHistory.map(msg =>
              ChatHistoryHelper.createChatPreviewBlock(msg, this.defaultQuestionAnswer)
            );
            this.scrollToBottom();
            const lastMessage = sortedHistory[sortedHistory.length - 1];
            if (lastMessage && lastMessage.MessageId) {
              this.getChatResponse(lastMessage.MessageId, true);
            }
            this.arktabaccess = false;
          } else {
            this.currentView = 'landing';
            this.arktabaccess = false;
          }
        } else {
          this.currentView = 'landing';
          this.arktabaccess = false;
        }
      } else {
        this.currentView = 'landing';
        this.arktabaccess = false;
      }
    }, 1000);
  }

  onChatSearch(): void {
    const searchText = this.chatSearchText.toLowerCase().trim();
    const nestedSearchText = this.isNestedSearchVisible ? this.chatNestedSearchText.toLowerCase().trim() : '';

    if (this.allChatList.length === 0 && (this.recentChats.length > 0 || this.olderChats.length > 0)) {
      this.allChatList = [...this.recentChats, ...this.olderChats];
    }

    // Always calculate primary count for conditional toggle visibility
    const primaryOnly = ChatHistoryHelper.filterChatsBySearch(this.allChatList, searchText, '');
    this.primaryFilteredCount = primaryOnly.length;

    const filteredChats = ChatHistoryHelper.filterChatsBySearch(this.allChatList, searchText, nestedSearchText);
    this.chatAccordions = ChatHistoryHelper.mapChatsToAccordions(filteredChats);
  }

  toggleNestedSearch(): void {
    this.isNestedSearchVisible = !this.isNestedSearchVisible;
    if (!this.isNestedSearchVisible) {
      this.chatNestedSearchText = '';
    }
    this.onChatSearch();
  }


  saveChatList(title: string, chatResponse?: { [key: string]: string }[], questionAnswerMarkdown?: string) {
    this.newChatId = null;
    const chatExists = this.allChatList.some(chat => chat.ChatId === this.guidChatId);

    if (chatExists) {
      this.newChatId = this.guidChatId;
      this.selectedChatId = this.newChatId;
      this.saveChatHistory(this.newChatId, chatResponse, title, undefined, questionAnswerMarkdown);
      return;
    }

    this.apiService.saveChatList(title, this.guidChatId).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          this.newChatId = apiResponse.Data;
          this.selectedChatId = this.newChatId;
          this.getChatListData();
          this.saveChatHistory(this.newChatId, chatResponse, title, undefined, questionAnswerMarkdown);
        }
      },
      error: () => {
      }
    });
  }

  saveChatHistory(
    chatId: string,
    questionAnswer?: { [key: string]: string }[],
    question?: string,
    messageIndex?: number,
    questionAnswerMarkdown?: string,
    isLiked?: boolean | null,
    dislikeReason?: string
  ) {

    const questionText = question || '';
    const questionAnswerText = questionAnswerMarkdown || this.defaultQuestionAnswer;
    const answerString = questionAnswer && questionAnswer.length > 0
      ? JSON.stringify(questionAnswer)
      : JSON.stringify([]);

    const chatHistory: ChatHistoryDocument = {
      UserId: this.userId || '',
      ChatId: chatId || '',
      Question: questionText,
      MessageIndex: messageIndex || 0,
      QuestionAnswer: questionAnswerText,
      IsActive: true,
      IsStarred: false,
      IsLiked: isLiked ?? null,
      DislikeReason: dislikeReason || ''
    };

    const chatAnswer: ChatAnswerDocument = {
      UserId: this.userId || '',
      ChatId: chatId || '',
      Answer: answerString
    };

    const diagnosticPayload = this.prepareDiagnosticPayload();

    const request: SaveChatResponseRequest = {
      ChatHistory: chatHistory,
      ChatAnswer: chatAnswer,
      PythonPrompt: diagnosticPayload ? JSON.stringify(diagnosticPayload) : undefined,
      SelectedClient: this.selected_client || this.landingdata?.client_code || undefined,
      SelectedStudy: this.selected_study || this.landingdata?.study || undefined,
      InputQuery: questionText || undefined
    };
    this.apiService.saveChatHistory(request).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData && apiResponse.Data) {
          const messageId = apiResponse.Data;
          if (this.chatPreviewBlocks.length > 0) {
            const latestChat = this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1];
            if (!latestChat.messageId) {
              latestChat.messageId = messageId;
              this.selectedMessageId = messageId;
            }
          }
          this.getChatListData();
        }
      },
      error: (err) => {
      }
    });
  }

  prepareDiagnosticPayload(): any {
    try {
      const payload: any = {
        mcode: this.mcode,
        user_input: this.promptData?.user_input,
        isTotalBase: this.isTotalBase,
        isBrandAnalysis: this.isBrandAnalysis,
        entryPointData: this.dataArray || [],

        // Selection data
        Row: this.dataObject?.Row || [],
        Column: this.dataObject?.Column || [],
        Filter: this.dataObject?.Filter || [],
        RowNesting: this.dataObject?.RowNesting || [],
        ColNesting: this.dataObject?.ColNesting || [],

        // Configuration
        clientCode: this.landingdata?.client_code || this.selected_client,
        studyname: this.landingdata?.study || this.selected_study,
        significance: this.DefaultConfidenceLevel || 'None',
        confidenceLevel: this.DefaultConfidenceLevel || 'None',
        SelectedWeight: this.selectedWeight || 'weight',

        // Snapshot related
        Section: this.selectedSection || this.promptData?.data?.snapshot_result?.snapshot?.widget_output?.section || '',
        Snapshot_Name: this.Snapshotdataforexport?.snapshotName || this.promptData?.data?.snapshot_result?.snapshot?.widget_output?.snapshot_name || '',
        Snapshot_Type: this._configService.selectedSnapshotType || this.promptData?.data?.snapshot_result?.snapshot?.widget_output?.snapshot_type || '',
        Widget_Id: this.widget_Id || '',
        Widget_Name: this.widget_Name || '',
        ...(this.promptData || {})
      };
      return payload;
    } catch (error) {
      console.error('Error preparing diagnostic payload:', error);
      return this.promptData || {};
    }
  }

  getChatResponse(messageId: string, showSingleMessageOnly: boolean = false) {
    this._loaderService.showLoader();
    this.isNewChatStarted = false;
    this.abandoningSessionId = '';
    this.OutputData = [];
    this.CrossTabOutPutData = [];
    this.showSnapshot = false;
    this.displayTable = false;
    this.failedCase = false;
    this.isCreateBtnClick = false;
    this.insightsVal = '';
    this.insightsStreamingText = '';
    this.insightsStreamingPoints = [];
    this.isselectionsummarycollapse = false;
    this.isselectionsummarycollapse2 = false;
    this._configService.standardSnapOutputData = [];
    this.MainResult = undefined;
    this._configService.updateSignificanceValue('None');
    this._configService.updateConfedenceValue('None');
    this._configService.IndexSelected = false;
    this._configService.baseSelected = 'Total Base';
    this._configService.isTotalBase = true;
    const chat = this.allChatList.find(c => c.ChatHistory && c.ChatHistory.some(h => h.MessageId === messageId));

    if (chat) {

      const targetMessage = chat.ChatHistory?.find((h: any) => h.MessageId === messageId);
      if (targetMessage) {
      }
    }

    if (chat) {
      this.selectedChatId = chat.ChatId || null;
      this.selectedMessageId = messageId;
      this.guidChatId = chat.ChatId || '';
      this.newChatId = chat.ChatId || null;

      if (!showSingleMessageOnly) {
        this.chatPreviewBlocks = (chat.ChatHistory || []).map(h =>
          ChatHistoryHelper.createChatPreviewBlock(h, this.defaultQuestionAnswer)
        );
      }
    } else {
      this.selectedChatId = messageId;
      this.guidChatId = messageId;
    }

    // SESSION VALIDATION FOR OLD HISTORY
    if (this.guidChatId && this.validatedSessionId !== this.guidChatId) {
      this.isCacheGenerated = false; // Reset flag for the new (old) session
      this.getBearerToken().then(token => {
        this.apiService.accessCheck(
          this.selected_client || 'Demo',
          this.selected_study || 'brand-health-tracker',
          token,
          this.guidChatId || ''
        ).subscribe({
          next: (res: any) => {
            if (res && res.modules_access) {
              this.modulesAccess = res.modules_access;
              this.validatedSessionId = this.guidChatId;

              const activeModules: any = {};
              for (const [key, value] of Object.entries(this.modulesAccess)) {
                if ((value as any).has_access) {
                  activeModules[key] = value;
                }
              }

              this.apiService.generateRestrictedCache(
                this.selected_client || 'Demo',
                this.selected_study || 'brand-health-tracker',
                token,
                this.guidChatId,
                activeModules
              ).subscribe({
                next: () => {
                  this.isCacheGenerated = true;
                },
                error: (err) => {
                  console.error('[getChatResponse] ❌ Cache failed:', err);
                  this._loaderService.hideLoader();
                }
              });
            }
          },
          error: (err) => {
            console.error('[getChatResponse] ❌ Access check failed:', err);
            this._loaderService.hideLoader();
          }
        });
      });
    }

    this.isChatHistoryOpen = false;
    this.isQuestionBrowserOpen = false;
    this.inputValue = '';

    this.apiService.getChatResponse(messageId).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);

        if (apiResponse.HasValidData && apiResponse.Data) {
          let historyItem: any;
          const parsedData = JSON.parse(apiResponse.Data);

          if (Array.isArray(parsedData)) {
            historyItem = parsedData[0];
          } else {
            historyItem = parsedData;
          }


          let questionToUse = historyItem?.Question;

          if (!questionToUse) {
            const blockWithQuestion = this.chatPreviewBlocks.find(b => b.messageId === messageId);
            if (blockWithQuestion) {
              questionToUse = blockWithQuestion.question;
            }
          }

          if (questionToUse) {
          } else {
            console.warn('[getChatResponse API] ⚠️ No question text available for messageId:', messageId);
          }

          let answerData = historyItem?.Answer;
          if (typeof answerData === 'string') {
            try {
              answerData = JSON.parse(answerData);

              if (answerData.getSnapshotOutput) {
                try {
                  const snapshotStr = typeof answerData.getSnapshotOutput === 'string'
                    ? answerData.getSnapshotOutput
                    : JSON.stringify(answerData.getSnapshotOutput);
                  const snapshotParsed = JSON.parse(snapshotStr);
                  if (snapshotParsed && snapshotParsed.Data) {
                    const dataArray = JSON.parse(snapshotParsed.Data);
                    if (dataArray && dataArray.length > 0) {
                    }
                  }
                } catch (e) {
                  console.error('[getChatResponse API] Failed to parse snapshot output for logging:', e);
                }
              }
            } catch (e) {
              console.error('[getChatResponse API] Failed to parse answer data:', e);
            }
          }
          this.sendInputMessage(answerData, true);
        } else {
          console.warn('[getChatResponse API] No valid data returned for messageId:', messageId);
          this._loaderService.hideLoader();
        }
      },
      error: (err) => {
        this.chatHistory = [];
        this._loaderService.hideLoader();
      }
    });
  }

  toggleStarred(chat: { question: string, response: string, messageId?: string, isStarred?: boolean, isLiked?: boolean | null, dislikeReason?: string }) {
    console.log('[toggleStarred] 🌟 Attempting toggle for messageId:', chat.messageId, 'Current state:', chat.isStarred);
    if (!chat.messageId || !this.selectedChatId) {
      console.warn('[toggleStarred] ❌ Missing messageId or selectedChatId');
      this.showToast('Cannot star: Message ID is not available', 'error');
      return;
    }

    const newStarredState = !chat.isStarred;
    this.apiService.updateChatStarred(chat.messageId, newStarredState).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          console.log('[toggleStarred] ✅ API Success. New state:', newStarredState);
          chat.isStarred = newStarredState;
          this.showToast(newStarredState ? 'Message starred successfully' : 'Message unstarred successfully', 'success');

          if (!newStarredState) {
            const beforeCount = this.starredMessages.length;
            // Handle both MessageId and messageId casing for robustness
            this.starredMessages = this.starredMessages.filter(m => {
              const mId = (m.MessageId || (m as any).messageId || '').toString().toLowerCase();
              const targetId = (chat.messageId || '').toString().toLowerCase();
              return mId !== targetId;
            });
            console.log(`[toggleStarred] 🗑️ Optimistic remove: ${beforeCount} -> ${this.starredMessages.length}`);
            this.onStarredSearch();
          } else {
            console.log('[toggleStarred] 🔄 Refreshing saved list for new star');
            this.loadStarredMessages();
          }
        } else {
          this.showToast('Failed to update starred status', 'error');
        }
      },
      error: (err) => {
        this.showToast('Error while updating starred status', 'error');
      }
    });
  }

  onDeleteClick(chat: { question: string, response: string, messageId?: string, isStarred?: boolean, isLiked?: boolean | null, feedbackSaved?: boolean, showDislikeInput?: boolean, dislikeReason?: string, QuestionAnswer?: string }) {
    if (!chat.messageId) {
      this.showToast('Cannot delete: Message ID is not available', 'error');
      return;
    }

    if (!confirm('Are you sure you want to delete this message?')) {
      return;
    }

    const isDeletingSelectedMessage = chat.messageId === this.selectedMessageId;
    this.apiService.deleteChatMessage(chat.messageId).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          const index = this.chatPreviewBlocks.indexOf(chat);
          if (index > -1) {
            this.chatPreviewBlocks.splice(index, 1);
          }
          if (isDeletingSelectedMessage) {
            this.selectedMessageId = null;
            this.displayTable = false;
            this.showSnapshot = false;
            this.isCreateBtnClick = false;
            this.CrossTabOutPutData = [];
            this.OutputData = [];
            this.clearOutputDataObject();
            this.insightsVal = [];
            this.insightsStreamingText = '';
            this.insightsStreamingPoints = [];
            this.isInsightspopupOpen = false;
            this.failedCase = false;
            this.isVerticalGroupBarChartClick = false;
            this.isVerticalBarChartClick = false;
            this.isVerticalStackChartClick = false;
            this.isLineChartClick = false;

            if (this.chatPreviewBlocks.length === 0) {
              setTimeout(() => {
                this.navigateToLanding();
              }, 100);
            }
          }
          console.log('[onDeleteClick] ✅ API Success for messageId:', chat.messageId);
          this.showToast('Message deleted successfully', 'success');

          // [SYNC FIX] If it was starred, we should have also cleared that on server
          // but we do it optimistically here to match the dual-call strategy
          if (chat.isStarred && chat.messageId) {
            this.apiService.updateChatStarred(chat.messageId, false).subscribe();
          }

          // Optimistic local removal from saved list
          const beforeCount = this.starredMessages.length;
          this.starredMessages = this.starredMessages.filter(m => {
            const mId = (m.MessageId || (m as any).messageId || '').toString().toLowerCase();
            const targetId = (chat.messageId || '').toString().toLowerCase();
            return mId !== targetId;
          });
          console.log(`[onDeleteClick] 🗑️ Optimistic remove from saved: ${beforeCount} -> ${this.starredMessages.length}`);
          this.onStarredSearch();

          setTimeout(() => {
            console.log('[onDeleteClick] 🔄 Refreshing lists');
            this.getChatListData();
            this.loadStarredMessages(); // Still refresh from server as secondary measure
          }, 300);
        } else {
          this.showToast('Failed to delete message', 'error');
        }
      },
      error: (err) => {
        this.showToast('Error while deleting message', 'error');
      }
    });
  }

  onLikeClick(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showDislikeInput?: boolean; dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      this.showToast('Cannot save feedback: Message ID is not available', 'error');
      return;
    }

    chat.showDislikeInput = false;
    chat.dislikeReason = '';
    const newLikedState = chat.isLiked === true ? null : true;
    this.saveFeedback(chat, newLikedState, '');
  }

  onDislikeClick(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showDislikeInput?: boolean; dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      this.showToast('Cannot save feedback: Message ID is not available', 'error');
      return;
    }

    if (chat.isLiked === false) {
      chat.showDislikeInput = false;
      chat.dislikeReason = '';
      this.saveFeedback(chat, null, '');
    } else {
      chat.showDislikeInput = true;
      chat.dislikeReason = '';
    }
  }

  submitDislikeFeedback(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showDislikeInput?: boolean; dislikeReason?: string }) {
    if (!chat.messageId || !this.selectedChatId) {
      return;
    }

    const reason = chat.dislikeReason?.trim() || '';
    this.saveFeedback(chat, false, reason);
    chat.showDislikeInput = false;
  }

  cancelDislikeFeedback(chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showDislikeInput?: boolean; dislikeReason?: string }) {
    chat.showDislikeInput = false;
    chat.dislikeReason = '';
  }

  private saveFeedback(
    chat: { question: string; response: string; messageId?: string; isLiked?: boolean | null; feedbackSaved?: boolean; showDislikeInput?: boolean; dislikeReason?: string },
    isLiked: boolean | null,
    dislikeReason: string
  ) {

    if (!chat.messageId || !this.selectedChatId) {
      this.showToast('Cannot save feedback: Message ID is not available', 'error');
      return;
    }

    const previousIsLiked = chat.isLiked;
    const previousFeedbackSaved = chat.feedbackSaved;

    chat.isLiked = isLiked;
    chat.feedbackSaved = (isLiked === true || isLiked === false);

    const feedbackRequest = {
      MessageId: chat.messageId,
      IsLiked: isLiked,
      DislikeReason: dislikeReason || ''
    };

    this.apiService.saveChatFeedback(feedbackRequest).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          chat.dislikeReason = dislikeReason;

          // Update the history list in memory
          if (chat.messageId && this.selectedChatId) {
            const chatInList = this.allChatList.find(c => c.ChatId === this.selectedChatId);
            if (chatInList && chatInList.ChatHistory) {
              const msg = chatInList.ChatHistory.find(h => h.MessageId === chat.messageId);
              if (msg) {
                msg.IsLiked = isLiked;
                msg.DislikeReason = dislikeReason;
              }
            }
          }
        } else {
          // Revert on failure
          chat.isLiked = previousIsLiked;
          chat.feedbackSaved = previousFeedbackSaved;
          this.showToast('Failed to save feedback on server', 'error');
        }
      },
      error: (err) => {
        // Revert on error
        chat.isLiked = previousIsLiked;
        chat.feedbackSaved = previousFeedbackSaved;
        console.error('An error occurred while saving feedback:', err);
        this.showToast('Network error while saving feedback', 'error');
      }
    });
  }

  parseChatResponse(ChatResponse: any): {
    AgentPayload?: any;
    GetMcode?: any;
    getSnapshotConfiguration?: any;
    GetCustomSnapshotWidget?: any;
    GetQuery?: any;
    getSnapshotOutput?: any;
    getSnapshotLoadData?: any;
    getConfiguration?: any;
    getSnapshotInsights?: any;
    getSnapshotInsightsTrend?: any;
    getInsights?: any;
    getQnA?: any;
  } {
    return ChatHistoryHelper.parseChatResponse(ChatResponse);
  }

  pushChatResponseEntry(key: string, value: any) {
    const entry = ChatHistoryHelper.formatChatResponseEntry(key, value);
    this.chatResponse.push(entry);
  }

  excelexportClicked() {
    ExportHandlerHelper.excelexportClicked(this);
  }

  handleExcelExportClick() {
    ExportHandlerHelper.handleExcelExportClick(this);
  }

  editablePPTClicked(isTredendDataRequired: boolean = false) {
    ExportHandlerHelper.editablePPTClicked(this, isTredendDataRequired);
  }

  onNewChatClick(): void {
    this.abandoningSessionId = this.guidChatId;
    this.isNewChatStarted = true;
    this.guidChatId = '';
    this.validatedSessionId = null;
    this.selectedChatId = null;
    this.inputValue = '';
    this.chatPreviewBlocks = [];
    this.insightsVal = '';
    this.displayTable = false;
    this.showSnapshot = false;
    this.failedCase = false;
    this.isInsightspopupOpen = false;
    this.OutputdataObject.Row = [];
    this.OutputdataObject.Column = [];
    this.CrossTabOutPutData = [];
    this.askMeLanding = true;
  }

  async clearCache(): Promise<void> {
    try {
      await this.indexedDBService.clearClientStudyCache();
    } catch (error) {
      console.error('Error clearing cache:', error);
      this.showToast('Error clearing cache', 'error');
    }
  }

  async getCacheStats(): Promise<void> {
    try {
      const stats = await this.indexedDBService.getStats();
    } catch (error) {
    }
  }

  showToast(message: string, type: 'success' | 'error' | 'info' = 'success') {
    this.toastMessage = message;
    this.toastType = type;
    this.showToastNotification = true;

    setTimeout(() => {
      this.showToastNotification = false;
    }, 3000);
  }

  sendKeyQuestion(question: string): void {
    this.searchText = question;
    this.navigateToChat();
    this.onSendMessage();
  }

  getFirstTwoInsights(): any[] {
    if (!this.insightsVal || !Array.isArray(this.insightsVal)) {
      return [];
    }
    return this.insightsVal.slice(0, 2);
  }

  getFirstTwoInsightsAsPlainText(): string {
    const insights = this.getFirstTwoInsights();
    if (insights.length === 0) {
      return '';
    }

    return insights.map(insight => {
      let text = '';
      if (typeof insight === 'string') {
        text = insight;
      } else if (insight && typeof insight === 'object') {
        // Use extraction logic similar to formatInsightsIntoPoints
        text = insight.Value || (insight.insights && insight.insights.Value) || '';
        if (!text && Object.keys(insight).length > 0) {
          const firstValue = Object.values(insight)[0];
          text = typeof firstValue === 'string' ? firstValue : (typeof firstValue === 'object' && firstValue ? (firstValue as any).Value || '' : '');
        }
      }

      if (!text) return '';

      let cleaned = text;
      cleaned = cleaned.replace(/^[^:]+:\s*/, '');
      return cleaned.trim();
    }).filter(t => t).join(' ');
  }

  getCurrentQnAResponse(): string {
    if (this.chatPreviewBlocks.length === 0) {
      return '';
    }

    const targetChat = this.selectedMessageId
      ? this.chatPreviewBlocks.find(chat => chat.messageId === this.selectedMessageId)
      : this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1];

    const response = targetChat?.QuestionAnswer || '';

    // Fallback if QnA is not available but insights are
    if ((!response || response === 'No data Available') && this.insightsVal && Array.isArray(this.insightsVal) && this.insightsVal.length > 0) {
      return this.insightsVal.join('\n');
    }

    return response;
  }

  getPostStreamMessage(): string {
    switch (this.mcode) {
      case 1: return 'Plotting Snapshot Visualization';
      case 2: return 'Building Brand Analysis Table';
      case 3: return 'Generating Crosstab Table';
      default: return 'Finalizing data analysis';
    }
  }

  updateQuestionAnswerForSelectedMessage(questionAnswerText: string): void {
    if (this.chatPreviewBlocks.length === 0) {
      return;
    }

    const targetChat = this.selectedMessageId
      ? this.chatPreviewBlocks.find(chat => chat.messageId === this.selectedMessageId)
      : this.chatPreviewBlocks[this.chatPreviewBlocks.length - 1];

    if (targetChat) {
      targetChat.QuestionAnswer = questionAnswerText;
    }
  }

  // ── AI Loader helpers ────────────────────────────────────────────────────
  startAiLoader(): void {
    this.arktabaccess = true;
  }

  stopAiLoader(): void {
    this.arktabaccess = false;
  }

  /**
   * Helper to ensure Funnel charts (and potentially others) have correct decimal precision
   * requested by the business to resolve data discrepancies in conversion calculations.
   */
  getFormattedCustomProperties(props: any, chartType: string): any {
    const isTable = chartType && chartType.toLowerCase().includes('table');
    const isFunnel = chartType && chartType.toLowerCase().includes('funnel');

    // Base defaults for stability
    const baseDefaults: any = {
      hideNA: true,
      datalabelProperty: 'default',
      datalabelFormat: 'percentage',
      decimalRoundOff: isFunnel ? 2 : 0,
      borderStyle: '1',
      borderColor: '#CAC4C4',
      ColumnHeaderAlignment: 'center',
      dataLabelAlignment: 'center',
      CalculationLogic: 'None',
      enableDataBars: true,
      ColumnHeaderSorting: true
    };

    if (!props) return JSON.stringify(baseDefaults);

    let parsedProps: any;
    if (typeof props === 'string') {
      try {
        parsedProps = JSON.parse(props);
      } catch (e) {
        parsedProps = {};
      }
    } else {
      parsedProps = props;
    }

    if (!parsedProps || typeof parsedProps !== 'object') {
      parsedProps = {};
    }

    // Merge defaults into parsed props for any missing keys
    Object.keys(baseDefaults).forEach(key => {
      if (parsedProps[key] === undefined) {
        parsedProps[key] = baseDefaults[key];
      }
    });

    // Specific overrides
    if (isFunnel && (parsedProps.decimalRoundOff === undefined || parsedProps.decimalRoundOff === 0)) {
      parsedProps.decimalRoundOff = 2;
    }

    return JSON.stringify(parsedProps);
  }
} // end of ChatbotexpandComponent class
